"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * UniqKey.OrganizationApi.Mobile
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupsApiFp = exports.GroupsApiAxiosParamCreator = exports.GroupRestrictionsApi = exports.GroupRestrictionsApiFactory = exports.GroupRestrictionsApiFp = exports.GroupRestrictionsApiAxiosParamCreator = exports.EmployeeAccountsToGroupsApi = exports.EmployeeAccountsToGroupsApiFactory = exports.EmployeeAccountsToGroupsApiFp = exports.EmployeeAccountsToGroupsApiAxiosParamCreator = exports.EmployeeAccountsApi = exports.EmployeeAccountsApiFactory = exports.EmployeeAccountsApiFp = exports.EmployeeAccountsApiAxiosParamCreator = exports.DomainRulesApi = exports.DomainRulesApiFactory = exports.DomainRulesApiFp = exports.DomainRulesApiAxiosParamCreator = exports.DevicesApi = exports.DevicesApiFactory = exports.DevicesApiFp = exports.DevicesApiAxiosParamCreator = exports.DesktopApplicationsApi = exports.DesktopApplicationsApiFactory = exports.DesktopApplicationsApiFp = exports.DesktopApplicationsApiAxiosParamCreator = exports.CompanionApplicationApi = exports.CompanionApplicationApiFactory = exports.CompanionApplicationApiFp = exports.CompanionApplicationApiAxiosParamCreator = exports.ApplicationsApi = exports.ApplicationsApiFactory = exports.ApplicationsApiFp = exports.ApplicationsApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.TrustedActionType = exports.QueueEvent = exports.ProcessType = exports.Ownership = exports.ImportHistoryStatus = exports.EncryptionKeyType = exports.EmployeeAccountType = exports.EmployeeAccountStatus = exports.DeviceTypeName = exports.CompanionApplicationTypeName = exports.ClientType = exports.AuthenticationType = void 0;
exports.TrustedPortalApi = exports.TrustedPortalApiFactory = exports.TrustedPortalApiFp = exports.TrustedPortalApiAxiosParamCreator = exports.TrustedBrowserApi = exports.TrustedBrowserApiFactory = exports.TrustedBrowserApiFp = exports.TrustedBrowserApiAxiosParamCreator = exports.TrustedActionApi = exports.TrustedActionApiFactory = exports.TrustedActionApiFp = exports.TrustedActionApiAxiosParamCreator = exports.SupportedUILanguagesApi = exports.SupportedUILanguagesApiFactory = exports.SupportedUILanguagesApiFp = exports.SupportedUILanguagesApiAxiosParamCreator = exports.QueueApi = exports.QueueApiFactory = exports.QueueApiFp = exports.QueueApiAxiosParamCreator = exports.PrivateKeychainApi = exports.PrivateKeychainApiFactory = exports.PrivateKeychainApiFp = exports.PrivateKeychainApiAxiosParamCreator = exports.PasswordHashesApi = exports.PasswordHashesApiFactory = exports.PasswordHashesApiFp = exports.PasswordHashesApiAxiosParamCreator = exports.PairingCodesApi = exports.PairingCodesApiFactory = exports.PairingCodesApiFp = exports.PairingCodesApiAxiosParamCreator = exports.OrganizationSettingsApi = exports.OrganizationSettingsApiFactory = exports.OrganizationSettingsApiFp = exports.OrganizationSettingsApiAxiosParamCreator = exports.OrganizationApi = exports.OrganizationApiFactory = exports.OrganizationApiFp = exports.OrganizationApiAxiosParamCreator = exports.MigrationApi = exports.MigrationApiFactory = exports.MigrationApiFp = exports.MigrationApiAxiosParamCreator = exports.MasterPasswordResetRequestApi = exports.MasterPasswordResetRequestApiFactory = exports.MasterPasswordResetRequestApiFp = exports.MasterPasswordResetRequestApiAxiosParamCreator = exports.GroupsApi = exports.GroupsApiFactory = void 0;
exports.VaultsToGroupsApi = exports.VaultsToGroupsApiFactory = exports.VaultsToGroupsApiFp = exports.VaultsToGroupsApiAxiosParamCreator = exports.VaultsToEmployeeAccountsApi = exports.VaultsToEmployeeAccountsApiFactory = exports.VaultsToEmployeeAccountsApiFp = exports.VaultsToEmployeeAccountsApiAxiosParamCreator = exports.VaultsApi = exports.VaultsApiFactory = exports.VaultsApiFp = exports.VaultsApiAxiosParamCreator = exports.UserActivationCodesApi = exports.UserActivationCodesApiFactory = exports.UserActivationCodesApiFp = exports.UserActivationCodesApiAxiosParamCreator = exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.AuthenticationType = {
    Basic: 'Basic',
    Saml: 'SAML'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ClientType = {
    Extension: 'Extension',
    Desktop: 'Desktop'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CompanionApplicationTypeName = {
    BrowserExtension: 'BrowserExtension',
    WindowsLogin: 'WindowsLogin',
    WindowsDesktop: 'WindowsDesktop',
    OrganizationPortal: 'OrganizationPortal'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DeviceTypeName = {
    Default: 'Default',
    Secondary: 'Secondary'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EmployeeAccountStatus = {
    Unprocessed: 'Unprocessed',
    Staged: 'Staged',
    Invited: 'Invited',
    Active: 'Active',
    Archived: 'Archived',
    Migrated: 'Migrated',
    MigrationInvited: 'MigrationInvited',
    ExistingUnprocessed: 'ExistingUnprocessed'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EmployeeAccountType = {
    Employee: 'Employee',
    Admin: 'Admin',
    Supporter: 'Supporter',
    KeylessAdmin: 'KeylessAdmin'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EncryptionKeyType = {
    PairingKey: 'PairingKey',
    OrganizationKey: 'OrganizationKey'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ImportHistoryStatus = {
    New: 'New',
    InProgress: 'InProgress',
    Failed: 'Failed',
    Completed: 'Completed',
    Cancelled: 'Cancelled'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Ownership = {
    Groups: 'Groups',
    Employees: 'Employees',
    Unmanaged: 'Unmanaged'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProcessType = {
    Create: 'Create',
    Update: 'Update'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.QueueEvent = {
    VaultPasswordRequested: 'VaultPasswordRequested',
    ProcessNewEmployee: 'ProcessNewEmployee',
    VaultDeletionForGroupRequested: 'VaultDeletionForGroupRequested',
    VaultPasswordEditRequestedForEmployee: 'VaultPasswordEditRequestedForEmployee',
    VaultPasswordCreationForGroupRequested: 'VaultPasswordCreationForGroupRequested',
    VaultPasswordCreationForEmployeeRequested: 'VaultPasswordCreationForEmployeeRequested',
    VaultDeletionForEmployeeRequested: 'VaultDeletionForEmployeeRequested',
    PromoteAdmin: 'PromoteAdmin',
    RevokeAdmin: 'RevokeAdmin',
    ImportVault: 'ImportVault',
    VaultSharingToGroupRequested: 'VaultSharingToGroupRequested',
    VaultSharingToEmployeeAccountRequested: 'VaultSharingToEmployeeAccountRequested',
    LogoutDevice: 'LogoutDevice',
    CreateTrustedBrowserRequested: 'CreateTrustedBrowserRequested',
    ProcessInviteEmployee: 'ProcessInviteEmployee',
    ShareGroupSecretWithEmployeeAccount: 'ShareGroupSecretWithEmployeeAccount',
    MoveVaultBetweenGroups: 'MoveVaultBetweenGroups',
    MoveVaultBetweenEmployees: 'MoveVaultBetweenEmployees',
    MoveVaultFromEmployeeToGroup: 'MoveVaultFromEmployeeToGroup',
    AdminVaultPasswordCreationForGroupRequested: 'AdminVaultPasswordCreationForGroupRequested',
    AdminVaultPasswordCreationForEmployeeRequested: 'AdminVaultPasswordCreationForEmployeeRequested',
    AdminVaultSharingToGroupRequested: 'AdminVaultSharingToGroupRequested',
    AdminVaultSharingToEmployeeAccountRequested: 'AdminVaultSharingToEmployeeAccountRequested',
    VaultPasswordRequestedForGroup: 'VaultPasswordRequestedForGroup',
    GetVaultPasswordDetailsViaTrustedBrowserRequested: 'GetVaultPasswordDetailsViaTrustedBrowserRequested',
    AdminVaultSecureNoteCreationForGroupRequested: 'AdminVaultSecureNoteCreationForGroupRequested',
    AdminVaultSecureNoteCreationForEmployeeRequested: 'AdminVaultSecureNoteCreationForEmployeeRequested',
    VaultSecureNoteEditRequestedForEmployee: 'VaultSecureNoteEditRequestedForEmployee',
    VaultSecureNoteRequested: 'VaultSecureNoteRequested',
    VaultSecureNoteRequestedForGroup: 'VaultSecureNoteRequestedForGroup',
    VaultPasswordCreationRequested: 'VaultPasswordCreationRequested',
    GetVaultPasswordDetailsForGroupViaTrustedBrowserRequested: 'GetVaultPasswordDetailsForGroupViaTrustedBrowserRequested',
    VaultSecureNoteCreationForGroupRequested: 'VaultSecureNoteCreationForGroupRequested',
    VaultSecureNoteCreationForEmployeeRequested: 'VaultSecureNoteCreationForEmployeeRequested',
    VaultSecureNoteEditRequestedForGroup: 'VaultSecureNoteEditRequestedForGroup',
    VaultPasswordEditRequestedForGroup: 'VaultPasswordEditRequestedForGroup',
    EmployeePromotedToAdmin: 'EmployeePromotedToAdmin',
    EmployeeDemotedFromAdmin: 'EmployeeDemotedFromAdmin',
    ApproveMasterPasswordResetRequest: 'ApproveMasterPasswordResetRequest',
    VaultCreditCardCreationForGroupRequested: 'VaultCreditCardCreationForGroupRequested',
    VaultCreditCardCreationForEmployeeRequested: 'VaultCreditCardCreationForEmployeeRequested',
    VaultCreditCardRequestedForEmployee: 'VaultCreditCardRequestedForEmployee',
    VaultCreditCardRequestedForGroup: 'VaultCreditCardRequestedForGroup',
    VaultCreditCardEditRequestedForEmployee: 'VaultCreditCardEditRequestedForEmployee',
    VaultCreditCardEditRequestedForGroup: 'VaultCreditCardEditRequestedForGroup',
    AdminVaultCreditCardCreationForGroupRequested: 'AdminVaultCreditCardCreationForGroupRequested',
    AdminVaultCreditCardCreationForEmployeeRequested: 'AdminVaultCreditCardCreationForEmployeeRequested',
    RevokeSharedVault: 'RevokeSharedVault',
    RevokeVaultSharing: 'RevokeVaultSharing',
    VaultRemoved: 'VaultRemoved',
    OrganizationEntriesChanged: 'OrganizationEntriesChanged',
    MoveVaultToPrivateKeychain: 'MoveVaultToPrivateKeychain',
    MoveVaultToEmployeeOrganizationKeychain: 'MoveVaultToEmployeeOrganizationKeychain',
    MoveVaultToGroupOrganizationKeychain: 'MoveVaultToGroupOrganizationKeychain',
    DeletePrivateKeychainVault: 'DeletePrivateKeychainVault',
    ExportVaultPassword: 'ExportVaultPassword',
    ProcessFirstAdminAsExistingUser: 'ProcessFirstAdminAsExistingUser',
    ProcessEmployeeAsExistingUser: 'ProcessEmployeeAsExistingUser',
    VaultSharingExpired: 'VaultSharingExpired',
    TrustedBrowserExpired: 'TrustedBrowserExpired',
    TrustedPortalRequested: 'TrustedPortalRequested',
    CreateTrustedBrowserRequestedV2: 'CreateTrustedBrowserRequestedV2',
    GetVaultPasswordDetailsViaTrustedBrowserRequestedV2: 'GetVaultPasswordDetailsViaTrustedBrowserRequestedV2',
    GetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedV2: 'GetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedV2',
    ProcessMigratedEmployee: 'ProcessMigratedEmployee',
    CreateTrustedBrowserRequestedV3: 'CreateTrustedBrowserRequestedV3',
    ImportVaultV2: 'ImportVaultV2',
    ExportVaultPasswordV2: 'ExportVaultPasswordV2',
    GetVaultPasswordDetailsViaTrustedBrowserRequestedV3: 'GetVaultPasswordDetailsViaTrustedBrowserRequestedV3',
    GetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedV3: 'GetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedV3',
    CheckGeolocationRestrictions: 'CheckGeolocationRestrictions',
    VaultSecureNoteCreationRequested: 'VaultSecureNoteCreationRequested',
    VaultCreditCardCreationRequested: 'VaultCreditCardCreationRequested',
    BulkDeleteVaultsRequested: 'BulkDeleteVaultsRequested',
    PartnerSupporterRequestApproval: 'PartnerSupporterRequestApproval',
    MoveVaultToGroup: 'MoveVaultToGroup',
    FixEmployeePrivateKeys: 'FixEmployeePrivateKeys'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TrustedActionType = {
    TrustedBrowser: 'TrustedBrowser',
    TrustedPortal: 'TrustedPortal'
};
/**
 * AdminApi - axios parameter creator
 * @export
 */
var AdminApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminManagedCorruptedVaultsGet: function (page_1, pageLength_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1], args_1, true), void 0, function (page, pageLength, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1AdminManagedCorruptedVaultsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1AdminManagedCorruptedVaultsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/Admin/ManagedCorruptedVaults";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPrivateKeysBackupsGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Admin/PrivateKeysBackups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ReportVaultFixFailRequest} [reportVaultFixFailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReportVaultFixFailPut: function (reportVaultFixFailRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([reportVaultFixFailRequest_1], args_1, true), void 0, function (reportVaultFixFailRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Admin/ReportVaultFixFail";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportVaultFixFailRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUnmanagedUnfixedVaultsGet: function (page_1, pageLength_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1], args_1, true), void 0, function (page, pageLength, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1AdminUnmanagedUnfixedVaultsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1AdminUnmanagedUnfixedVaultsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/Admin/UnmanagedUnfixedVaults";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateVaultSymmetricKeyBackupRequest} [updateVaultSymmetricKeyBackupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUpdateVaultSymmetricKeyBackupPut: function (updateVaultSymmetricKeyBackupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updateVaultSymmetricKeyBackupRequest_1], args_1, true), void 0, function (updateVaultSymmetricKeyBackupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Admin/UpdateVaultSymmetricKeyBackup";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateVaultSymmetricKeyBackupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AdminApiAxiosParamCreator = AdminApiAxiosParamCreator;
/**
 * AdminApi - functional programming interface
 * @export
 */
var AdminApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AdminApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminManagedCorruptedVaultsGet: function (page, pageLength, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1AdminManagedCorruptedVaultsGet(page, pageLength, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPrivateKeysBackupsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1AdminPrivateKeysBackupsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ReportVaultFixFailRequest} [reportVaultFixFailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReportVaultFixFailPut: function (reportVaultFixFailRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1AdminReportVaultFixFailPut(reportVaultFixFailRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUnmanagedUnfixedVaultsGet: function (page, pageLength, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1AdminUnmanagedUnfixedVaultsGet(page, pageLength, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateVaultSymmetricKeyBackupRequest} [updateVaultSymmetricKeyBackupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUpdateVaultSymmetricKeyBackupPut: function (updateVaultSymmetricKeyBackupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1AdminUpdateVaultSymmetricKeyBackupPut(updateVaultSymmetricKeyBackupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AdminApiFp = AdminApiFp;
/**
 * AdminApi - factory interface
 * @export
 */
var AdminApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AdminApiFp)(configuration);
    return {
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminManagedCorruptedVaultsGet: function (page, pageLength, options) {
            return localVarFp.apiV1AdminManagedCorruptedVaultsGet(page, pageLength, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPrivateKeysBackupsGet: function (options) {
            return localVarFp.apiV1AdminPrivateKeysBackupsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ReportVaultFixFailRequest} [reportVaultFixFailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminReportVaultFixFailPut: function (reportVaultFixFailRequest, options) {
            return localVarFp.apiV1AdminReportVaultFixFailPut(reportVaultFixFailRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUnmanagedUnfixedVaultsGet: function (page, pageLength, options) {
            return localVarFp.apiV1AdminUnmanagedUnfixedVaultsGet(page, pageLength, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UpdateVaultSymmetricKeyBackupRequest} [updateVaultSymmetricKeyBackupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminUpdateVaultSymmetricKeyBackupPut: function (updateVaultSymmetricKeyBackupRequest, options) {
            return localVarFp.apiV1AdminUpdateVaultSymmetricKeyBackupPut(updateVaultSymmetricKeyBackupRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AdminApiFactory = AdminApiFactory;
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
var AdminApi = /** @class */ (function (_super) {
    __extends(AdminApi, _super);
    function AdminApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.apiV1AdminManagedCorruptedVaultsGet = function (page, pageLength, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).apiV1AdminManagedCorruptedVaultsGet(page, pageLength, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.apiV1AdminPrivateKeysBackupsGet = function (options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).apiV1AdminPrivateKeysBackupsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ReportVaultFixFailRequest} [reportVaultFixFailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.apiV1AdminReportVaultFixFailPut = function (reportVaultFixFailRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).apiV1AdminReportVaultFixFailPut(reportVaultFixFailRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.apiV1AdminUnmanagedUnfixedVaultsGet = function (page, pageLength, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).apiV1AdminUnmanagedUnfixedVaultsGet(page, pageLength, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UpdateVaultSymmetricKeyBackupRequest} [updateVaultSymmetricKeyBackupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.apiV1AdminUpdateVaultSymmetricKeyBackupPut = function (updateVaultSymmetricKeyBackupRequest, options) {
        var _this = this;
        return (0, exports.AdminApiFp)(this.configuration).apiV1AdminUpdateVaultSymmetricKeyBackupPut(updateVaultSymmetricKeyBackupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AdminApi;
}(base_1.BaseAPI));
exports.AdminApi = AdminApi;
/**
 * ApplicationsApi - axios parameter creator
 * @export
 */
var ApplicationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGet: function (page_1, pageLength_1, searchQuery_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, searchQuery_1], args_1, true), void 0, function (page, pageLength, searchQuery, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/Applications";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet: function (applicationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([applicationId_1], args_1, true), void 0, function (applicationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'applicationId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet', 'applicationId', applicationId);
                            localVarPath = "/api/v1/Applications/GetDomainRulesAndDesktopApplicationsByApplicationId/{applicationId}"
                                .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsUrlGet: function (url_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([url_1], args_1, true), void 0, function (url, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'url' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsUrlGet', 'url', url);
                            localVarPath = "/api/v1/Applications/{url}"
                                .replace("{".concat("url", "}"), encodeURIComponent(String(url)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ApplicationsApiAxiosParamCreator = ApplicationsApiAxiosParamCreator;
/**
 * ApplicationsApi - functional programming interface
 * @export
 */
var ApplicationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ApplicationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGet: function (page, pageLength, searchQuery, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1ApplicationsGet(page, pageLength, searchQuery, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet: function (applicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet(applicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsUrlGet: function (url, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1ApplicationsUrlGet(url, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ApplicationsApiFp = ApplicationsApiFp;
/**
 * ApplicationsApi - factory interface
 * @export
 */
var ApplicationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ApplicationsApiFp)(configuration);
    return {
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGet: function (page, pageLength, searchQuery, options) {
            return localVarFp.apiV1ApplicationsGet(page, pageLength, searchQuery, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet: function (applicationId, options) {
            return localVarFp.apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet(applicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsUrlGet: function (url, options) {
            return localVarFp.apiV1ApplicationsUrlGet(url, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ApplicationsApiFactory = ApplicationsApiFactory;
/**
 * ApplicationsApi - object-oriented interface
 * @export
 * @class ApplicationsApi
 * @extends {BaseAPI}
 */
var ApplicationsApi = /** @class */ (function (_super) {
    __extends(ApplicationsApi, _super);
    function ApplicationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} [searchQuery]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.apiV1ApplicationsGet = function (page, pageLength, searchQuery, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).apiV1ApplicationsGet(page, pageLength, searchQuery, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} applicationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet = function (applicationId, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet(applicationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.apiV1ApplicationsUrlGet = function (url, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).apiV1ApplicationsUrlGet(url, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApplicationsApi;
}(base_1.BaseAPI));
exports.ApplicationsApi = ApplicationsApi;
/**
 * CompanionApplicationApi - axios parameter creator
 * @export
 */
var CompanionApplicationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompanionApplicationCompanionApplicationIdDelete: function (companionApplicationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([companionApplicationId_1], args_1, true), void 0, function (companionApplicationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companionApplicationId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1CompanionApplicationCompanionApplicationIdDelete', 'companionApplicationId', companionApplicationId);
                            localVarPath = "/api/v1/CompanionApplication/{companionApplicationId}"
                                .replace("{".concat("companionApplicationId", "}"), encodeURIComponent(String(companionApplicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompanionApplicationGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/CompanionApplication";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {PairCompanionApplicationRequest} [pairCompanionApplicationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompanionApplicationPairPost: function (pairCompanionApplicationRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([pairCompanionApplicationRequest_1], args_1, true), void 0, function (pairCompanionApplicationRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/CompanionApplication/Pair";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pairCompanionApplicationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {PairCompanionApplicationRequestV2} [pairCompanionApplicationRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CompanionApplicationPairPost: function (pairCompanionApplicationRequestV2_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([pairCompanionApplicationRequestV2_1], args_1, true), void 0, function (pairCompanionApplicationRequestV2, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v2/CompanionApplication/Pair";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pairCompanionApplicationRequestV2, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CompanionApplicationApiAxiosParamCreator = CompanionApplicationApiAxiosParamCreator;
/**
 * CompanionApplicationApi - functional programming interface
 * @export
 */
var CompanionApplicationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CompanionApplicationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompanionApplicationCompanionApplicationIdDelete: function (companionApplicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CompanionApplicationCompanionApplicationIdDelete(companionApplicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompanionApplicationGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CompanionApplicationGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {PairCompanionApplicationRequest} [pairCompanionApplicationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompanionApplicationPairPost: function (pairCompanionApplicationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CompanionApplicationPairPost(pairCompanionApplicationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {PairCompanionApplicationRequestV2} [pairCompanionApplicationRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CompanionApplicationPairPost: function (pairCompanionApplicationRequestV2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2CompanionApplicationPairPost(pairCompanionApplicationRequestV2, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CompanionApplicationApiFp = CompanionApplicationApiFp;
/**
 * CompanionApplicationApi - factory interface
 * @export
 */
var CompanionApplicationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CompanionApplicationApiFp)(configuration);
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompanionApplicationCompanionApplicationIdDelete: function (companionApplicationId, options) {
            return localVarFp.apiV1CompanionApplicationCompanionApplicationIdDelete(companionApplicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompanionApplicationGet: function (options) {
            return localVarFp.apiV1CompanionApplicationGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {PairCompanionApplicationRequest} [pairCompanionApplicationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompanionApplicationPairPost: function (pairCompanionApplicationRequest, options) {
            return localVarFp.apiV1CompanionApplicationPairPost(pairCompanionApplicationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {PairCompanionApplicationRequestV2} [pairCompanionApplicationRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CompanionApplicationPairPost: function (pairCompanionApplicationRequestV2, options) {
            return localVarFp.apiV2CompanionApplicationPairPost(pairCompanionApplicationRequestV2, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CompanionApplicationApiFactory = CompanionApplicationApiFactory;
/**
 * CompanionApplicationApi - object-oriented interface
 * @export
 * @class CompanionApplicationApi
 * @extends {BaseAPI}
 */
var CompanionApplicationApi = /** @class */ (function (_super) {
    __extends(CompanionApplicationApi, _super);
    function CompanionApplicationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} companionApplicationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanionApplicationApi
     */
    CompanionApplicationApi.prototype.apiV1CompanionApplicationCompanionApplicationIdDelete = function (companionApplicationId, options) {
        var _this = this;
        return (0, exports.CompanionApplicationApiFp)(this.configuration).apiV1CompanionApplicationCompanionApplicationIdDelete(companionApplicationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanionApplicationApi
     */
    CompanionApplicationApi.prototype.apiV1CompanionApplicationGet = function (options) {
        var _this = this;
        return (0, exports.CompanionApplicationApiFp)(this.configuration).apiV1CompanionApplicationGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PairCompanionApplicationRequest} [pairCompanionApplicationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanionApplicationApi
     */
    CompanionApplicationApi.prototype.apiV1CompanionApplicationPairPost = function (pairCompanionApplicationRequest, options) {
        var _this = this;
        return (0, exports.CompanionApplicationApiFp)(this.configuration).apiV1CompanionApplicationPairPost(pairCompanionApplicationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PairCompanionApplicationRequestV2} [pairCompanionApplicationRequestV2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanionApplicationApi
     */
    CompanionApplicationApi.prototype.apiV2CompanionApplicationPairPost = function (pairCompanionApplicationRequestV2, options) {
        var _this = this;
        return (0, exports.CompanionApplicationApiFp)(this.configuration).apiV2CompanionApplicationPairPost(pairCompanionApplicationRequestV2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CompanionApplicationApi;
}(base_1.BaseAPI));
exports.CompanionApplicationApi = CompanionApplicationApi;
/**
 * DesktopApplicationsApi - axios parameter creator
 * @export
 */
var DesktopApplicationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [desktopAppName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DesktopApplicationsSearchByDesktopAppNameGet: function (desktopAppName_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([desktopAppName_1], args_1, true), void 0, function (desktopAppName, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/DesktopApplications/SearchByDesktopAppName";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (desktopAppName !== undefined) {
                                localVarQueryParameter['DesktopAppName'] = desktopAppName;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DesktopApplicationsApiAxiosParamCreator = DesktopApplicationsApiAxiosParamCreator;
/**
 * DesktopApplicationsApi - functional programming interface
 * @export
 */
var DesktopApplicationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DesktopApplicationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [desktopAppName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DesktopApplicationsSearchByDesktopAppNameGet: function (desktopAppName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DesktopApplicationsSearchByDesktopAppNameGet(desktopAppName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DesktopApplicationsApiFp = DesktopApplicationsApiFp;
/**
 * DesktopApplicationsApi - factory interface
 * @export
 */
var DesktopApplicationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DesktopApplicationsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [desktopAppName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DesktopApplicationsSearchByDesktopAppNameGet: function (desktopAppName, options) {
            return localVarFp.apiV1DesktopApplicationsSearchByDesktopAppNameGet(desktopAppName, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DesktopApplicationsApiFactory = DesktopApplicationsApiFactory;
/**
 * DesktopApplicationsApi - object-oriented interface
 * @export
 * @class DesktopApplicationsApi
 * @extends {BaseAPI}
 */
var DesktopApplicationsApi = /** @class */ (function (_super) {
    __extends(DesktopApplicationsApi, _super);
    function DesktopApplicationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [desktopAppName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesktopApplicationsApi
     */
    DesktopApplicationsApi.prototype.apiV1DesktopApplicationsSearchByDesktopAppNameGet = function (desktopAppName, options) {
        var _this = this;
        return (0, exports.DesktopApplicationsApiFp)(this.configuration).apiV1DesktopApplicationsSearchByDesktopAppNameGet(desktopAppName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DesktopApplicationsApi;
}(base_1.BaseAPI));
exports.DesktopApplicationsApi = DesktopApplicationsApi;
/**
 * DevicesApi - axios parameter creator
 * @export
 */
var DevicesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {CreateSecondaryDeviceRequest} [createSecondaryDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesCreateSecondaryDevicePost: function (createSecondaryDeviceRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createSecondaryDeviceRequest_1], args_1, true), void 0, function (createSecondaryDeviceRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Devices/CreateSecondaryDevice";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSecondaryDeviceRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesDeviceIdPatch: function (deviceId_1, operation_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deviceId_1, operation_1], args_1, true), void 0, function (deviceId, operation, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'deviceId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1DevicesDeviceIdPatch', 'deviceId', deviceId);
                            localVarPath = "/api/v1/Devices/{deviceId}"
                                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(operation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesGetSecondaryDevicesGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Devices/GetSecondaryDevices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesLogoutDeviceIdPost: function (deviceId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deviceId_1], args_1, true), void 0, function (deviceId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'deviceId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1DevicesLogoutDeviceIdPost', 'deviceId', deviceId);
                            localVarPath = "/api/v1/Devices/Logout/{deviceId}"
                                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesLogoutSecondaryDeviceDeviceIdPost: function (deviceId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deviceId_1], args_1, true), void 0, function (deviceId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'deviceId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1DevicesLogoutSecondaryDeviceDeviceIdPost', 'deviceId', deviceId);
                            localVarPath = "/api/v1/Devices/LogoutSecondaryDevice/{deviceId}"
                                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateDeviceRequest} [createDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesPost: function (createDeviceRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createDeviceRequest_1], args_1, true), void 0, function (createDeviceRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Devices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createDeviceRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesUnpairSecondaryDeviceDeviceIdPost: function (deviceId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deviceId_1], args_1, true), void 0, function (deviceId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'deviceId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1DevicesUnpairSecondaryDeviceDeviceIdPost', 'deviceId', deviceId);
                            localVarPath = "/api/v1/Devices/UnpairSecondaryDevice/{deviceId}"
                                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DevicesApiAxiosParamCreator = DevicesApiAxiosParamCreator;
/**
 * DevicesApi - functional programming interface
 * @export
 */
var DevicesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DevicesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {CreateSecondaryDeviceRequest} [createSecondaryDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesCreateSecondaryDevicePost: function (createSecondaryDeviceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DevicesCreateSecondaryDevicePost(createSecondaryDeviceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesDeviceIdPatch: function (deviceId, operation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DevicesDeviceIdPatch(deviceId, operation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesGetSecondaryDevicesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DevicesGetSecondaryDevicesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesLogoutDeviceIdPost: function (deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DevicesLogoutDeviceIdPost(deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesLogoutSecondaryDeviceDeviceIdPost: function (deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DevicesLogoutSecondaryDeviceDeviceIdPost(deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateDeviceRequest} [createDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesPost: function (createDeviceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DevicesPost(createDeviceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesUnpairSecondaryDeviceDeviceIdPost: function (deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DevicesUnpairSecondaryDeviceDeviceIdPost(deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DevicesApiFp = DevicesApiFp;
/**
 * DevicesApi - factory interface
 * @export
 */
var DevicesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DevicesApiFp)(configuration);
    return {
        /**
         *
         * @param {CreateSecondaryDeviceRequest} [createSecondaryDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesCreateSecondaryDevicePost: function (createSecondaryDeviceRequest, options) {
            return localVarFp.apiV1DevicesCreateSecondaryDevicePost(createSecondaryDeviceRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesDeviceIdPatch: function (deviceId, operation, options) {
            return localVarFp.apiV1DevicesDeviceIdPatch(deviceId, operation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesGetSecondaryDevicesGet: function (options) {
            return localVarFp.apiV1DevicesGetSecondaryDevicesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesLogoutDeviceIdPost: function (deviceId, options) {
            return localVarFp.apiV1DevicesLogoutDeviceIdPost(deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesLogoutSecondaryDeviceDeviceIdPost: function (deviceId, options) {
            return localVarFp.apiV1DevicesLogoutSecondaryDeviceDeviceIdPost(deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateDeviceRequest} [createDeviceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesPost: function (createDeviceRequest, options) {
            return localVarFp.apiV1DevicesPost(createDeviceRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DevicesUnpairSecondaryDeviceDeviceIdPost: function (deviceId, options) {
            return localVarFp.apiV1DevicesUnpairSecondaryDeviceDeviceIdPost(deviceId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DevicesApiFactory = DevicesApiFactory;
/**
 * DevicesApi - object-oriented interface
 * @export
 * @class DevicesApi
 * @extends {BaseAPI}
 */
var DevicesApi = /** @class */ (function (_super) {
    __extends(DevicesApi, _super);
    function DevicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {CreateSecondaryDeviceRequest} [createSecondaryDeviceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.apiV1DevicesCreateSecondaryDevicePost = function (createSecondaryDeviceRequest, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).apiV1DevicesCreateSecondaryDevicePost(createSecondaryDeviceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceId
     * @param {Array<Operation>} [operation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.apiV1DevicesDeviceIdPatch = function (deviceId, operation, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).apiV1DevicesDeviceIdPatch(deviceId, operation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.apiV1DevicesGetSecondaryDevicesGet = function (options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).apiV1DevicesGetSecondaryDevicesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.apiV1DevicesLogoutDeviceIdPost = function (deviceId, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).apiV1DevicesLogoutDeviceIdPost(deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.apiV1DevicesLogoutSecondaryDeviceDeviceIdPost = function (deviceId, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).apiV1DevicesLogoutSecondaryDeviceDeviceIdPost(deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateDeviceRequest} [createDeviceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.apiV1DevicesPost = function (createDeviceRequest, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).apiV1DevicesPost(createDeviceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} deviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.apiV1DevicesUnpairSecondaryDeviceDeviceIdPost = function (deviceId, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).apiV1DevicesUnpairSecondaryDeviceDeviceIdPost(deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DevicesApi;
}(base_1.BaseAPI));
exports.DevicesApi = DevicesApi;
/**
 * DomainRulesApi - axios parameter creator
 * @export
 */
var DomainRulesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DomainRulesSearchByUrlGet: function (url_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([url_1], args_1, true), void 0, function (url, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/DomainRules/SearchByUrl";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (url !== undefined) {
                                localVarQueryParameter['url'] = url;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DomainRulesApiAxiosParamCreator = DomainRulesApiAxiosParamCreator;
/**
 * DomainRulesApi - functional programming interface
 * @export
 */
var DomainRulesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DomainRulesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DomainRulesSearchByUrlGet: function (url, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DomainRulesSearchByUrlGet(url, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DomainRulesApiFp = DomainRulesApiFp;
/**
 * DomainRulesApi - factory interface
 * @export
 */
var DomainRulesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DomainRulesApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DomainRulesSearchByUrlGet: function (url, options) {
            return localVarFp.apiV1DomainRulesSearchByUrlGet(url, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DomainRulesApiFactory = DomainRulesApiFactory;
/**
 * DomainRulesApi - object-oriented interface
 * @export
 * @class DomainRulesApi
 * @extends {BaseAPI}
 */
var DomainRulesApi = /** @class */ (function (_super) {
    __extends(DomainRulesApi, _super);
    function DomainRulesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [url]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainRulesApi
     */
    DomainRulesApi.prototype.apiV1DomainRulesSearchByUrlGet = function (url, options) {
        var _this = this;
        return (0, exports.DomainRulesApiFp)(this.configuration).apiV1DomainRulesSearchByUrlGet(url, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DomainRulesApi;
}(base_1.BaseAPI));
exports.DomainRulesApi = DomainRulesApi;
/**
 * EmployeeAccountsApi - axios parameter creator
 * @export
 */
var EmployeeAccountsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} employeeAccountId
         * @param {CreateBackupRequest} [createBackupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsCreateBackupEmployeeAccountIdPost: function (employeeAccountId_1, createBackupRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1, createBackupRequest_1], args_1, true), void 0, function (employeeAccountId, createBackupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'employeeAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsCreateBackupEmployeeAccountIdPost', 'employeeAccountId', employeeAccountId);
                            localVarPath = "/api/v1/EmployeeAccounts/CreateBackup/{employeeAccountId}"
                                .replace("{".concat("employeeAccountId", "}"), encodeURIComponent(String(employeeAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createBackupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetCurrentUserGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/GetCurrentUser";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [searchString]
         * @param {string} [vaultId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetEmployeesByEmailSearchGet: function (searchString_1, vaultId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([searchString_1, vaultId_1], args_1, true), void 0, function (searchString, vaultId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/GetEmployeesByEmailSearch";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (searchString !== undefined) {
                                localVarQueryParameter['SearchString'] = searchString;
                            }
                            if (vaultId !== undefined) {
                                localVarQueryParameter['VaultId'] = vaultId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [vaultId]
         * @param {boolean} [isPending]
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetEmployeesVaultIsSharedWithGet: function (vaultId_1, isPending_1, searchString_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1, isPending_1, searchString_1], args_1, true), void 0, function (vaultId, isPending, searchString, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/GetEmployeesVaultIsSharedWith";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (vaultId !== undefined) {
                                localVarQueryParameter['VaultId'] = vaultId;
                            }
                            if (isPending !== undefined) {
                                localVarQueryParameter['IsPending'] = isPending;
                            }
                            if (searchString !== undefined) {
                                localVarQueryParameter['SearchString'] = searchString;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {boolean} [isPending]
         * @param {string} [vaultId]
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetEmployeesWhoSharedVaultsGet: function (isPending_1, vaultId_1, searchString_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([isPending_1, vaultId_1, searchString_1], args_1, true), void 0, function (isPending, vaultId, searchString, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/GetEmployeesWhoSharedVaults";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (isPending !== undefined) {
                                localVarQueryParameter['IsPending'] = isPending;
                            }
                            if (vaultId !== undefined) {
                                localVarQueryParameter['VaultId'] = vaultId;
                            }
                            if (searchString !== undefined) {
                                localVarQueryParameter['SearchString'] = searchString;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetJwksGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/GetJwks";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet: function (employeeAccountId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1], args_1, true), void 0, function (employeeAccountId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'employeeAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet', 'employeeAccountId', employeeAccountId);
                            localVarPath = "/api/v1/EmployeeAccounts/GetMasterPasswordBackup/{employeeAccountId}"
                                .replace("{".concat("employeeAccountId", "}"), encodeURIComponent(String(employeeAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetMasterPasswordBackupForCurrentEmployeeGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/GetMasterPasswordBackupForCurrentEmployee";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetPrivateBackupKeyEmployeeAccountIdGet: function (employeeAccountId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1], args_1, true), void 0, function (employeeAccountId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'employeeAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetPrivateBackupKeyEmployeeAccountIdGet', 'employeeAccountId', employeeAccountId);
                            localVarPath = "/api/v1/EmployeeAccounts/GetPrivateBackupKey/{employeeAccountId}"
                                .replace("{".concat("employeeAccountId", "}"), encodeURIComponent(String(employeeAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetPublicKeyEmployeeAccountIdGet: function (employeeAccountId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1], args_1, true), void 0, function (employeeAccountId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'employeeAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetPublicKeyEmployeeAccountIdGet', 'employeeAccountId', employeeAccountId);
                            localVarPath = "/api/v1/EmployeeAccounts/GetPublicKey/{employeeAccountId}"
                                .replace("{".concat("employeeAccountId", "}"), encodeURIComponent(String(employeeAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {LoginStepOneRequest} [loginStepOneRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsLoginStepOnePost: function (loginStepOneRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([loginStepOneRequest_1], args_1, true), void 0, function (loginStepOneRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/LoginStepOne";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loginStepOneRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {LoginStepTwoRequest} [loginStepTwoRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsLoginStepTwoPost: function (loginStepTwoRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([loginStepTwoRequest_1], args_1, true), void 0, function (loginStepTwoRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/LoginStepTwo";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loginStepTwoRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsMeGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/Me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsMeKeyPairGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/Me/KeyPair";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsPatchCurrentUserPatch: function (operation_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([operation_1], args_1, true), void 0, function (operation, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/PatchCurrentUser";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(operation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {PrivateBackupUpdateRequest} [privateBackupUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsPrivateBackupUpdatePut: function (privateBackupUpdateRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([privateBackupUpdateRequest_1], args_1, true), void 0, function (privateBackupUpdateRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/PrivateBackupUpdate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(privateBackupUpdateRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RefreshTokensRequest} [refreshTokensRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRefreshTokensPost: function (refreshTokensRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([refreshTokensRequest_1], args_1, true), void 0, function (refreshTokensRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/RefreshTokens";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refreshTokensRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<RegisterEmployeeAccountRequest>} [registerEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRegisterBulkPost: function (registerEmployeeAccountRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([registerEmployeeAccountRequest_1], args_1, true), void 0, function (registerEmployeeAccountRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/RegisterBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(registerEmployeeAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RegisterEmployeeAccountRequest} [registerEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRegisterPost: function (registerEmployeeAccountRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([registerEmployeeAccountRequest_1], args_1, true), void 0, function (registerEmployeeAccountRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/Register";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(registerEmployeeAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {SavePrivateKeyRequest} [savePrivateKeyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsSavePrivateKeyEmployeeAccountIdPost: function (employeeAccountId_1, savePrivateKeyRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1, savePrivateKeyRequest_1], args_1, true), void 0, function (employeeAccountId, savePrivateKeyRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'employeeAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsSavePrivateKeyEmployeeAccountIdPost', 'employeeAccountId', employeeAccountId);
                            localVarPath = "/api/v1/EmployeeAccounts/SavePrivateKey/{employeeAccountId}"
                                .replace("{".concat("employeeAccountId", "}"), encodeURIComponent(String(employeeAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(savePrivateKeyRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsSendTestSilentPushGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/SendTestSilentPush";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet: function (employeeAccountId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1], args_1, true), void 0, function (employeeAccountId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'employeeAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV2EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet', 'employeeAccountId', employeeAccountId);
                            localVarPath = "/api/v2/EmployeeAccounts/GetMasterPasswordBackup/{employeeAccountId}"
                                .replace("{".concat("employeeAccountId", "}"), encodeURIComponent(String(employeeAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EmployeeAccountsApiAxiosParamCreator = EmployeeAccountsApiAxiosParamCreator;
/**
 * EmployeeAccountsApi - functional programming interface
 * @export
 */
var EmployeeAccountsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EmployeeAccountsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} employeeAccountId
         * @param {CreateBackupRequest} [createBackupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsCreateBackupEmployeeAccountIdPost: function (employeeAccountId, createBackupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsCreateBackupEmployeeAccountIdPost(employeeAccountId, createBackupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetCurrentUserGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetCurrentUserGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [searchString]
         * @param {string} [vaultId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetEmployeesByEmailSearchGet: function (searchString, vaultId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetEmployeesByEmailSearchGet(searchString, vaultId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [vaultId]
         * @param {boolean} [isPending]
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetEmployeesVaultIsSharedWithGet: function (vaultId, isPending, searchString, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetEmployeesVaultIsSharedWithGet(vaultId, isPending, searchString, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {boolean} [isPending]
         * @param {string} [vaultId]
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetEmployeesWhoSharedVaultsGet: function (isPending, vaultId, searchString, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetEmployeesWhoSharedVaultsGet(isPending, vaultId, searchString, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetJwksGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetJwksGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet: function (employeeAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet(employeeAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetMasterPasswordBackupForCurrentEmployeeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetMasterPasswordBackupForCurrentEmployeeGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetPrivateBackupKeyEmployeeAccountIdGet: function (employeeAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetPrivateBackupKeyEmployeeAccountIdGet(employeeAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetPublicKeyEmployeeAccountIdGet: function (employeeAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetPublicKeyEmployeeAccountIdGet(employeeAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {LoginStepOneRequest} [loginStepOneRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsLoginStepOnePost: function (loginStepOneRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsLoginStepOnePost(loginStepOneRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {LoginStepTwoRequest} [loginStepTwoRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsLoginStepTwoPost: function (loginStepTwoRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsLoginStepTwoPost(loginStepTwoRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsMeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsMeGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsMeKeyPairGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsMeKeyPairGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsPatchCurrentUserPatch: function (operation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsPatchCurrentUserPatch(operation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {PrivateBackupUpdateRequest} [privateBackupUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsPrivateBackupUpdatePut: function (privateBackupUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsPrivateBackupUpdatePut(privateBackupUpdateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RefreshTokensRequest} [refreshTokensRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRefreshTokensPost: function (refreshTokensRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsRefreshTokensPost(refreshTokensRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<RegisterEmployeeAccountRequest>} [registerEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRegisterBulkPost: function (registerEmployeeAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsRegisterBulkPost(registerEmployeeAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RegisterEmployeeAccountRequest} [registerEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRegisterPost: function (registerEmployeeAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsRegisterPost(registerEmployeeAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {SavePrivateKeyRequest} [savePrivateKeyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsSavePrivateKeyEmployeeAccountIdPost: function (employeeAccountId, savePrivateKeyRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsSavePrivateKeyEmployeeAccountIdPost(employeeAccountId, savePrivateKeyRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsSendTestSilentPushGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsSendTestSilentPushGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet: function (employeeAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet(employeeAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.EmployeeAccountsApiFp = EmployeeAccountsApiFp;
/**
 * EmployeeAccountsApi - factory interface
 * @export
 */
var EmployeeAccountsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EmployeeAccountsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} employeeAccountId
         * @param {CreateBackupRequest} [createBackupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsCreateBackupEmployeeAccountIdPost: function (employeeAccountId, createBackupRequest, options) {
            return localVarFp.apiV1EmployeeAccountsCreateBackupEmployeeAccountIdPost(employeeAccountId, createBackupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetCurrentUserGet: function (options) {
            return localVarFp.apiV1EmployeeAccountsGetCurrentUserGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [searchString]
         * @param {string} [vaultId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetEmployeesByEmailSearchGet: function (searchString, vaultId, options) {
            return localVarFp.apiV1EmployeeAccountsGetEmployeesByEmailSearchGet(searchString, vaultId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [vaultId]
         * @param {boolean} [isPending]
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetEmployeesVaultIsSharedWithGet: function (vaultId, isPending, searchString, options) {
            return localVarFp.apiV1EmployeeAccountsGetEmployeesVaultIsSharedWithGet(vaultId, isPending, searchString, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {boolean} [isPending]
         * @param {string} [vaultId]
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetEmployeesWhoSharedVaultsGet: function (isPending, vaultId, searchString, options) {
            return localVarFp.apiV1EmployeeAccountsGetEmployeesWhoSharedVaultsGet(isPending, vaultId, searchString, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetJwksGet: function (options) {
            return localVarFp.apiV1EmployeeAccountsGetJwksGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet: function (employeeAccountId, options) {
            return localVarFp.apiV1EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetMasterPasswordBackupForCurrentEmployeeGet: function (options) {
            return localVarFp.apiV1EmployeeAccountsGetMasterPasswordBackupForCurrentEmployeeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetPrivateBackupKeyEmployeeAccountIdGet: function (employeeAccountId, options) {
            return localVarFp.apiV1EmployeeAccountsGetPrivateBackupKeyEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetPublicKeyEmployeeAccountIdGet: function (employeeAccountId, options) {
            return localVarFp.apiV1EmployeeAccountsGetPublicKeyEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {LoginStepOneRequest} [loginStepOneRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsLoginStepOnePost: function (loginStepOneRequest, options) {
            return localVarFp.apiV1EmployeeAccountsLoginStepOnePost(loginStepOneRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {LoginStepTwoRequest} [loginStepTwoRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsLoginStepTwoPost: function (loginStepTwoRequest, options) {
            return localVarFp.apiV1EmployeeAccountsLoginStepTwoPost(loginStepTwoRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsMeGet: function (options) {
            return localVarFp.apiV1EmployeeAccountsMeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsMeKeyPairGet: function (options) {
            return localVarFp.apiV1EmployeeAccountsMeKeyPairGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsPatchCurrentUserPatch: function (operation, options) {
            return localVarFp.apiV1EmployeeAccountsPatchCurrentUserPatch(operation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {PrivateBackupUpdateRequest} [privateBackupUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsPrivateBackupUpdatePut: function (privateBackupUpdateRequest, options) {
            return localVarFp.apiV1EmployeeAccountsPrivateBackupUpdatePut(privateBackupUpdateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RefreshTokensRequest} [refreshTokensRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRefreshTokensPost: function (refreshTokensRequest, options) {
            return localVarFp.apiV1EmployeeAccountsRefreshTokensPost(refreshTokensRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<RegisterEmployeeAccountRequest>} [registerEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRegisterBulkPost: function (registerEmployeeAccountRequest, options) {
            return localVarFp.apiV1EmployeeAccountsRegisterBulkPost(registerEmployeeAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RegisterEmployeeAccountRequest} [registerEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRegisterPost: function (registerEmployeeAccountRequest, options) {
            return localVarFp.apiV1EmployeeAccountsRegisterPost(registerEmployeeAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {SavePrivateKeyRequest} [savePrivateKeyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsSavePrivateKeyEmployeeAccountIdPost: function (employeeAccountId, savePrivateKeyRequest, options) {
            return localVarFp.apiV1EmployeeAccountsSavePrivateKeyEmployeeAccountIdPost(employeeAccountId, savePrivateKeyRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsSendTestSilentPushGet: function (options) {
            return localVarFp.apiV1EmployeeAccountsSendTestSilentPushGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet: function (employeeAccountId, options) {
            return localVarFp.apiV2EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EmployeeAccountsApiFactory = EmployeeAccountsApiFactory;
/**
 * EmployeeAccountsApi - object-oriented interface
 * @export
 * @class EmployeeAccountsApi
 * @extends {BaseAPI}
 */
var EmployeeAccountsApi = /** @class */ (function (_super) {
    __extends(EmployeeAccountsApi, _super);
    function EmployeeAccountsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} employeeAccountId
     * @param {CreateBackupRequest} [createBackupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsCreateBackupEmployeeAccountIdPost = function (employeeAccountId, createBackupRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsCreateBackupEmployeeAccountIdPost(employeeAccountId, createBackupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetCurrentUserGet = function (options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetCurrentUserGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [searchString]
     * @param {string} [vaultId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetEmployeesByEmailSearchGet = function (searchString, vaultId, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetEmployeesByEmailSearchGet(searchString, vaultId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [vaultId]
     * @param {boolean} [isPending]
     * @param {string} [searchString]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetEmployeesVaultIsSharedWithGet = function (vaultId, isPending, searchString, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetEmployeesVaultIsSharedWithGet(vaultId, isPending, searchString, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {boolean} [isPending]
     * @param {string} [vaultId]
     * @param {string} [searchString]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetEmployeesWhoSharedVaultsGet = function (isPending, vaultId, searchString, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetEmployeesWhoSharedVaultsGet(isPending, vaultId, searchString, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetJwksGet = function (options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetJwksGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} employeeAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet = function (employeeAccountId, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetMasterPasswordBackupForCurrentEmployeeGet = function (options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetMasterPasswordBackupForCurrentEmployeeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} employeeAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetPrivateBackupKeyEmployeeAccountIdGet = function (employeeAccountId, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetPrivateBackupKeyEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} employeeAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetPublicKeyEmployeeAccountIdGet = function (employeeAccountId, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetPublicKeyEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {LoginStepOneRequest} [loginStepOneRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsLoginStepOnePost = function (loginStepOneRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsLoginStepOnePost(loginStepOneRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {LoginStepTwoRequest} [loginStepTwoRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsLoginStepTwoPost = function (loginStepTwoRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsLoginStepTwoPost(loginStepTwoRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsMeGet = function (options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsMeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsMeKeyPairGet = function (options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsMeKeyPairGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Array<Operation>} [operation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsPatchCurrentUserPatch = function (operation, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsPatchCurrentUserPatch(operation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PrivateBackupUpdateRequest} [privateBackupUpdateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsPrivateBackupUpdatePut = function (privateBackupUpdateRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsPrivateBackupUpdatePut(privateBackupUpdateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RefreshTokensRequest} [refreshTokensRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsRefreshTokensPost = function (refreshTokensRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsRefreshTokensPost(refreshTokensRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Array<RegisterEmployeeAccountRequest>} [registerEmployeeAccountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsRegisterBulkPost = function (registerEmployeeAccountRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsRegisterBulkPost(registerEmployeeAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RegisterEmployeeAccountRequest} [registerEmployeeAccountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsRegisterPost = function (registerEmployeeAccountRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsRegisterPost(registerEmployeeAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} employeeAccountId
     * @param {SavePrivateKeyRequest} [savePrivateKeyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsSavePrivateKeyEmployeeAccountIdPost = function (employeeAccountId, savePrivateKeyRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsSavePrivateKeyEmployeeAccountIdPost(employeeAccountId, savePrivateKeyRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsSendTestSilentPushGet = function (options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsSendTestSilentPushGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} employeeAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV2EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet = function (employeeAccountId, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV2EmployeeAccountsGetMasterPasswordBackupEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EmployeeAccountsApi;
}(base_1.BaseAPI));
exports.EmployeeAccountsApi = EmployeeAccountsApi;
/**
 * EmployeeAccountsToGroupsApi - axios parameter creator
 * @export
 */
var EmployeeAccountsToGroupsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsToGroupsGetByEmployeeAccountIdGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccountsToGroups/GetByEmployeeAccountId";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsToGroupsGetGroupIdsByEmployeeAccountIdGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccountsToGroups/GetGroupIdsByEmployeeAccountId";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EmployeeAccountsToGroupsApiAxiosParamCreator = EmployeeAccountsToGroupsApiAxiosParamCreator;
/**
 * EmployeeAccountsToGroupsApi - functional programming interface
 * @export
 */
var EmployeeAccountsToGroupsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EmployeeAccountsToGroupsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsToGroupsGetByEmployeeAccountIdGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsToGroupsGetByEmployeeAccountIdGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsToGroupsGetGroupIdsByEmployeeAccountIdGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsToGroupsGetGroupIdsByEmployeeAccountIdGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.EmployeeAccountsToGroupsApiFp = EmployeeAccountsToGroupsApiFp;
/**
 * EmployeeAccountsToGroupsApi - factory interface
 * @export
 */
var EmployeeAccountsToGroupsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EmployeeAccountsToGroupsApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsToGroupsGetByEmployeeAccountIdGet: function (options) {
            return localVarFp.apiV1EmployeeAccountsToGroupsGetByEmployeeAccountIdGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsToGroupsGetGroupIdsByEmployeeAccountIdGet: function (options) {
            return localVarFp.apiV1EmployeeAccountsToGroupsGetGroupIdsByEmployeeAccountIdGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EmployeeAccountsToGroupsApiFactory = EmployeeAccountsToGroupsApiFactory;
/**
 * EmployeeAccountsToGroupsApi - object-oriented interface
 * @export
 * @class EmployeeAccountsToGroupsApi
 * @extends {BaseAPI}
 */
var EmployeeAccountsToGroupsApi = /** @class */ (function (_super) {
    __extends(EmployeeAccountsToGroupsApi, _super);
    function EmployeeAccountsToGroupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsToGroupsApi
     */
    EmployeeAccountsToGroupsApi.prototype.apiV1EmployeeAccountsToGroupsGetByEmployeeAccountIdGet = function (options) {
        var _this = this;
        return (0, exports.EmployeeAccountsToGroupsApiFp)(this.configuration).apiV1EmployeeAccountsToGroupsGetByEmployeeAccountIdGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsToGroupsApi
     */
    EmployeeAccountsToGroupsApi.prototype.apiV1EmployeeAccountsToGroupsGetGroupIdsByEmployeeAccountIdGet = function (options) {
        var _this = this;
        return (0, exports.EmployeeAccountsToGroupsApiFp)(this.configuration).apiV1EmployeeAccountsToGroupsGetGroupIdsByEmployeeAccountIdGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EmployeeAccountsToGroupsApi;
}(base_1.BaseAPI));
exports.EmployeeAccountsToGroupsApi = EmployeeAccountsToGroupsApi;
/**
 * GroupRestrictionsApi - axios parameter creator
 * @export
 */
var GroupRestrictionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/GroupRestrictions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsGetByVaultIdVaultIdGet: function (vaultId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1], args_1, true), void 0, function (vaultId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupRestrictionsGetByVaultIdVaultIdGet', 'vaultId', vaultId);
                            localVarPath = "/api/v1/GroupRestrictions/GetByVaultId/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsGroupIdGet: function (groupId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([groupId_1], args_1, true), void 0, function (groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'groupId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupRestrictionsGroupIdGet', 'groupId', groupId);
                            localVarPath = "/api/v1/GroupRestrictions/{groupId}"
                                .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.GroupRestrictionsApiAxiosParamCreator = GroupRestrictionsApiAxiosParamCreator;
/**
 * GroupRestrictionsApi - functional programming interface
 * @export
 */
var GroupRestrictionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GroupRestrictionsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupRestrictionsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsGetByVaultIdVaultIdGet: function (vaultId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupRestrictionsGetByVaultIdVaultIdGet(vaultId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsGroupIdGet: function (groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupRestrictionsGroupIdGet(groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.GroupRestrictionsApiFp = GroupRestrictionsApiFp;
/**
 * GroupRestrictionsApi - factory interface
 * @export
 */
var GroupRestrictionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GroupRestrictionsApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsGet: function (options) {
            return localVarFp.apiV1GroupRestrictionsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsGetByVaultIdVaultIdGet: function (vaultId, options) {
            return localVarFp.apiV1GroupRestrictionsGetByVaultIdVaultIdGet(vaultId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsGroupIdGet: function (groupId, options) {
            return localVarFp.apiV1GroupRestrictionsGroupIdGet(groupId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GroupRestrictionsApiFactory = GroupRestrictionsApiFactory;
/**
 * GroupRestrictionsApi - object-oriented interface
 * @export
 * @class GroupRestrictionsApi
 * @extends {BaseAPI}
 */
var GroupRestrictionsApi = /** @class */ (function (_super) {
    __extends(GroupRestrictionsApi, _super);
    function GroupRestrictionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupRestrictionsApi
     */
    GroupRestrictionsApi.prototype.apiV1GroupRestrictionsGet = function (options) {
        var _this = this;
        return (0, exports.GroupRestrictionsApiFp)(this.configuration).apiV1GroupRestrictionsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupRestrictionsApi
     */
    GroupRestrictionsApi.prototype.apiV1GroupRestrictionsGetByVaultIdVaultIdGet = function (vaultId, options) {
        var _this = this;
        return (0, exports.GroupRestrictionsApiFp)(this.configuration).apiV1GroupRestrictionsGetByVaultIdVaultIdGet(vaultId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupRestrictionsApi
     */
    GroupRestrictionsApi.prototype.apiV1GroupRestrictionsGroupIdGet = function (groupId, options) {
        var _this = this;
        return (0, exports.GroupRestrictionsApiFp)(this.configuration).apiV1GroupRestrictionsGroupIdGet(groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GroupRestrictionsApi;
}(base_1.BaseAPI));
exports.GroupRestrictionsApi = GroupRestrictionsApi;
/**
 * GroupsApi - axios parameter creator
 * @export
 */
var GroupsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Groups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGetGroupAdminSecretsGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Groups/GetGroupAdminSecrets";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGetGroupSecretsGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Groups/GetGroupSecrets";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGroupIdGet: function (groupId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([groupId_1], args_1, true), void 0, function (groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'groupId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupsGroupIdGet', 'groupId', groupId);
                            localVarPath = "/api/v1/Groups/{groupId}"
                                .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.GroupsApiAxiosParamCreator = GroupsApiAxiosParamCreator;
/**
 * GroupsApi - functional programming interface
 * @export
 */
var GroupsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GroupsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGetGroupAdminSecretsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupsGetGroupAdminSecretsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGetGroupSecretsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupsGetGroupSecretsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGroupIdGet: function (groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupsGroupIdGet(groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.GroupsApiFp = GroupsApiFp;
/**
 * GroupsApi - factory interface
 * @export
 */
var GroupsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GroupsApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGet: function (options) {
            return localVarFp.apiV1GroupsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGetGroupAdminSecretsGet: function (options) {
            return localVarFp.apiV1GroupsGetGroupAdminSecretsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGetGroupSecretsGet: function (options) {
            return localVarFp.apiV1GroupsGetGroupSecretsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGroupIdGet: function (groupId, options) {
            return localVarFp.apiV1GroupsGroupIdGet(groupId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GroupsApiFactory = GroupsApiFactory;
/**
 * GroupsApi - object-oriented interface
 * @export
 * @class GroupsApi
 * @extends {BaseAPI}
 */
var GroupsApi = /** @class */ (function (_super) {
    __extends(GroupsApi, _super);
    function GroupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    GroupsApi.prototype.apiV1GroupsGet = function (options) {
        var _this = this;
        return (0, exports.GroupsApiFp)(this.configuration).apiV1GroupsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    GroupsApi.prototype.apiV1GroupsGetGroupAdminSecretsGet = function (options) {
        var _this = this;
        return (0, exports.GroupsApiFp)(this.configuration).apiV1GroupsGetGroupAdminSecretsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    GroupsApi.prototype.apiV1GroupsGetGroupSecretsGet = function (options) {
        var _this = this;
        return (0, exports.GroupsApiFp)(this.configuration).apiV1GroupsGetGroupSecretsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    GroupsApi.prototype.apiV1GroupsGroupIdGet = function (groupId, options) {
        var _this = this;
        return (0, exports.GroupsApiFp)(this.configuration).apiV1GroupsGroupIdGet(groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GroupsApi;
}(base_1.BaseAPI));
exports.GroupsApi = GroupsApi;
/**
 * MasterPasswordResetRequestApi - axios parameter creator
 * @export
 */
var MasterPasswordResetRequestApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestCodeGet: function (code_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([code_1], args_1, true), void 0, function (code, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1MasterPasswordResetRequestCodeGet', 'code', code);
                            localVarPath = "/api/v1/MasterPasswordResetRequest/{code}"
                                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestGetResetMasterPasswordTokenEmployeeAccountIdGet: function (employeeAccountId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1], args_1, true), void 0, function (employeeAccountId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'employeeAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1MasterPasswordResetRequestGetResetMasterPasswordTokenEmployeeAccountIdGet', 'employeeAccountId', employeeAccountId);
                            localVarPath = "/api/v1/MasterPasswordResetRequest/GetResetMasterPasswordToken/{employeeAccountId}"
                                .replace("{".concat("employeeAccountId", "}"), encodeURIComponent(String(employeeAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateMasterPasswordResetRequestRequest} [createMasterPasswordResetRequestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestPost: function (createMasterPasswordResetRequestRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createMasterPasswordResetRequestRequest_1], args_1, true), void 0, function (createMasterPasswordResetRequestRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/MasterPasswordResetRequest";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createMasterPasswordResetRequestRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.MasterPasswordResetRequestApiAxiosParamCreator = MasterPasswordResetRequestApiAxiosParamCreator;
/**
 * MasterPasswordResetRequestApi - functional programming interface
 * @export
 */
var MasterPasswordResetRequestApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MasterPasswordResetRequestApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestCodeGet: function (code, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MasterPasswordResetRequestCodeGet(code, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestGetResetMasterPasswordTokenEmployeeAccountIdGet: function (employeeAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MasterPasswordResetRequestGetResetMasterPasswordTokenEmployeeAccountIdGet(employeeAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateMasterPasswordResetRequestRequest} [createMasterPasswordResetRequestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestPost: function (createMasterPasswordResetRequestRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MasterPasswordResetRequestPost(createMasterPasswordResetRequestRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MasterPasswordResetRequestApiFp = MasterPasswordResetRequestApiFp;
/**
 * MasterPasswordResetRequestApi - factory interface
 * @export
 */
var MasterPasswordResetRequestApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MasterPasswordResetRequestApiFp)(configuration);
    return {
        /**
         *
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestCodeGet: function (code, options) {
            return localVarFp.apiV1MasterPasswordResetRequestCodeGet(code, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestGetResetMasterPasswordTokenEmployeeAccountIdGet: function (employeeAccountId, options) {
            return localVarFp.apiV1MasterPasswordResetRequestGetResetMasterPasswordTokenEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateMasterPasswordResetRequestRequest} [createMasterPasswordResetRequestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestPost: function (createMasterPasswordResetRequestRequest, options) {
            return localVarFp.apiV1MasterPasswordResetRequestPost(createMasterPasswordResetRequestRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MasterPasswordResetRequestApiFactory = MasterPasswordResetRequestApiFactory;
/**
 * MasterPasswordResetRequestApi - object-oriented interface
 * @export
 * @class MasterPasswordResetRequestApi
 * @extends {BaseAPI}
 */
var MasterPasswordResetRequestApi = /** @class */ (function (_super) {
    __extends(MasterPasswordResetRequestApi, _super);
    function MasterPasswordResetRequestApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterPasswordResetRequestApi
     */
    MasterPasswordResetRequestApi.prototype.apiV1MasterPasswordResetRequestCodeGet = function (code, options) {
        var _this = this;
        return (0, exports.MasterPasswordResetRequestApiFp)(this.configuration).apiV1MasterPasswordResetRequestCodeGet(code, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} employeeAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterPasswordResetRequestApi
     */
    MasterPasswordResetRequestApi.prototype.apiV1MasterPasswordResetRequestGetResetMasterPasswordTokenEmployeeAccountIdGet = function (employeeAccountId, options) {
        var _this = this;
        return (0, exports.MasterPasswordResetRequestApiFp)(this.configuration).apiV1MasterPasswordResetRequestGetResetMasterPasswordTokenEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateMasterPasswordResetRequestRequest} [createMasterPasswordResetRequestRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterPasswordResetRequestApi
     */
    MasterPasswordResetRequestApi.prototype.apiV1MasterPasswordResetRequestPost = function (createMasterPasswordResetRequestRequest, options) {
        var _this = this;
        return (0, exports.MasterPasswordResetRequestApiFp)(this.configuration).apiV1MasterPasswordResetRequestPost(createMasterPasswordResetRequestRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MasterPasswordResetRequestApi;
}(base_1.BaseAPI));
exports.MasterPasswordResetRequestApi = MasterPasswordResetRequestApi;
/**
 * MigrationApi - axios parameter creator
 * @export
 */
var MigrationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {ChangeMasterPasswordForMigrationRequest} [changeMasterPasswordForMigrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationChangeMasterPasswordForMigrationPost: function (changeMasterPasswordForMigrationRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([changeMasterPasswordForMigrationRequest_1], args_1, true), void 0, function (changeMasterPasswordForMigrationRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Migration/ChangeMasterPasswordForMigration";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeMasterPasswordForMigrationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateMasterPasswordBackupForMigrationRequest} [createMasterPasswordBackupForMigrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationCreateMasterPasswordBackupForMigrationPost: function (createMasterPasswordBackupForMigrationRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createMasterPasswordBackupForMigrationRequest_1], args_1, true), void 0, function (createMasterPasswordBackupForMigrationRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Migration/CreateMasterPasswordBackupForMigration";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createMasterPasswordBackupForMigrationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationGetMigrationInfoEmailGet: function (email_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([email_1], args_1, true), void 0, function (email, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'email' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1MigrationGetMigrationInfoEmailGet', 'email', email);
                            localVarPath = "/api/v1/Migration/GetMigrationInfo/{email}"
                                .replace("{".concat("email", "}"), encodeURIComponent(String(email)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {MigrationLoginRequest} [migrationLoginRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationMigrationLoginPost: function (migrationLoginRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([migrationLoginRequest_1], args_1, true), void 0, function (migrationLoginRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Migration/MigrationLogin";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(migrationLoginRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {SavePrivateKeyForMigrationRequest} [savePrivateKeyForMigrationRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1MigrationSavePrivateKeyForMigrationEmployeeAccountIdPost: function (employeeAccountId_1, savePrivateKeyForMigrationRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1, savePrivateKeyForMigrationRequest_1], args_1, true), void 0, function (employeeAccountId, savePrivateKeyForMigrationRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'employeeAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1MigrationSavePrivateKeyForMigrationEmployeeAccountIdPost', 'employeeAccountId', employeeAccountId);
                            localVarPath = "/api/v1/Migration/SavePrivateKeyForMigration/{employeeAccountId}"
                                .replace("{".concat("employeeAccountId", "}"), encodeURIComponent(String(employeeAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(savePrivateKeyForMigrationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.MigrationApiAxiosParamCreator = MigrationApiAxiosParamCreator;
/**
 * MigrationApi - functional programming interface
 * @export
 */
var MigrationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MigrationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ChangeMasterPasswordForMigrationRequest} [changeMasterPasswordForMigrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationChangeMasterPasswordForMigrationPost: function (changeMasterPasswordForMigrationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MigrationChangeMasterPasswordForMigrationPost(changeMasterPasswordForMigrationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateMasterPasswordBackupForMigrationRequest} [createMasterPasswordBackupForMigrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationCreateMasterPasswordBackupForMigrationPost: function (createMasterPasswordBackupForMigrationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MigrationCreateMasterPasswordBackupForMigrationPost(createMasterPasswordBackupForMigrationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationGetMigrationInfoEmailGet: function (email, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MigrationGetMigrationInfoEmailGet(email, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {MigrationLoginRequest} [migrationLoginRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationMigrationLoginPost: function (migrationLoginRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MigrationMigrationLoginPost(migrationLoginRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {SavePrivateKeyForMigrationRequest} [savePrivateKeyForMigrationRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1MigrationSavePrivateKeyForMigrationEmployeeAccountIdPost: function (employeeAccountId, savePrivateKeyForMigrationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MigrationSavePrivateKeyForMigrationEmployeeAccountIdPost(employeeAccountId, savePrivateKeyForMigrationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MigrationApiFp = MigrationApiFp;
/**
 * MigrationApi - factory interface
 * @export
 */
var MigrationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MigrationApiFp)(configuration);
    return {
        /**
         *
         * @param {ChangeMasterPasswordForMigrationRequest} [changeMasterPasswordForMigrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationChangeMasterPasswordForMigrationPost: function (changeMasterPasswordForMigrationRequest, options) {
            return localVarFp.apiV1MigrationChangeMasterPasswordForMigrationPost(changeMasterPasswordForMigrationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateMasterPasswordBackupForMigrationRequest} [createMasterPasswordBackupForMigrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationCreateMasterPasswordBackupForMigrationPost: function (createMasterPasswordBackupForMigrationRequest, options) {
            return localVarFp.apiV1MigrationCreateMasterPasswordBackupForMigrationPost(createMasterPasswordBackupForMigrationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationGetMigrationInfoEmailGet: function (email, options) {
            return localVarFp.apiV1MigrationGetMigrationInfoEmailGet(email, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {MigrationLoginRequest} [migrationLoginRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationMigrationLoginPost: function (migrationLoginRequest, options) {
            return localVarFp.apiV1MigrationMigrationLoginPost(migrationLoginRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {SavePrivateKeyForMigrationRequest} [savePrivateKeyForMigrationRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1MigrationSavePrivateKeyForMigrationEmployeeAccountIdPost: function (employeeAccountId, savePrivateKeyForMigrationRequest, options) {
            return localVarFp.apiV1MigrationSavePrivateKeyForMigrationEmployeeAccountIdPost(employeeAccountId, savePrivateKeyForMigrationRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MigrationApiFactory = MigrationApiFactory;
/**
 * MigrationApi - object-oriented interface
 * @export
 * @class MigrationApi
 * @extends {BaseAPI}
 */
var MigrationApi = /** @class */ (function (_super) {
    __extends(MigrationApi, _super);
    function MigrationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {ChangeMasterPasswordForMigrationRequest} [changeMasterPasswordForMigrationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    MigrationApi.prototype.apiV1MigrationChangeMasterPasswordForMigrationPost = function (changeMasterPasswordForMigrationRequest, options) {
        var _this = this;
        return (0, exports.MigrationApiFp)(this.configuration).apiV1MigrationChangeMasterPasswordForMigrationPost(changeMasterPasswordForMigrationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateMasterPasswordBackupForMigrationRequest} [createMasterPasswordBackupForMigrationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    MigrationApi.prototype.apiV1MigrationCreateMasterPasswordBackupForMigrationPost = function (createMasterPasswordBackupForMigrationRequest, options) {
        var _this = this;
        return (0, exports.MigrationApiFp)(this.configuration).apiV1MigrationCreateMasterPasswordBackupForMigrationPost(createMasterPasswordBackupForMigrationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    MigrationApi.prototype.apiV1MigrationGetMigrationInfoEmailGet = function (email, options) {
        var _this = this;
        return (0, exports.MigrationApiFp)(this.configuration).apiV1MigrationGetMigrationInfoEmailGet(email, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {MigrationLoginRequest} [migrationLoginRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    MigrationApi.prototype.apiV1MigrationMigrationLoginPost = function (migrationLoginRequest, options) {
        var _this = this;
        return (0, exports.MigrationApiFp)(this.configuration).apiV1MigrationMigrationLoginPost(migrationLoginRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} employeeAccountId
     * @param {SavePrivateKeyForMigrationRequest} [savePrivateKeyForMigrationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    MigrationApi.prototype.apiV1MigrationSavePrivateKeyForMigrationEmployeeAccountIdPost = function (employeeAccountId, savePrivateKeyForMigrationRequest, options) {
        var _this = this;
        return (0, exports.MigrationApiFp)(this.configuration).apiV1MigrationSavePrivateKeyForMigrationEmployeeAccountIdPost(employeeAccountId, savePrivateKeyForMigrationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MigrationApi;
}(base_1.BaseAPI));
exports.MigrationApi = MigrationApi;
/**
 * OrganizationApi - axios parameter creator
 * @export
 */
var OrganizationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationsCurrentGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Organizations/Current";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationsGetByUserEmailEmailGet: function (email_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([email_1], args_1, true), void 0, function (email, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'email' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1OrganizationsGetByUserEmailEmailGet', 'email', email);
                            localVarPath = "/api/v1/Organizations/GetByUserEmail/{email}"
                                .replace("{".concat("email", "}"), encodeURIComponent(String(email)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OrganizationApiAxiosParamCreator = OrganizationApiAxiosParamCreator;
/**
 * OrganizationApi - functional programming interface
 * @export
 */
var OrganizationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrganizationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationsCurrentGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1OrganizationsCurrentGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationsGetByUserEmailEmailGet: function (email, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1OrganizationsGetByUserEmailEmailGet(email, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OrganizationApiFp = OrganizationApiFp;
/**
 * OrganizationApi - factory interface
 * @export
 */
var OrganizationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrganizationApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationsCurrentGet: function (options) {
            return localVarFp.apiV1OrganizationsCurrentGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationsGetByUserEmailEmailGet: function (email, options) {
            return localVarFp.apiV1OrganizationsGetByUserEmailEmailGet(email, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrganizationApiFactory = OrganizationApiFactory;
/**
 * OrganizationApi - object-oriented interface
 * @export
 * @class OrganizationApi
 * @extends {BaseAPI}
 */
var OrganizationApi = /** @class */ (function (_super) {
    __extends(OrganizationApi, _super);
    function OrganizationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.apiV1OrganizationsCurrentGet = function (options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).apiV1OrganizationsCurrentGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.apiV1OrganizationsGetByUserEmailEmailGet = function (email, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).apiV1OrganizationsGetByUserEmailEmailGet(email, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrganizationApi;
}(base_1.BaseAPI));
exports.OrganizationApi = OrganizationApi;
/**
 * OrganizationSettingsApi - axios parameter creator
 * @export
 */
var OrganizationSettingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationSettingsGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/OrganizationSettings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OrganizationSettingsApiAxiosParamCreator = OrganizationSettingsApiAxiosParamCreator;
/**
 * OrganizationSettingsApi - functional programming interface
 * @export
 */
var OrganizationSettingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrganizationSettingsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationSettingsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1OrganizationSettingsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OrganizationSettingsApiFp = OrganizationSettingsApiFp;
/**
 * OrganizationSettingsApi - factory interface
 * @export
 */
var OrganizationSettingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrganizationSettingsApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationSettingsGet: function (options) {
            return localVarFp.apiV1OrganizationSettingsGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrganizationSettingsApiFactory = OrganizationSettingsApiFactory;
/**
 * OrganizationSettingsApi - object-oriented interface
 * @export
 * @class OrganizationSettingsApi
 * @extends {BaseAPI}
 */
var OrganizationSettingsApi = /** @class */ (function (_super) {
    __extends(OrganizationSettingsApi, _super);
    function OrganizationSettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationSettingsApi
     */
    OrganizationSettingsApi.prototype.apiV1OrganizationSettingsGet = function (options) {
        var _this = this;
        return (0, exports.OrganizationSettingsApiFp)(this.configuration).apiV1OrganizationSettingsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrganizationSettingsApi;
}(base_1.BaseAPI));
exports.OrganizationSettingsApi = OrganizationSettingsApi;
/**
 * PairingCodesApi - axios parameter creator
 * @export
 */
var PairingCodesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PairingCodesGetGet: function (code_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([code_1], args_1, true), void 0, function (code, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PairingCodes/Get";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (code !== undefined) {
                                localVarQueryParameter['code'] = code;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PairingCodesApiAxiosParamCreator = PairingCodesApiAxiosParamCreator;
/**
 * PairingCodesApi - functional programming interface
 * @export
 */
var PairingCodesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PairingCodesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PairingCodesGetGet: function (code, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PairingCodesGetGet(code, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PairingCodesApiFp = PairingCodesApiFp;
/**
 * PairingCodesApi - factory interface
 * @export
 */
var PairingCodesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PairingCodesApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PairingCodesGetGet: function (code, options) {
            return localVarFp.apiV1PairingCodesGetGet(code, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PairingCodesApiFactory = PairingCodesApiFactory;
/**
 * PairingCodesApi - object-oriented interface
 * @export
 * @class PairingCodesApi
 * @extends {BaseAPI}
 */
var PairingCodesApi = /** @class */ (function (_super) {
    __extends(PairingCodesApi, _super);
    function PairingCodesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PairingCodesApi
     */
    PairingCodesApi.prototype.apiV1PairingCodesGetGet = function (code, options) {
        var _this = this;
        return (0, exports.PairingCodesApiFp)(this.configuration).apiV1PairingCodesGetGet(code, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PairingCodesApi;
}(base_1.BaseAPI));
exports.PairingCodesApi = PairingCodesApi;
/**
 * PasswordHashesApi - axios parameter creator
 * @export
 */
var PasswordHashesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {BulkCreateOrganizationPasswordHashesRequest} [bulkCreateOrganizationPasswordHashesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkCreateOrganizationPasswordHashesPost: function (bulkCreateOrganizationPasswordHashesRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bulkCreateOrganizationPasswordHashesRequest_1], args_1, true), void 0, function (bulkCreateOrganizationPasswordHashesRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PasswordHashes/BulkCreateOrganizationPasswordHashes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkCreateOrganizationPasswordHashesRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkCreateUserPasswordHashesRequest} [bulkCreateUserPasswordHashesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkCreateUserPasswordHashesPost: function (bulkCreateUserPasswordHashesRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bulkCreateUserPasswordHashesRequest_1], args_1, true), void 0, function (bulkCreateUserPasswordHashesRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PasswordHashes/BulkCreateUserPasswordHashes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkCreateUserPasswordHashesRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkMarkOrganizationPasswordHashesFailedRequest} [bulkMarkOrganizationPasswordHashesFailedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkMarkOrganizationPasswordHashesFailedPost: function (bulkMarkOrganizationPasswordHashesFailedRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bulkMarkOrganizationPasswordHashesFailedRequest_1], args_1, true), void 0, function (bulkMarkOrganizationPasswordHashesFailedRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PasswordHashes/BulkMarkOrganizationPasswordHashesFailed";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkMarkOrganizationPasswordHashesFailedRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkMarkUserPasswordHashesFailedRequest} [bulkMarkUserPasswordHashesFailedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkMarkUserPasswordHashesFailedPost: function (bulkMarkUserPasswordHashesFailedRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bulkMarkUserPasswordHashesFailedRequest_1], args_1, true), void 0, function (bulkMarkUserPasswordHashesFailedRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PasswordHashes/BulkMarkUserPasswordHashesFailed";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkMarkUserPasswordHashesFailedRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkMoveOrgPasswordHashesToUserRequest} [bulkMoveOrgPasswordHashesToUserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkMoveOrgPasswordHashesToUserPost: function (bulkMoveOrgPasswordHashesToUserRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bulkMoveOrgPasswordHashesToUserRequest_1], args_1, true), void 0, function (bulkMoveOrgPasswordHashesToUserRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PasswordHashes/BulkMoveOrgPasswordHashesToUser";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkMoveOrgPasswordHashesToUserRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [failedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetFailedGroupPasswordsGet: function (limit_1, failedAfter_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, failedAfter_1], args_1, true), void 0, function (limit, failedAfter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PasswordHashes/GetFailedGroupPasswords";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (failedAfter !== undefined) {
                                localVarQueryParameter['failedAfter'] = (failedAfter instanceof Date) ?
                                    failedAfter.toISOString() :
                                    failedAfter;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [failedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetFailedOrganizationPasswordsGet: function (limit_1, failedAfter_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, failedAfter_1], args_1, true), void 0, function (limit, failedAfter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PasswordHashes/GetFailedOrganizationPasswords";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (failedAfter !== undefined) {
                                localVarQueryParameter['failedAfter'] = (failedAfter instanceof Date) ?
                                    failedAfter.toISOString() :
                                    failedAfter;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [failedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetFailedUserPasswordsGet: function (limit_1, failedAfter_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, failedAfter_1], args_1, true), void 0, function (limit, failedAfter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PasswordHashes/GetFailedUserPasswords";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (failedAfter !== undefined) {
                                localVarQueryParameter['failedAfter'] = (failedAfter instanceof Date) ?
                                    failedAfter.toISOString() :
                                    failedAfter;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetUnprocessedGroupPasswordsGet: function (limit_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1], args_1, true), void 0, function (limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PasswordHashes/GetUnprocessedGroupPasswords";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetUnprocessedOrganizationPasswordsGet: function (limit_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1], args_1, true), void 0, function (limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PasswordHashes/GetUnprocessedOrganizationPasswords";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetUnprocessedUserPasswordsGet: function (limit_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1], args_1, true), void 0, function (limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PasswordHashes/GetUnprocessedUserPasswords";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PasswordHashesApiAxiosParamCreator = PasswordHashesApiAxiosParamCreator;
/**
 * PasswordHashesApi - functional programming interface
 * @export
 */
var PasswordHashesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PasswordHashesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {BulkCreateOrganizationPasswordHashesRequest} [bulkCreateOrganizationPasswordHashesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkCreateOrganizationPasswordHashesPost: function (bulkCreateOrganizationPasswordHashesRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PasswordHashesBulkCreateOrganizationPasswordHashesPost(bulkCreateOrganizationPasswordHashesRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkCreateUserPasswordHashesRequest} [bulkCreateUserPasswordHashesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkCreateUserPasswordHashesPost: function (bulkCreateUserPasswordHashesRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PasswordHashesBulkCreateUserPasswordHashesPost(bulkCreateUserPasswordHashesRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkMarkOrganizationPasswordHashesFailedRequest} [bulkMarkOrganizationPasswordHashesFailedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkMarkOrganizationPasswordHashesFailedPost: function (bulkMarkOrganizationPasswordHashesFailedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PasswordHashesBulkMarkOrganizationPasswordHashesFailedPost(bulkMarkOrganizationPasswordHashesFailedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkMarkUserPasswordHashesFailedRequest} [bulkMarkUserPasswordHashesFailedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkMarkUserPasswordHashesFailedPost: function (bulkMarkUserPasswordHashesFailedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PasswordHashesBulkMarkUserPasswordHashesFailedPost(bulkMarkUserPasswordHashesFailedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkMoveOrgPasswordHashesToUserRequest} [bulkMoveOrgPasswordHashesToUserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkMoveOrgPasswordHashesToUserPost: function (bulkMoveOrgPasswordHashesToUserRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PasswordHashesBulkMoveOrgPasswordHashesToUserPost(bulkMoveOrgPasswordHashesToUserRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [failedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetFailedGroupPasswordsGet: function (limit, failedAfter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PasswordHashesGetFailedGroupPasswordsGet(limit, failedAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [failedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetFailedOrganizationPasswordsGet: function (limit, failedAfter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PasswordHashesGetFailedOrganizationPasswordsGet(limit, failedAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [failedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetFailedUserPasswordsGet: function (limit, failedAfter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PasswordHashesGetFailedUserPasswordsGet(limit, failedAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetUnprocessedGroupPasswordsGet: function (limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PasswordHashesGetUnprocessedGroupPasswordsGet(limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetUnprocessedOrganizationPasswordsGet: function (limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PasswordHashesGetUnprocessedOrganizationPasswordsGet(limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetUnprocessedUserPasswordsGet: function (limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PasswordHashesGetUnprocessedUserPasswordsGet(limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PasswordHashesApiFp = PasswordHashesApiFp;
/**
 * PasswordHashesApi - factory interface
 * @export
 */
var PasswordHashesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PasswordHashesApiFp)(configuration);
    return {
        /**
         *
         * @param {BulkCreateOrganizationPasswordHashesRequest} [bulkCreateOrganizationPasswordHashesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkCreateOrganizationPasswordHashesPost: function (bulkCreateOrganizationPasswordHashesRequest, options) {
            return localVarFp.apiV1PasswordHashesBulkCreateOrganizationPasswordHashesPost(bulkCreateOrganizationPasswordHashesRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {BulkCreateUserPasswordHashesRequest} [bulkCreateUserPasswordHashesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkCreateUserPasswordHashesPost: function (bulkCreateUserPasswordHashesRequest, options) {
            return localVarFp.apiV1PasswordHashesBulkCreateUserPasswordHashesPost(bulkCreateUserPasswordHashesRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {BulkMarkOrganizationPasswordHashesFailedRequest} [bulkMarkOrganizationPasswordHashesFailedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkMarkOrganizationPasswordHashesFailedPost: function (bulkMarkOrganizationPasswordHashesFailedRequest, options) {
            return localVarFp.apiV1PasswordHashesBulkMarkOrganizationPasswordHashesFailedPost(bulkMarkOrganizationPasswordHashesFailedRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {BulkMarkUserPasswordHashesFailedRequest} [bulkMarkUserPasswordHashesFailedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkMarkUserPasswordHashesFailedPost: function (bulkMarkUserPasswordHashesFailedRequest, options) {
            return localVarFp.apiV1PasswordHashesBulkMarkUserPasswordHashesFailedPost(bulkMarkUserPasswordHashesFailedRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {BulkMoveOrgPasswordHashesToUserRequest} [bulkMoveOrgPasswordHashesToUserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesBulkMoveOrgPasswordHashesToUserPost: function (bulkMoveOrgPasswordHashesToUserRequest, options) {
            return localVarFp.apiV1PasswordHashesBulkMoveOrgPasswordHashesToUserPost(bulkMoveOrgPasswordHashesToUserRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [failedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetFailedGroupPasswordsGet: function (limit, failedAfter, options) {
            return localVarFp.apiV1PasswordHashesGetFailedGroupPasswordsGet(limit, failedAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [failedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetFailedOrganizationPasswordsGet: function (limit, failedAfter, options) {
            return localVarFp.apiV1PasswordHashesGetFailedOrganizationPasswordsGet(limit, failedAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [failedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetFailedUserPasswordsGet: function (limit, failedAfter, options) {
            return localVarFp.apiV1PasswordHashesGetFailedUserPasswordsGet(limit, failedAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetUnprocessedGroupPasswordsGet: function (limit, options) {
            return localVarFp.apiV1PasswordHashesGetUnprocessedGroupPasswordsGet(limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetUnprocessedOrganizationPasswordsGet: function (limit, options) {
            return localVarFp.apiV1PasswordHashesGetUnprocessedOrganizationPasswordsGet(limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PasswordHashesGetUnprocessedUserPasswordsGet: function (limit, options) {
            return localVarFp.apiV1PasswordHashesGetUnprocessedUserPasswordsGet(limit, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PasswordHashesApiFactory = PasswordHashesApiFactory;
/**
 * PasswordHashesApi - object-oriented interface
 * @export
 * @class PasswordHashesApi
 * @extends {BaseAPI}
 */
var PasswordHashesApi = /** @class */ (function (_super) {
    __extends(PasswordHashesApi, _super);
    function PasswordHashesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {BulkCreateOrganizationPasswordHashesRequest} [bulkCreateOrganizationPasswordHashesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordHashesApi
     */
    PasswordHashesApi.prototype.apiV1PasswordHashesBulkCreateOrganizationPasswordHashesPost = function (bulkCreateOrganizationPasswordHashesRequest, options) {
        var _this = this;
        return (0, exports.PasswordHashesApiFp)(this.configuration).apiV1PasswordHashesBulkCreateOrganizationPasswordHashesPost(bulkCreateOrganizationPasswordHashesRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {BulkCreateUserPasswordHashesRequest} [bulkCreateUserPasswordHashesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordHashesApi
     */
    PasswordHashesApi.prototype.apiV1PasswordHashesBulkCreateUserPasswordHashesPost = function (bulkCreateUserPasswordHashesRequest, options) {
        var _this = this;
        return (0, exports.PasswordHashesApiFp)(this.configuration).apiV1PasswordHashesBulkCreateUserPasswordHashesPost(bulkCreateUserPasswordHashesRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {BulkMarkOrganizationPasswordHashesFailedRequest} [bulkMarkOrganizationPasswordHashesFailedRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordHashesApi
     */
    PasswordHashesApi.prototype.apiV1PasswordHashesBulkMarkOrganizationPasswordHashesFailedPost = function (bulkMarkOrganizationPasswordHashesFailedRequest, options) {
        var _this = this;
        return (0, exports.PasswordHashesApiFp)(this.configuration).apiV1PasswordHashesBulkMarkOrganizationPasswordHashesFailedPost(bulkMarkOrganizationPasswordHashesFailedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {BulkMarkUserPasswordHashesFailedRequest} [bulkMarkUserPasswordHashesFailedRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordHashesApi
     */
    PasswordHashesApi.prototype.apiV1PasswordHashesBulkMarkUserPasswordHashesFailedPost = function (bulkMarkUserPasswordHashesFailedRequest, options) {
        var _this = this;
        return (0, exports.PasswordHashesApiFp)(this.configuration).apiV1PasswordHashesBulkMarkUserPasswordHashesFailedPost(bulkMarkUserPasswordHashesFailedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {BulkMoveOrgPasswordHashesToUserRequest} [bulkMoveOrgPasswordHashesToUserRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordHashesApi
     */
    PasswordHashesApi.prototype.apiV1PasswordHashesBulkMoveOrgPasswordHashesToUserPost = function (bulkMoveOrgPasswordHashesToUserRequest, options) {
        var _this = this;
        return (0, exports.PasswordHashesApiFp)(this.configuration).apiV1PasswordHashesBulkMoveOrgPasswordHashesToUserPost(bulkMoveOrgPasswordHashesToUserRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [limit]
     * @param {string} [failedAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordHashesApi
     */
    PasswordHashesApi.prototype.apiV1PasswordHashesGetFailedGroupPasswordsGet = function (limit, failedAfter, options) {
        var _this = this;
        return (0, exports.PasswordHashesApiFp)(this.configuration).apiV1PasswordHashesGetFailedGroupPasswordsGet(limit, failedAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [limit]
     * @param {string} [failedAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordHashesApi
     */
    PasswordHashesApi.prototype.apiV1PasswordHashesGetFailedOrganizationPasswordsGet = function (limit, failedAfter, options) {
        var _this = this;
        return (0, exports.PasswordHashesApiFp)(this.configuration).apiV1PasswordHashesGetFailedOrganizationPasswordsGet(limit, failedAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [limit]
     * @param {string} [failedAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordHashesApi
     */
    PasswordHashesApi.prototype.apiV1PasswordHashesGetFailedUserPasswordsGet = function (limit, failedAfter, options) {
        var _this = this;
        return (0, exports.PasswordHashesApiFp)(this.configuration).apiV1PasswordHashesGetFailedUserPasswordsGet(limit, failedAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordHashesApi
     */
    PasswordHashesApi.prototype.apiV1PasswordHashesGetUnprocessedGroupPasswordsGet = function (limit, options) {
        var _this = this;
        return (0, exports.PasswordHashesApiFp)(this.configuration).apiV1PasswordHashesGetUnprocessedGroupPasswordsGet(limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordHashesApi
     */
    PasswordHashesApi.prototype.apiV1PasswordHashesGetUnprocessedOrganizationPasswordsGet = function (limit, options) {
        var _this = this;
        return (0, exports.PasswordHashesApiFp)(this.configuration).apiV1PasswordHashesGetUnprocessedOrganizationPasswordsGet(limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordHashesApi
     */
    PasswordHashesApi.prototype.apiV1PasswordHashesGetUnprocessedUserPasswordsGet = function (limit, options) {
        var _this = this;
        return (0, exports.PasswordHashesApiFp)(this.configuration).apiV1PasswordHashesGetUnprocessedUserPasswordsGet(limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PasswordHashesApi;
}(base_1.BaseAPI));
exports.PasswordHashesApi = PasswordHashesApi;
/**
 * PrivateKeychainApi - axios parameter creator
 * @export
 */
var PrivateKeychainApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {DeleteVaultRequest} [deleteVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrivateKeychainDeleteVaultDelete: function (deleteVaultRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteVaultRequest_1], args_1, true), void 0, function (deleteVaultRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PrivateKeychain/DeleteVault";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteVaultRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PrivateKeychainApiAxiosParamCreator = PrivateKeychainApiAxiosParamCreator;
/**
 * PrivateKeychainApi - functional programming interface
 * @export
 */
var PrivateKeychainApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PrivateKeychainApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {DeleteVaultRequest} [deleteVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrivateKeychainDeleteVaultDelete: function (deleteVaultRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PrivateKeychainDeleteVaultDelete(deleteVaultRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PrivateKeychainApiFp = PrivateKeychainApiFp;
/**
 * PrivateKeychainApi - factory interface
 * @export
 */
var PrivateKeychainApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PrivateKeychainApiFp)(configuration);
    return {
        /**
         *
         * @param {DeleteVaultRequest} [deleteVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PrivateKeychainDeleteVaultDelete: function (deleteVaultRequest, options) {
            return localVarFp.apiV1PrivateKeychainDeleteVaultDelete(deleteVaultRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PrivateKeychainApiFactory = PrivateKeychainApiFactory;
/**
 * PrivateKeychainApi - object-oriented interface
 * @export
 * @class PrivateKeychainApi
 * @extends {BaseAPI}
 */
var PrivateKeychainApi = /** @class */ (function (_super) {
    __extends(PrivateKeychainApi, _super);
    function PrivateKeychainApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {DeleteVaultRequest} [deleteVaultRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateKeychainApi
     */
    PrivateKeychainApi.prototype.apiV1PrivateKeychainDeleteVaultDelete = function (deleteVaultRequest, options) {
        var _this = this;
        return (0, exports.PrivateKeychainApiFp)(this.configuration).apiV1PrivateKeychainDeleteVaultDelete(deleteVaultRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PrivateKeychainApi;
}(base_1.BaseAPI));
exports.PrivateKeychainApi = PrivateKeychainApi;
/**
 * QueueApi - axios parameter creator
 * @export
 */
var QueueApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {AddToEmployeeRequestedApprovalRequest} [addToEmployeeRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAddRequestedForEmployeeApprovePost: function (addToEmployeeRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([addToEmployeeRequestedApprovalRequest_1], args_1, true), void 0, function (addToEmployeeRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/AddRequestedForEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addToEmployeeRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {AddToEmployeeRequestedRejectRequest} [addToEmployeeRequestedRejectRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAddRequestedForEmployeeRejectPost: function (addToEmployeeRequestedRejectRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([addToEmployeeRequestedRejectRequest_1], args_1, true), void 0, function (addToEmployeeRequestedRejectRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/AddRequestedForEmployee/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addToEmployeeRequestedRejectRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {AddToGroupRequestedApprovalRequest} [addToGroupRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAddRequestedForGroupApprovePost: function (addToGroupRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([addToGroupRequestedApprovalRequest_1], args_1, true), void 0, function (addToGroupRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/AddRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addToGroupRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {AddToGroupRequestedRejectRequest} [addToGroupRequestedRejectRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAddRequestedForGroupRejectPost: function (addToGroupRequestedRejectRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([addToGroupRequestedRejectRequest_1], args_1, true), void 0, function (addToGroupRequestedRejectRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/AddRequestedForGroup/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addToGroupRequestedRejectRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {AddToEmployeeRequestedApprovalRequest} [addToEmployeeRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminAddRequestedForEmployeeApprovePost: function (addToEmployeeRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([addToEmployeeRequestedApprovalRequest_1], args_1, true), void 0, function (addToEmployeeRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/AdminAddRequestedForEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addToEmployeeRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {AddToGroupRequestedApprovalRequest} [addToGroupRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminAddRequestedForGroupApprovePost: function (addToGroupRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([addToGroupRequestedApprovalRequest_1], args_1, true), void 0, function (addToGroupRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/AdminAddRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addToGroupRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultCreditCardCreationRequestedForEmployeeApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultCreditCardCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultCreditCardCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/AdminVaultCreditCardCreationRequestedForEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultCreditCardCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultCreditCardCreationRequestedForGroupApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultCreditCardCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultCreditCardCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/AdminVaultCreditCardCreationRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultCreditCardCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultPasswordCreationRequestedForEmployeeApprovePost: function (vaultPasswordCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultPasswordCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultPasswordCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/AdminVaultPasswordCreationRequestedForEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultPasswordCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultPasswordCreationRequestedForGroupApprovePost: function (vaultPasswordCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultPasswordCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultPasswordCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/AdminVaultPasswordCreationRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultPasswordCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultSecureNoteCreationRequestedForEmployeeApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultSecureNoteCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/AdminVaultSecureNoteCreationRequestedForEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultSecureNoteCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultSecureNoteCreationRequestedForGroupApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultSecureNoteCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/AdminVaultSecureNoteCreationRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultSecureNoteCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveCreateTrustedBrowserRequest} [approveCreateTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueCreateTrustedBrowserRequestedApprovePost: function (approveCreateTrustedBrowserRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveCreateTrustedBrowserRequest_1], args_1, true), void 0, function (approveCreateTrustedBrowserRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/CreateTrustedBrowserRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveCreateTrustedBrowserRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectCreateTrustedBrowserRequest} [rejectCreateTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueCreateTrustedBrowserRequestedRejectPost: function (rejectCreateTrustedBrowserRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectCreateTrustedBrowserRequest_1], args_1, true), void 0, function (rejectCreateTrustedBrowserRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/CreateTrustedBrowserRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectCreateTrustedBrowserRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveDeleteVaultRequest} [approveDeleteVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeleteVaultApprovePost: function (approveDeleteVaultRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveDeleteVaultRequest_1], args_1, true), void 0, function (approveDeleteVaultRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/DeleteVault/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveDeleteVaultRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectDeleteVaultRequest} [rejectDeleteVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeleteVaultRejectPost: function (rejectDeleteVaultRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectDeleteVaultRequest_1], args_1, true), void 0, function (rejectDeleteVaultRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/DeleteVault/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectDeleteVaultRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteBulkVaultsApprovalRequest} [deleteBulkVaultsApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionBulkVaultsRequestedApprovePost: function (deleteBulkVaultsApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteBulkVaultsApprovalRequest_1], args_1, true), void 0, function (deleteBulkVaultsApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/DeletionBulkVaultsRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteBulkVaultsApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteBulkVaultsRejectRequest} [deleteBulkVaultsRejectRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionBulkVaultsRequestedRejectPost: function (deleteBulkVaultsRejectRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteBulkVaultsRejectRequest_1], args_1, true), void 0, function (deleteBulkVaultsRejectRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/DeletionBulkVaultsRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteBulkVaultsRejectRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DeletionRequestedApprovalRequest} [deletionRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionForEmployeeRequestedApprovePost: function (deletionRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deletionRequestedApprovalRequest_1], args_1, true), void 0, function (deletionRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/DeletionForEmployeeRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deletionRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DeletionRequestedRejectionRequest} [deletionRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionForEmployeeRequestedRejectPost: function (deletionRequestedRejectionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deletionRequestedRejectionRequest_1], args_1, true), void 0, function (deletionRequestedRejectionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/DeletionForEmployeeRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deletionRequestedRejectionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DeletionRequestedApprovalRequest} [deletionRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionForGroupRequestedApprovePost: function (deletionRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deletionRequestedApprovalRequest_1], args_1, true), void 0, function (deletionRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/DeletionForGroupRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deletionRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DeletionRequestedRejectionRequest} [deletionRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionForGroupRequestedRejectPost: function (deletionRequestedRejectionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deletionRequestedRejectionRequest_1], args_1, true), void 0, function (deletionRequestedRejectionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/DeletionForGroupRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deletionRequestedRejectionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveExportVaultPasswordsRequest} [approveExportVaultPasswordsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueExportVaultPasswordsApprovePost: function (approveExportVaultPasswordsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveExportVaultPasswordsRequest_1], args_1, true), void 0, function (approveExportVaultPasswordsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/ExportVaultPasswords/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveExportVaultPasswordsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectExportVaultPasswordsRequest} [rejectExportVaultPasswordsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueExportVaultPasswordsRejectPost: function (rejectExportVaultPasswordsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectExportVaultPasswordsRequest_1], args_1, true), void 0, function (rejectExportVaultPasswordsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/ExportVaultPasswords/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectExportVaultPasswordsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveFixEmployeePrivateKeysRequest} [approveFixEmployeePrivateKeysRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueFixEmployeePrivateKeysApprovePost: function (approveFixEmployeePrivateKeysRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveFixEmployeePrivateKeysRequest_1], args_1, true), void 0, function (approveFixEmployeePrivateKeysRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/FixEmployeePrivateKeys/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveFixEmployeePrivateKeysRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateFixEmployeePrivateKeysRequest} [createFixEmployeePrivateKeysRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueFixEmployeePrivateKeysCreatePost: function (createFixEmployeePrivateKeysRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createFixEmployeePrivateKeysRequest_1], args_1, true), void 0, function (createFixEmployeePrivateKeysRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/FixEmployeePrivateKeys/Create";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFixEmployeePrivateKeysRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest} [approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost: function (approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest_1], args_1, true), void 0, function (approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/GetVaultPasswordDetailsForGroupViaTrustedBrowserRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest} [rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest_1], args_1, true), void 0, function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/GetVaultPasswordDetailsForGroupViaTrustedBrowserRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveGetVaultPasswordDetailsViaTrustedBrowserRequest} [approveGetVaultPasswordDetailsViaTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost: function (approveGetVaultPasswordDetailsViaTrustedBrowserRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveGetVaultPasswordDetailsViaTrustedBrowserRequest_1], args_1, true), void 0, function (approveGetVaultPasswordDetailsViaTrustedBrowserRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/GetVaultPasswordDetailsViaTrustedBrowserRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveGetVaultPasswordDetailsViaTrustedBrowserRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsViaTrustedBrowserRequest} [rejectGetVaultPasswordDetailsViaTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsViaTrustedBrowserRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectGetVaultPasswordDetailsViaTrustedBrowserRequest_1], args_1, true), void 0, function (rejectGetVaultPasswordDetailsViaTrustedBrowserRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/GetVaultPasswordDetailsViaTrustedBrowserRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectGetVaultPasswordDetailsViaTrustedBrowserRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMasterPasswordResetRequestRequest} [approveMasterPasswordResetRequestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMasterPasswordResetRequestApprovePost: function (approveMasterPasswordResetRequestRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveMasterPasswordResetRequestRequest_1], args_1, true), void 0, function (approveMasterPasswordResetRequestRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/MasterPasswordResetRequest/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveMasterPasswordResetRequestRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultBetweenEmployeeRequest} [approveMoveVaultBetweenEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultBetweenEmployeesApprovePost: function (approveMoveVaultBetweenEmployeeRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveMoveVaultBetweenEmployeeRequest_1], args_1, true), void 0, function (approveMoveVaultBetweenEmployeeRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/MoveVaultBetweenEmployees/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveMoveVaultBetweenEmployeeRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultBetweenGroupsRequest} [approveMoveVaultBetweenGroupsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultBetweenGroupsApprovePost: function (approveMoveVaultBetweenGroupsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveMoveVaultBetweenGroupsRequest_1], args_1, true), void 0, function (approveMoveVaultBetweenGroupsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/MoveVaultBetweenGroups/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveMoveVaultBetweenGroupsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultFromEmployeeToGroupRequest} [approveMoveVaultFromEmployeeToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultFromEmployeeToGroupApprovePost: function (approveMoveVaultFromEmployeeToGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveMoveVaultFromEmployeeToGroupRequest_1], args_1, true), void 0, function (approveMoveVaultFromEmployeeToGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/MoveVaultFromEmployeeToGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveMoveVaultFromEmployeeToGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultToEmployeeOrganizationKeychainRequest} [approveMoveVaultToEmployeeOrganizationKeychainRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultToEmployeeOrganizationKeychainApprovePost: function (approveMoveVaultToEmployeeOrganizationKeychainRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveMoveVaultToEmployeeOrganizationKeychainRequest_1], args_1, true), void 0, function (approveMoveVaultToEmployeeOrganizationKeychainRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/MoveVaultToEmployeeOrganizationKeychain/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveMoveVaultToEmployeeOrganizationKeychainRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultToGroupRequest} [approveMoveVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultToGroupApprovePost: function (approveMoveVaultToGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveMoveVaultToGroupRequest_1], args_1, true), void 0, function (approveMoveVaultToGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/MoveVaultToGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveMoveVaultToGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultToGroupOrganizationKeychainRequest} [approveMoveVaultToGroupOrganizationKeychainRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultToGroupOrganizationKeychainApprovePost: function (approveMoveVaultToGroupOrganizationKeychainRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveMoveVaultToGroupOrganizationKeychainRequest_1], args_1, true), void 0, function (approveMoveVaultToGroupOrganizationKeychainRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/MoveVaultToGroupOrganizationKeychain/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveMoveVaultToGroupOrganizationKeychainRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultToPrivateKeychainRequest} [approveMoveVaultToPrivateKeychainRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultToPrivateKeychainApprovePost: function (approveMoveVaultToPrivateKeychainRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveMoveVaultToPrivateKeychainRequest_1], args_1, true), void 0, function (approveMoveVaultToPrivateKeychainRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/MoveVaultToPrivateKeychain/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveMoveVaultToPrivateKeychainRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {PartnerSupportRequestApprovalRequest} [partnerSupportRequestApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueuePartnerSupportRequestApprovePost: function (partnerSupportRequestApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([partnerSupportRequestApprovalRequest_1], args_1, true), void 0, function (partnerSupportRequestApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/PartnerSupportRequest/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(partnerSupportRequestApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveProcessEmployeeAsExistingUserRequest} [approveProcessEmployeeAsExistingUserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessEmployeeAsExistingUserApprovePost: function (approveProcessEmployeeAsExistingUserRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveProcessEmployeeAsExistingUserRequest_1], args_1, true), void 0, function (approveProcessEmployeeAsExistingUserRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/ProcessEmployeeAsExistingUser/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveProcessEmployeeAsExistingUserRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveProcessFirstAdminAsExistingUser} [approveProcessFirstAdminAsExistingUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessFirstAdminAsExistingUserApprovePost: function (approveProcessFirstAdminAsExistingUser_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveProcessFirstAdminAsExistingUser_1], args_1, true), void 0, function (approveProcessFirstAdminAsExistingUser, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/ProcessFirstAdminAsExistingUser/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveProcessFirstAdminAsExistingUser, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveProcessInviteEmployeeRequest} [approveProcessInviteEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessInviteEmployeeApprovePost: function (approveProcessInviteEmployeeRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveProcessInviteEmployeeRequest_1], args_1, true), void 0, function (approveProcessInviteEmployeeRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/ProcessInviteEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveProcessInviteEmployeeRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveProcessMigratedEmployeeRequest} [approveProcessMigratedEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessMigratedEmployeeApprovePost: function (approveProcessMigratedEmployeeRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveProcessMigratedEmployeeRequest_1], args_1, true), void 0, function (approveProcessMigratedEmployeeRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/ProcessMigratedEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveProcessMigratedEmployeeRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveProcessNewEmployeeRequest} [approveProcessNewEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessNewEmployeeApprovePost: function (approveProcessNewEmployeeRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveProcessNewEmployeeRequest_1], args_1, true), void 0, function (approveProcessNewEmployeeRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/ProcessNewEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveProcessNewEmployeeRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {FailProcessNewEmployeeRequest} [failProcessNewEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessNewEmployeeFailPost: function (failProcessNewEmployeeRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([failProcessNewEmployeeRequest_1], args_1, true), void 0, function (failProcessNewEmployeeRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/ProcessNewEmployee/Fail";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(failProcessNewEmployeeRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApprovePromoteAdminRequest} [approvePromoteAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueuePromoteAdminApprovePost: function (approvePromoteAdminRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approvePromoteAdminRequest_1], args_1, true), void 0, function (approvePromoteAdminRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/PromoteAdmin/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approvePromoteAdminRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectPromoteAdminRequest} [rejectPromoteAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueuePromoteAdminRejectPost: function (rejectPromoteAdminRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectPromoteAdminRequest_1], args_1, true), void 0, function (rejectPromoteAdminRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/PromoteAdmin/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectPromoteAdminRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveQueueRequest} [approveQueueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonApprovePost: function (approveQueueRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveQueueRequest_1], args_1, true), void 0, function (approveQueueRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/QueueCommon/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveQueueRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} queueMessageId
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonCheckIfAvailableGet: function (queueMessageId_1, deviceId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([queueMessageId_1, deviceId_1], args_1, true), void 0, function (queueMessageId, deviceId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'queueMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1QueueQueueCommonCheckIfAvailableGet', 'queueMessageId', queueMessageId);
                            // verify required parameter 'deviceId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1QueueQueueCommonCheckIfAvailableGet', 'deviceId', deviceId);
                            localVarPath = "/api/v1/queue/QueueCommon/CheckIfAvailable";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (queueMessageId !== undefined) {
                                localVarQueryParameter['QueueMessageId'] = queueMessageId;
                            }
                            if (deviceId !== undefined) {
                                localVarQueryParameter['DeviceId'] = deviceId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {FailQueueRequest} [failQueueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonFailPost: function (failQueueRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([failQueueRequest_1], args_1, true), void 0, function (failQueueRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/QueueCommon/Fail";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(failQueueRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} quantity
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonGetQueueMessagesGet: function (quantity_1, deviceId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([quantity_1, deviceId_1], args_1, true), void 0, function (quantity, deviceId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'quantity' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1QueueQueueCommonGetQueueMessagesGet', 'quantity', quantity);
                            // verify required parameter 'deviceId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1QueueQueueCommonGetQueueMessagesGet', 'deviceId', deviceId);
                            localVarPath = "/api/v1/queue/QueueCommon/GetQueueMessages";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (quantity !== undefined) {
                                localVarQueryParameter['Quantity'] = quantity;
                            }
                            if (deviceId !== undefined) {
                                localVarQueryParameter['DeviceId'] = deviceId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectQueueRequest} [rejectQueueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonRejectPost: function (rejectQueueRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectQueueRequest_1], args_1, true), void 0, function (rejectQueueRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/QueueCommon/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectQueueRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveRevokeAdminRequest} [approveRevokeAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeAdminApprovePost: function (approveRevokeAdminRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveRevokeAdminRequest_1], args_1, true), void 0, function (approveRevokeAdminRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/RevokeAdmin/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveRevokeAdminRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectRevokeAdminRequest} [rejectRevokeAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeAdminRejectPost: function (rejectRevokeAdminRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectRevokeAdminRequest_1], args_1, true), void 0, function (rejectRevokeAdminRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/RevokeAdmin/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectRevokeAdminRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveRevokeSharedVaultRequest} [approveRevokeSharedVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeSharedVaultApprovePost: function (approveRevokeSharedVaultRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveRevokeSharedVaultRequest_1], args_1, true), void 0, function (approveRevokeSharedVaultRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/RevokeSharedVault/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveRevokeSharedVaultRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectRevokeSharedVaultRequest} [rejectRevokeSharedVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeSharedVaultRejectPost: function (rejectRevokeSharedVaultRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectRevokeSharedVaultRequest_1], args_1, true), void 0, function (rejectRevokeSharedVaultRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/RevokeSharedVault/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectRevokeSharedVaultRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveRevokeVaultSharingRequest} [approveRevokeVaultSharingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeVaultSharingApprovePost: function (approveRevokeVaultSharingRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveRevokeVaultSharingRequest_1], args_1, true), void 0, function (approveRevokeVaultSharingRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/RevokeVaultSharing/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveRevokeVaultSharingRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectRevokeVaultSharingRequest} [rejectRevokeVaultSharingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeVaultSharingRejectPost: function (rejectRevokeVaultSharingRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectRevokeVaultSharingRequest_1], args_1, true), void 0, function (rejectRevokeVaultSharingRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/RevokeVaultSharing/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectRevokeVaultSharingRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveShareGroupSecretWithEmployeeAccountRequest} [approveShareGroupSecretWithEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueShareGroupSecretWithEmployeeAccountApprovePost: function (approveShareGroupSecretWithEmployeeAccountRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveShareGroupSecretWithEmployeeAccountRequest_1], args_1, true), void 0, function (approveShareGroupSecretWithEmployeeAccountRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/ShareGroupSecretWithEmployeeAccount/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveShareGroupSecretWithEmployeeAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveTrustedPortalRequestedRequest} [approveTrustedPortalRequestedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueTrustedPortalRequestedApprovePost: function (approveTrustedPortalRequestedRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveTrustedPortalRequestedRequest_1], args_1, true), void 0, function (approveTrustedPortalRequestedRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/TrustedPortalRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveTrustedPortalRequestedRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectTrustedPortalRequestedRequest} [rejectTrustedPortalRequestedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueTrustedPortalRequestedRejectPost: function (rejectTrustedPortalRequestedRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectTrustedPortalRequestedRequest_1], args_1, true), void 0, function (rejectTrustedPortalRequestedRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/TrustedPortalRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectTrustedPortalRequestedRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardCreationRequestedApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultCreditCardCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultCreditCardCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultCreditCardCreationRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultCreditCardCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardCreationRequestedForEmployeeApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultCreditCardCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultCreditCardCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultCreditCardCreationRequestedForEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultCreditCardCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardCreationRequestedForGroupApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultCreditCardCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultCreditCardCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultCreditCardCreationRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultCreditCardCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardDetailsRequestedApprovalRequest} [vaultCreditCardDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardDetailsRequestedApprovePost: function (vaultCreditCardDetailsRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultCreditCardDetailsRequestedApprovalRequest_1], args_1, true), void 0, function (vaultCreditCardDetailsRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultCreditCardDetailsRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultCreditCardDetailsRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardDetailsRequestedApprovalRequest} [vaultCreditCardDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardDetailsRequestedForGroupApprovePost: function (vaultCreditCardDetailsRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultCreditCardDetailsRequestedApprovalRequest_1], args_1, true), void 0, function (vaultCreditCardDetailsRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultCreditCardDetailsRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultCreditCardDetailsRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardDetailsRequestedRejectionRequest} [vaultCreditCardDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardDetailsRequestedForGroupRejectPost: function (vaultCreditCardDetailsRequestedRejectionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultCreditCardDetailsRequestedRejectionRequest_1], args_1, true), void 0, function (vaultCreditCardDetailsRequestedRejectionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultCreditCardDetailsRequestedForGroup/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultCreditCardDetailsRequestedRejectionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardDetailsRequestedRejectionRequest} [vaultCreditCardDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardDetailsRequestedRejectPost: function (vaultCreditCardDetailsRequestedRejectionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultCreditCardDetailsRequestedRejectionRequest_1], args_1, true), void 0, function (vaultCreditCardDetailsRequestedRejectionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultCreditCardDetailsRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultCreditCardDetailsRequestedRejectionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardEditRequestedApprovalRequest} [vaultCreditCardEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardEditRequestedForEmployeeApprovePost: function (vaultCreditCardEditRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultCreditCardEditRequestedApprovalRequest_1], args_1, true), void 0, function (vaultCreditCardEditRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultCreditCardEditRequestedForEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultCreditCardEditRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardEditRequestedApprovalRequest} [vaultCreditCardEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardEditRequestedForGroupApprovePost: function (vaultCreditCardEditRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultCreditCardEditRequestedApprovalRequest_1], args_1, true), void 0, function (vaultCreditCardEditRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultCreditCardEditRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultCreditCardEditRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedUnmanagedApprovalRequest} [vaultPasswordCreationRequestedUnmanagedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordCreationRequestedApprovePost: function (vaultPasswordCreationRequestedUnmanagedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultPasswordCreationRequestedUnmanagedApprovalRequest_1], args_1, true), void 0, function (vaultPasswordCreationRequestedUnmanagedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultPasswordCreationRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultPasswordCreationRequestedUnmanagedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordCreationRequestedForEmployeeApprovePost: function (vaultPasswordCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultPasswordCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultPasswordCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultPasswordCreationRequestedForEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultPasswordCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordCreationRequestedForGroupApprovePost: function (vaultPasswordCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultPasswordCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultPasswordCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultPasswordCreationRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultPasswordCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordDetailsRequestedApprovalRequest} [vaultPasswordDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordDetailsRequestedApprovePost: function (vaultPasswordDetailsRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultPasswordDetailsRequestedApprovalRequest_1], args_1, true), void 0, function (vaultPasswordDetailsRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultPasswordDetailsRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultPasswordDetailsRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordDetailsRequestedApprovalRequest} [vaultPasswordDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordDetailsRequestedForGroupApprovePost: function (vaultPasswordDetailsRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultPasswordDetailsRequestedApprovalRequest_1], args_1, true), void 0, function (vaultPasswordDetailsRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultPasswordDetailsRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultPasswordDetailsRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordDetailsRequestedRejectionRequest} [vaultPasswordDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordDetailsRequestedForGroupRejectPost: function (vaultPasswordDetailsRequestedRejectionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultPasswordDetailsRequestedRejectionRequest_1], args_1, true), void 0, function (vaultPasswordDetailsRequestedRejectionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultPasswordDetailsRequestedForGroup/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultPasswordDetailsRequestedRejectionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordDetailsRequestedRejectionRequest} [vaultPasswordDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordDetailsRequestedRejectPost: function (vaultPasswordDetailsRequestedRejectionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultPasswordDetailsRequestedRejectionRequest_1], args_1, true), void 0, function (vaultPasswordDetailsRequestedRejectionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultPasswordDetailsRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultPasswordDetailsRequestedRejectionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordEditRequestedApprovalRequest} [vaultPasswordEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordEditRequestedForEmployeeApprovePost: function (vaultPasswordEditRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultPasswordEditRequestedApprovalRequest_1], args_1, true), void 0, function (vaultPasswordEditRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultPasswordEditRequestedForEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultPasswordEditRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordEditRequestedApprovalRequest} [vaultPasswordEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordEditRequestedForGroupApprovePost: function (vaultPasswordEditRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultPasswordEditRequestedApprovalRequest_1], args_1, true), void 0, function (vaultPasswordEditRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultPasswordEditRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultPasswordEditRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteCreationRequestedApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultSecureNoteCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultSecureNoteCreationRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultSecureNoteCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteCreationRequestedForEmployeeApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultSecureNoteCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultSecureNoteCreationRequestedForEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultSecureNoteCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteCreationRequestedForGroupApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultSecureNoteCreationRequestedApprovalRequest_1], args_1, true), void 0, function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultSecureNoteCreationRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultSecureNoteCreationRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteDetailsRequestedApprovalRequest} [vaultSecureNoteDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteDetailsRequestedApprovePost: function (vaultSecureNoteDetailsRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultSecureNoteDetailsRequestedApprovalRequest_1], args_1, true), void 0, function (vaultSecureNoteDetailsRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultSecureNoteDetailsRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultSecureNoteDetailsRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteDetailsRequestedApprovalRequest} [vaultSecureNoteDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteDetailsRequestedForGroupApprovePost: function (vaultSecureNoteDetailsRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultSecureNoteDetailsRequestedApprovalRequest_1], args_1, true), void 0, function (vaultSecureNoteDetailsRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultSecureNoteDetailsRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultSecureNoteDetailsRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteDetailsRequestedRejectionRequest} [vaultSecureNoteDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteDetailsRequestedForGroupRejectPost: function (vaultSecureNoteDetailsRequestedRejectionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultSecureNoteDetailsRequestedRejectionRequest_1], args_1, true), void 0, function (vaultSecureNoteDetailsRequestedRejectionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultSecureNoteDetailsRequestedForGroup/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultSecureNoteDetailsRequestedRejectionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteDetailsRequestedRejectionRequest} [vaultSecureNoteDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteDetailsRequestedRejectPost: function (vaultSecureNoteDetailsRequestedRejectionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultSecureNoteDetailsRequestedRejectionRequest_1], args_1, true), void 0, function (vaultSecureNoteDetailsRequestedRejectionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultSecureNoteDetailsRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultSecureNoteDetailsRequestedRejectionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteEditRequestedApprovalRequest} [vaultSecureNoteEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteEditRequestedForEmployeeApprovePost: function (vaultSecureNoteEditRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultSecureNoteEditRequestedApprovalRequest_1], args_1, true), void 0, function (vaultSecureNoteEditRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultSecureNoteEditRequestedForEmployee/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultSecureNoteEditRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteEditRequestedApprovalRequest} [vaultSecureNoteEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteEditRequestedForGroupApprovePost: function (vaultSecureNoteEditRequestedApprovalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultSecureNoteEditRequestedApprovalRequest_1], args_1, true), void 0, function (vaultSecureNoteEditRequestedApprovalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/queue/VaultSecureNoteEditRequestedForGroup/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vaultSecureNoteEditRequestedApprovalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveCreateTrustedBrowserV2Request} [approveCreateTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueCreateTrustedBrowserRequestedApprovePost: function (approveCreateTrustedBrowserV2Request_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveCreateTrustedBrowserV2Request_1], args_1, true), void 0, function (approveCreateTrustedBrowserV2Request, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v2/queue/CreateTrustedBrowserRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveCreateTrustedBrowserV2Request, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectCreateTrustedBrowserV2Request} [rejectCreateTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueCreateTrustedBrowserRequestedRejectPost: function (rejectCreateTrustedBrowserV2Request_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectCreateTrustedBrowserV2Request_1], args_1, true), void 0, function (rejectCreateTrustedBrowserV2Request, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v2/queue/CreateTrustedBrowserRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectCreateTrustedBrowserV2Request, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request} [approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost: function (approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request_1], args_1, true), void 0, function (approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v2/queue/GetVaultPasswordDetailsForGroupViaTrustedBrowserRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request} [rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request_1], args_1, true), void 0, function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v2/queue/GetVaultPasswordDetailsForGroupViaTrustedBrowserRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveGetVaultPasswordDetailsViaTrustedBrowserV2Request} [approveGetVaultPasswordDetailsViaTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost: function (approveGetVaultPasswordDetailsViaTrustedBrowserV2Request_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([approveGetVaultPasswordDetailsViaTrustedBrowserV2Request_1], args_1, true), void 0, function (approveGetVaultPasswordDetailsViaTrustedBrowserV2Request, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v2/queue/GetVaultPasswordDetailsViaTrustedBrowserRequested/Approve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(approveGetVaultPasswordDetailsViaTrustedBrowserV2Request, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsViaTrustedBrowserV2Request} [rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request_1], args_1, true), void 0, function (rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v2/queue/GetVaultPasswordDetailsViaTrustedBrowserRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueQueueCommonGetAdminQueueMessagesGet: function (quantity_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([quantity_1], args_1, true), void 0, function (quantity, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'quantity' is not null or undefined
                            (0, common_1.assertParamExists)('apiV2QueueQueueCommonGetAdminQueueMessagesGet', 'quantity', quantity);
                            localVarPath = "/api/v2/queue/QueueCommon/GetAdminQueueMessages";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (quantity !== undefined) {
                                localVarQueryParameter['Quantity'] = quantity;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} quantity
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueQueueCommonGetUserQueueMessagesGet: function (quantity_1, deviceId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([quantity_1, deviceId_1], args_1, true), void 0, function (quantity, deviceId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'quantity' is not null or undefined
                            (0, common_1.assertParamExists)('apiV2QueueQueueCommonGetUserQueueMessagesGet', 'quantity', quantity);
                            // verify required parameter 'deviceId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV2QueueQueueCommonGetUserQueueMessagesGet', 'deviceId', deviceId);
                            localVarPath = "/api/v2/queue/QueueCommon/GetUserQueueMessages";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (quantity !== undefined) {
                                localVarQueryParameter['Quantity'] = quantity;
                            }
                            if (deviceId !== undefined) {
                                localVarQueryParameter['DeviceId'] = deviceId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request} [rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request_1], args_1, true), void 0, function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v3/queue/GetVaultPasswordDetailsForGroupViaTrustedBrowserRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsViaTrustedBrowserV3Request} [rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request_1], args_1, true), void 0, function (rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v3/queue/GetVaultPasswordDetailsViaTrustedBrowserRequested/Reject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.QueueApiAxiosParamCreator = QueueApiAxiosParamCreator;
/**
 * QueueApi - functional programming interface
 * @export
 */
var QueueApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.QueueApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {AddToEmployeeRequestedApprovalRequest} [addToEmployeeRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAddRequestedForEmployeeApprovePost: function (addToEmployeeRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueAddRequestedForEmployeeApprovePost(addToEmployeeRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AddToEmployeeRequestedRejectRequest} [addToEmployeeRequestedRejectRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAddRequestedForEmployeeRejectPost: function (addToEmployeeRequestedRejectRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueAddRequestedForEmployeeRejectPost(addToEmployeeRequestedRejectRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AddToGroupRequestedApprovalRequest} [addToGroupRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAddRequestedForGroupApprovePost: function (addToGroupRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueAddRequestedForGroupApprovePost(addToGroupRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AddToGroupRequestedRejectRequest} [addToGroupRequestedRejectRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAddRequestedForGroupRejectPost: function (addToGroupRequestedRejectRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueAddRequestedForGroupRejectPost(addToGroupRequestedRejectRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AddToEmployeeRequestedApprovalRequest} [addToEmployeeRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminAddRequestedForEmployeeApprovePost: function (addToEmployeeRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueAdminAddRequestedForEmployeeApprovePost(addToEmployeeRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AddToGroupRequestedApprovalRequest} [addToGroupRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminAddRequestedForGroupApprovePost: function (addToGroupRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueAdminAddRequestedForGroupApprovePost(addToGroupRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultCreditCardCreationRequestedForEmployeeApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueAdminVaultCreditCardCreationRequestedForEmployeeApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultCreditCardCreationRequestedForGroupApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueAdminVaultCreditCardCreationRequestedForGroupApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultPasswordCreationRequestedForEmployeeApprovePost: function (vaultPasswordCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueAdminVaultPasswordCreationRequestedForEmployeeApprovePost(vaultPasswordCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultPasswordCreationRequestedForGroupApprovePost: function (vaultPasswordCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueAdminVaultPasswordCreationRequestedForGroupApprovePost(vaultPasswordCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultSecureNoteCreationRequestedForEmployeeApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueAdminVaultSecureNoteCreationRequestedForEmployeeApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultSecureNoteCreationRequestedForGroupApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueAdminVaultSecureNoteCreationRequestedForGroupApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveCreateTrustedBrowserRequest} [approveCreateTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueCreateTrustedBrowserRequestedApprovePost: function (approveCreateTrustedBrowserRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueCreateTrustedBrowserRequestedApprovePost(approveCreateTrustedBrowserRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectCreateTrustedBrowserRequest} [rejectCreateTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueCreateTrustedBrowserRequestedRejectPost: function (rejectCreateTrustedBrowserRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueCreateTrustedBrowserRequestedRejectPost(rejectCreateTrustedBrowserRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveDeleteVaultRequest} [approveDeleteVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeleteVaultApprovePost: function (approveDeleteVaultRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueDeleteVaultApprovePost(approveDeleteVaultRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectDeleteVaultRequest} [rejectDeleteVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeleteVaultRejectPost: function (rejectDeleteVaultRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueDeleteVaultRejectPost(rejectDeleteVaultRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteBulkVaultsApprovalRequest} [deleteBulkVaultsApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionBulkVaultsRequestedApprovePost: function (deleteBulkVaultsApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueDeletionBulkVaultsRequestedApprovePost(deleteBulkVaultsApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteBulkVaultsRejectRequest} [deleteBulkVaultsRejectRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionBulkVaultsRequestedRejectPost: function (deleteBulkVaultsRejectRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueDeletionBulkVaultsRequestedRejectPost(deleteBulkVaultsRejectRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DeletionRequestedApprovalRequest} [deletionRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionForEmployeeRequestedApprovePost: function (deletionRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueDeletionForEmployeeRequestedApprovePost(deletionRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DeletionRequestedRejectionRequest} [deletionRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionForEmployeeRequestedRejectPost: function (deletionRequestedRejectionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueDeletionForEmployeeRequestedRejectPost(deletionRequestedRejectionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DeletionRequestedApprovalRequest} [deletionRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionForGroupRequestedApprovePost: function (deletionRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueDeletionForGroupRequestedApprovePost(deletionRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DeletionRequestedRejectionRequest} [deletionRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionForGroupRequestedRejectPost: function (deletionRequestedRejectionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueDeletionForGroupRequestedRejectPost(deletionRequestedRejectionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveExportVaultPasswordsRequest} [approveExportVaultPasswordsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueExportVaultPasswordsApprovePost: function (approveExportVaultPasswordsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueExportVaultPasswordsApprovePost(approveExportVaultPasswordsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectExportVaultPasswordsRequest} [rejectExportVaultPasswordsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueExportVaultPasswordsRejectPost: function (rejectExportVaultPasswordsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueExportVaultPasswordsRejectPost(rejectExportVaultPasswordsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveFixEmployeePrivateKeysRequest} [approveFixEmployeePrivateKeysRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueFixEmployeePrivateKeysApprovePost: function (approveFixEmployeePrivateKeysRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueFixEmployeePrivateKeysApprovePost(approveFixEmployeePrivateKeysRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateFixEmployeePrivateKeysRequest} [createFixEmployeePrivateKeysRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueFixEmployeePrivateKeysCreatePost: function (createFixEmployeePrivateKeysRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueFixEmployeePrivateKeysCreatePost(createFixEmployeePrivateKeysRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest} [approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost: function (approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost(approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest} [rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveGetVaultPasswordDetailsViaTrustedBrowserRequest} [approveGetVaultPasswordDetailsViaTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost: function (approveGetVaultPasswordDetailsViaTrustedBrowserRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost(approveGetVaultPasswordDetailsViaTrustedBrowserRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsViaTrustedBrowserRequest} [rejectGetVaultPasswordDetailsViaTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsViaTrustedBrowserRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsViaTrustedBrowserRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMasterPasswordResetRequestRequest} [approveMasterPasswordResetRequestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMasterPasswordResetRequestApprovePost: function (approveMasterPasswordResetRequestRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueMasterPasswordResetRequestApprovePost(approveMasterPasswordResetRequestRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultBetweenEmployeeRequest} [approveMoveVaultBetweenEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultBetweenEmployeesApprovePost: function (approveMoveVaultBetweenEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueMoveVaultBetweenEmployeesApprovePost(approveMoveVaultBetweenEmployeeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultBetweenGroupsRequest} [approveMoveVaultBetweenGroupsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultBetweenGroupsApprovePost: function (approveMoveVaultBetweenGroupsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueMoveVaultBetweenGroupsApprovePost(approveMoveVaultBetweenGroupsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultFromEmployeeToGroupRequest} [approveMoveVaultFromEmployeeToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultFromEmployeeToGroupApprovePost: function (approveMoveVaultFromEmployeeToGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueMoveVaultFromEmployeeToGroupApprovePost(approveMoveVaultFromEmployeeToGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultToEmployeeOrganizationKeychainRequest} [approveMoveVaultToEmployeeOrganizationKeychainRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultToEmployeeOrganizationKeychainApprovePost: function (approveMoveVaultToEmployeeOrganizationKeychainRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueMoveVaultToEmployeeOrganizationKeychainApprovePost(approveMoveVaultToEmployeeOrganizationKeychainRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultToGroupRequest} [approveMoveVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultToGroupApprovePost: function (approveMoveVaultToGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueMoveVaultToGroupApprovePost(approveMoveVaultToGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultToGroupOrganizationKeychainRequest} [approveMoveVaultToGroupOrganizationKeychainRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultToGroupOrganizationKeychainApprovePost: function (approveMoveVaultToGroupOrganizationKeychainRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueMoveVaultToGroupOrganizationKeychainApprovePost(approveMoveVaultToGroupOrganizationKeychainRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveMoveVaultToPrivateKeychainRequest} [approveMoveVaultToPrivateKeychainRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultToPrivateKeychainApprovePost: function (approveMoveVaultToPrivateKeychainRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueMoveVaultToPrivateKeychainApprovePost(approveMoveVaultToPrivateKeychainRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {PartnerSupportRequestApprovalRequest} [partnerSupportRequestApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueuePartnerSupportRequestApprovePost: function (partnerSupportRequestApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueuePartnerSupportRequestApprovePost(partnerSupportRequestApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveProcessEmployeeAsExistingUserRequest} [approveProcessEmployeeAsExistingUserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessEmployeeAsExistingUserApprovePost: function (approveProcessEmployeeAsExistingUserRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueProcessEmployeeAsExistingUserApprovePost(approveProcessEmployeeAsExistingUserRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveProcessFirstAdminAsExistingUser} [approveProcessFirstAdminAsExistingUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessFirstAdminAsExistingUserApprovePost: function (approveProcessFirstAdminAsExistingUser, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueProcessFirstAdminAsExistingUserApprovePost(approveProcessFirstAdminAsExistingUser, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveProcessInviteEmployeeRequest} [approveProcessInviteEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessInviteEmployeeApprovePost: function (approveProcessInviteEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueProcessInviteEmployeeApprovePost(approveProcessInviteEmployeeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveProcessMigratedEmployeeRequest} [approveProcessMigratedEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessMigratedEmployeeApprovePost: function (approveProcessMigratedEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueProcessMigratedEmployeeApprovePost(approveProcessMigratedEmployeeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveProcessNewEmployeeRequest} [approveProcessNewEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessNewEmployeeApprovePost: function (approveProcessNewEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueProcessNewEmployeeApprovePost(approveProcessNewEmployeeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {FailProcessNewEmployeeRequest} [failProcessNewEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessNewEmployeeFailPost: function (failProcessNewEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueProcessNewEmployeeFailPost(failProcessNewEmployeeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApprovePromoteAdminRequest} [approvePromoteAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueuePromoteAdminApprovePost: function (approvePromoteAdminRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueuePromoteAdminApprovePost(approvePromoteAdminRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectPromoteAdminRequest} [rejectPromoteAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueuePromoteAdminRejectPost: function (rejectPromoteAdminRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueuePromoteAdminRejectPost(rejectPromoteAdminRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveQueueRequest} [approveQueueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonApprovePost: function (approveQueueRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueQueueCommonApprovePost(approveQueueRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} queueMessageId
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonCheckIfAvailableGet: function (queueMessageId, deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueQueueCommonCheckIfAvailableGet(queueMessageId, deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {FailQueueRequest} [failQueueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonFailPost: function (failQueueRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueQueueCommonFailPost(failQueueRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} quantity
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonGetQueueMessagesGet: function (quantity, deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueQueueCommonGetQueueMessagesGet(quantity, deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectQueueRequest} [rejectQueueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonRejectPost: function (rejectQueueRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueQueueCommonRejectPost(rejectQueueRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveRevokeAdminRequest} [approveRevokeAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeAdminApprovePost: function (approveRevokeAdminRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueRevokeAdminApprovePost(approveRevokeAdminRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectRevokeAdminRequest} [rejectRevokeAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeAdminRejectPost: function (rejectRevokeAdminRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueRevokeAdminRejectPost(rejectRevokeAdminRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveRevokeSharedVaultRequest} [approveRevokeSharedVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeSharedVaultApprovePost: function (approveRevokeSharedVaultRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueRevokeSharedVaultApprovePost(approveRevokeSharedVaultRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectRevokeSharedVaultRequest} [rejectRevokeSharedVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeSharedVaultRejectPost: function (rejectRevokeSharedVaultRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueRevokeSharedVaultRejectPost(rejectRevokeSharedVaultRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveRevokeVaultSharingRequest} [approveRevokeVaultSharingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeVaultSharingApprovePost: function (approveRevokeVaultSharingRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueRevokeVaultSharingApprovePost(approveRevokeVaultSharingRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectRevokeVaultSharingRequest} [rejectRevokeVaultSharingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeVaultSharingRejectPost: function (rejectRevokeVaultSharingRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueRevokeVaultSharingRejectPost(rejectRevokeVaultSharingRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveShareGroupSecretWithEmployeeAccountRequest} [approveShareGroupSecretWithEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueShareGroupSecretWithEmployeeAccountApprovePost: function (approveShareGroupSecretWithEmployeeAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueShareGroupSecretWithEmployeeAccountApprovePost(approveShareGroupSecretWithEmployeeAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveTrustedPortalRequestedRequest} [approveTrustedPortalRequestedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueTrustedPortalRequestedApprovePost: function (approveTrustedPortalRequestedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueTrustedPortalRequestedApprovePost(approveTrustedPortalRequestedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectTrustedPortalRequestedRequest} [rejectTrustedPortalRequestedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueTrustedPortalRequestedRejectPost: function (rejectTrustedPortalRequestedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueTrustedPortalRequestedRejectPost(rejectTrustedPortalRequestedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardCreationRequestedApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultCreditCardCreationRequestedApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardCreationRequestedForEmployeeApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultCreditCardCreationRequestedForEmployeeApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardCreationRequestedForGroupApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultCreditCardCreationRequestedForGroupApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardDetailsRequestedApprovalRequest} [vaultCreditCardDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardDetailsRequestedApprovePost: function (vaultCreditCardDetailsRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultCreditCardDetailsRequestedApprovePost(vaultCreditCardDetailsRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardDetailsRequestedApprovalRequest} [vaultCreditCardDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardDetailsRequestedForGroupApprovePost: function (vaultCreditCardDetailsRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultCreditCardDetailsRequestedForGroupApprovePost(vaultCreditCardDetailsRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardDetailsRequestedRejectionRequest} [vaultCreditCardDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardDetailsRequestedForGroupRejectPost: function (vaultCreditCardDetailsRequestedRejectionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultCreditCardDetailsRequestedForGroupRejectPost(vaultCreditCardDetailsRequestedRejectionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardDetailsRequestedRejectionRequest} [vaultCreditCardDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardDetailsRequestedRejectPost: function (vaultCreditCardDetailsRequestedRejectionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultCreditCardDetailsRequestedRejectPost(vaultCreditCardDetailsRequestedRejectionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardEditRequestedApprovalRequest} [vaultCreditCardEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardEditRequestedForEmployeeApprovePost: function (vaultCreditCardEditRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultCreditCardEditRequestedForEmployeeApprovePost(vaultCreditCardEditRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultCreditCardEditRequestedApprovalRequest} [vaultCreditCardEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardEditRequestedForGroupApprovePost: function (vaultCreditCardEditRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultCreditCardEditRequestedForGroupApprovePost(vaultCreditCardEditRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedUnmanagedApprovalRequest} [vaultPasswordCreationRequestedUnmanagedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordCreationRequestedApprovePost: function (vaultPasswordCreationRequestedUnmanagedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultPasswordCreationRequestedApprovePost(vaultPasswordCreationRequestedUnmanagedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordCreationRequestedForEmployeeApprovePost: function (vaultPasswordCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultPasswordCreationRequestedForEmployeeApprovePost(vaultPasswordCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordCreationRequestedForGroupApprovePost: function (vaultPasswordCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultPasswordCreationRequestedForGroupApprovePost(vaultPasswordCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordDetailsRequestedApprovalRequest} [vaultPasswordDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordDetailsRequestedApprovePost: function (vaultPasswordDetailsRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultPasswordDetailsRequestedApprovePost(vaultPasswordDetailsRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordDetailsRequestedApprovalRequest} [vaultPasswordDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordDetailsRequestedForGroupApprovePost: function (vaultPasswordDetailsRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultPasswordDetailsRequestedForGroupApprovePost(vaultPasswordDetailsRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordDetailsRequestedRejectionRequest} [vaultPasswordDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordDetailsRequestedForGroupRejectPost: function (vaultPasswordDetailsRequestedRejectionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultPasswordDetailsRequestedForGroupRejectPost(vaultPasswordDetailsRequestedRejectionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordDetailsRequestedRejectionRequest} [vaultPasswordDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordDetailsRequestedRejectPost: function (vaultPasswordDetailsRequestedRejectionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultPasswordDetailsRequestedRejectPost(vaultPasswordDetailsRequestedRejectionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordEditRequestedApprovalRequest} [vaultPasswordEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordEditRequestedForEmployeeApprovePost: function (vaultPasswordEditRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultPasswordEditRequestedForEmployeeApprovePost(vaultPasswordEditRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultPasswordEditRequestedApprovalRequest} [vaultPasswordEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordEditRequestedForGroupApprovePost: function (vaultPasswordEditRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultPasswordEditRequestedForGroupApprovePost(vaultPasswordEditRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteCreationRequestedApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultSecureNoteCreationRequestedApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteCreationRequestedForEmployeeApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultSecureNoteCreationRequestedForEmployeeApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteCreationRequestedForGroupApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultSecureNoteCreationRequestedForGroupApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteDetailsRequestedApprovalRequest} [vaultSecureNoteDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteDetailsRequestedApprovePost: function (vaultSecureNoteDetailsRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultSecureNoteDetailsRequestedApprovePost(vaultSecureNoteDetailsRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteDetailsRequestedApprovalRequest} [vaultSecureNoteDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteDetailsRequestedForGroupApprovePost: function (vaultSecureNoteDetailsRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultSecureNoteDetailsRequestedForGroupApprovePost(vaultSecureNoteDetailsRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteDetailsRequestedRejectionRequest} [vaultSecureNoteDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteDetailsRequestedForGroupRejectPost: function (vaultSecureNoteDetailsRequestedRejectionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultSecureNoteDetailsRequestedForGroupRejectPost(vaultSecureNoteDetailsRequestedRejectionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteDetailsRequestedRejectionRequest} [vaultSecureNoteDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteDetailsRequestedRejectPost: function (vaultSecureNoteDetailsRequestedRejectionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultSecureNoteDetailsRequestedRejectPost(vaultSecureNoteDetailsRequestedRejectionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteEditRequestedApprovalRequest} [vaultSecureNoteEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteEditRequestedForEmployeeApprovePost: function (vaultSecureNoteEditRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultSecureNoteEditRequestedForEmployeeApprovePost(vaultSecureNoteEditRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {VaultSecureNoteEditRequestedApprovalRequest} [vaultSecureNoteEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteEditRequestedForGroupApprovePost: function (vaultSecureNoteEditRequestedApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueVaultSecureNoteEditRequestedForGroupApprovePost(vaultSecureNoteEditRequestedApprovalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveCreateTrustedBrowserV2Request} [approveCreateTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueCreateTrustedBrowserRequestedApprovePost: function (approveCreateTrustedBrowserV2Request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2QueueCreateTrustedBrowserRequestedApprovePost(approveCreateTrustedBrowserV2Request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectCreateTrustedBrowserV2Request} [rejectCreateTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueCreateTrustedBrowserRequestedRejectPost: function (rejectCreateTrustedBrowserV2Request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2QueueCreateTrustedBrowserRequestedRejectPost(rejectCreateTrustedBrowserV2Request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request} [approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost: function (approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost(approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request} [rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ApproveGetVaultPasswordDetailsViaTrustedBrowserV2Request} [approveGetVaultPasswordDetailsViaTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost: function (approveGetVaultPasswordDetailsViaTrustedBrowserV2Request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost(approveGetVaultPasswordDetailsViaTrustedBrowserV2Request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsViaTrustedBrowserV2Request} [rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueQueueCommonGetAdminQueueMessagesGet: function (quantity, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2QueueQueueCommonGetAdminQueueMessagesGet(quantity, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} quantity
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueQueueCommonGetUserQueueMessagesGet: function (quantity, deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2QueueQueueCommonGetUserQueueMessagesGet(quantity, deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request} [rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV3QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsViaTrustedBrowserV3Request} [rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV3QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.QueueApiFp = QueueApiFp;
/**
 * QueueApi - factory interface
 * @export
 */
var QueueApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.QueueApiFp)(configuration);
    return {
        /**
         *
         * @param {AddToEmployeeRequestedApprovalRequest} [addToEmployeeRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAddRequestedForEmployeeApprovePost: function (addToEmployeeRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueAddRequestedForEmployeeApprovePost(addToEmployeeRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AddToEmployeeRequestedRejectRequest} [addToEmployeeRequestedRejectRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAddRequestedForEmployeeRejectPost: function (addToEmployeeRequestedRejectRequest, options) {
            return localVarFp.apiV1QueueAddRequestedForEmployeeRejectPost(addToEmployeeRequestedRejectRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AddToGroupRequestedApprovalRequest} [addToGroupRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAddRequestedForGroupApprovePost: function (addToGroupRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueAddRequestedForGroupApprovePost(addToGroupRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AddToGroupRequestedRejectRequest} [addToGroupRequestedRejectRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAddRequestedForGroupRejectPost: function (addToGroupRequestedRejectRequest, options) {
            return localVarFp.apiV1QueueAddRequestedForGroupRejectPost(addToGroupRequestedRejectRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AddToEmployeeRequestedApprovalRequest} [addToEmployeeRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminAddRequestedForEmployeeApprovePost: function (addToEmployeeRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueAdminAddRequestedForEmployeeApprovePost(addToEmployeeRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AddToGroupRequestedApprovalRequest} [addToGroupRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminAddRequestedForGroupApprovePost: function (addToGroupRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueAdminAddRequestedForGroupApprovePost(addToGroupRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultCreditCardCreationRequestedForEmployeeApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueAdminVaultCreditCardCreationRequestedForEmployeeApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultCreditCardCreationRequestedForGroupApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueAdminVaultCreditCardCreationRequestedForGroupApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultPasswordCreationRequestedForEmployeeApprovePost: function (vaultPasswordCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueAdminVaultPasswordCreationRequestedForEmployeeApprovePost(vaultPasswordCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultPasswordCreationRequestedForGroupApprovePost: function (vaultPasswordCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueAdminVaultPasswordCreationRequestedForGroupApprovePost(vaultPasswordCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultSecureNoteCreationRequestedForEmployeeApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueAdminVaultSecureNoteCreationRequestedForEmployeeApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueAdminVaultSecureNoteCreationRequestedForGroupApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueAdminVaultSecureNoteCreationRequestedForGroupApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveCreateTrustedBrowserRequest} [approveCreateTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueCreateTrustedBrowserRequestedApprovePost: function (approveCreateTrustedBrowserRequest, options) {
            return localVarFp.apiV1QueueCreateTrustedBrowserRequestedApprovePost(approveCreateTrustedBrowserRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectCreateTrustedBrowserRequest} [rejectCreateTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueCreateTrustedBrowserRequestedRejectPost: function (rejectCreateTrustedBrowserRequest, options) {
            return localVarFp.apiV1QueueCreateTrustedBrowserRequestedRejectPost(rejectCreateTrustedBrowserRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveDeleteVaultRequest} [approveDeleteVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeleteVaultApprovePost: function (approveDeleteVaultRequest, options) {
            return localVarFp.apiV1QueueDeleteVaultApprovePost(approveDeleteVaultRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectDeleteVaultRequest} [rejectDeleteVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeleteVaultRejectPost: function (rejectDeleteVaultRequest, options) {
            return localVarFp.apiV1QueueDeleteVaultRejectPost(rejectDeleteVaultRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DeleteBulkVaultsApprovalRequest} [deleteBulkVaultsApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionBulkVaultsRequestedApprovePost: function (deleteBulkVaultsApprovalRequest, options) {
            return localVarFp.apiV1QueueDeletionBulkVaultsRequestedApprovePost(deleteBulkVaultsApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DeleteBulkVaultsRejectRequest} [deleteBulkVaultsRejectRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionBulkVaultsRequestedRejectPost: function (deleteBulkVaultsRejectRequest, options) {
            return localVarFp.apiV1QueueDeletionBulkVaultsRequestedRejectPost(deleteBulkVaultsRejectRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DeletionRequestedApprovalRequest} [deletionRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionForEmployeeRequestedApprovePost: function (deletionRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueDeletionForEmployeeRequestedApprovePost(deletionRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DeletionRequestedRejectionRequest} [deletionRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionForEmployeeRequestedRejectPost: function (deletionRequestedRejectionRequest, options) {
            return localVarFp.apiV1QueueDeletionForEmployeeRequestedRejectPost(deletionRequestedRejectionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DeletionRequestedApprovalRequest} [deletionRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionForGroupRequestedApprovePost: function (deletionRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueDeletionForGroupRequestedApprovePost(deletionRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DeletionRequestedRejectionRequest} [deletionRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeletionForGroupRequestedRejectPost: function (deletionRequestedRejectionRequest, options) {
            return localVarFp.apiV1QueueDeletionForGroupRequestedRejectPost(deletionRequestedRejectionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveExportVaultPasswordsRequest} [approveExportVaultPasswordsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueExportVaultPasswordsApprovePost: function (approveExportVaultPasswordsRequest, options) {
            return localVarFp.apiV1QueueExportVaultPasswordsApprovePost(approveExportVaultPasswordsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectExportVaultPasswordsRequest} [rejectExportVaultPasswordsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueExportVaultPasswordsRejectPost: function (rejectExportVaultPasswordsRequest, options) {
            return localVarFp.apiV1QueueExportVaultPasswordsRejectPost(rejectExportVaultPasswordsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveFixEmployeePrivateKeysRequest} [approveFixEmployeePrivateKeysRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueFixEmployeePrivateKeysApprovePost: function (approveFixEmployeePrivateKeysRequest, options) {
            return localVarFp.apiV1QueueFixEmployeePrivateKeysApprovePost(approveFixEmployeePrivateKeysRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateFixEmployeePrivateKeysRequest} [createFixEmployeePrivateKeysRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueFixEmployeePrivateKeysCreatePost: function (createFixEmployeePrivateKeysRequest, options) {
            return localVarFp.apiV1QueueFixEmployeePrivateKeysCreatePost(createFixEmployeePrivateKeysRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest} [approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost: function (approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options) {
            return localVarFp.apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost(approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest} [rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options) {
            return localVarFp.apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveGetVaultPasswordDetailsViaTrustedBrowserRequest} [approveGetVaultPasswordDetailsViaTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost: function (approveGetVaultPasswordDetailsViaTrustedBrowserRequest, options) {
            return localVarFp.apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost(approveGetVaultPasswordDetailsViaTrustedBrowserRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsViaTrustedBrowserRequest} [rejectGetVaultPasswordDetailsViaTrustedBrowserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsViaTrustedBrowserRequest, options) {
            return localVarFp.apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsViaTrustedBrowserRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveMasterPasswordResetRequestRequest} [approveMasterPasswordResetRequestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMasterPasswordResetRequestApprovePost: function (approveMasterPasswordResetRequestRequest, options) {
            return localVarFp.apiV1QueueMasterPasswordResetRequestApprovePost(approveMasterPasswordResetRequestRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveMoveVaultBetweenEmployeeRequest} [approveMoveVaultBetweenEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultBetweenEmployeesApprovePost: function (approveMoveVaultBetweenEmployeeRequest, options) {
            return localVarFp.apiV1QueueMoveVaultBetweenEmployeesApprovePost(approveMoveVaultBetweenEmployeeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveMoveVaultBetweenGroupsRequest} [approveMoveVaultBetweenGroupsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultBetweenGroupsApprovePost: function (approveMoveVaultBetweenGroupsRequest, options) {
            return localVarFp.apiV1QueueMoveVaultBetweenGroupsApprovePost(approveMoveVaultBetweenGroupsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveMoveVaultFromEmployeeToGroupRequest} [approveMoveVaultFromEmployeeToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultFromEmployeeToGroupApprovePost: function (approveMoveVaultFromEmployeeToGroupRequest, options) {
            return localVarFp.apiV1QueueMoveVaultFromEmployeeToGroupApprovePost(approveMoveVaultFromEmployeeToGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveMoveVaultToEmployeeOrganizationKeychainRequest} [approveMoveVaultToEmployeeOrganizationKeychainRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultToEmployeeOrganizationKeychainApprovePost: function (approveMoveVaultToEmployeeOrganizationKeychainRequest, options) {
            return localVarFp.apiV1QueueMoveVaultToEmployeeOrganizationKeychainApprovePost(approveMoveVaultToEmployeeOrganizationKeychainRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveMoveVaultToGroupRequest} [approveMoveVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultToGroupApprovePost: function (approveMoveVaultToGroupRequest, options) {
            return localVarFp.apiV1QueueMoveVaultToGroupApprovePost(approveMoveVaultToGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveMoveVaultToGroupOrganizationKeychainRequest} [approveMoveVaultToGroupOrganizationKeychainRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultToGroupOrganizationKeychainApprovePost: function (approveMoveVaultToGroupOrganizationKeychainRequest, options) {
            return localVarFp.apiV1QueueMoveVaultToGroupOrganizationKeychainApprovePost(approveMoveVaultToGroupOrganizationKeychainRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveMoveVaultToPrivateKeychainRequest} [approveMoveVaultToPrivateKeychainRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueMoveVaultToPrivateKeychainApprovePost: function (approveMoveVaultToPrivateKeychainRequest, options) {
            return localVarFp.apiV1QueueMoveVaultToPrivateKeychainApprovePost(approveMoveVaultToPrivateKeychainRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {PartnerSupportRequestApprovalRequest} [partnerSupportRequestApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueuePartnerSupportRequestApprovePost: function (partnerSupportRequestApprovalRequest, options) {
            return localVarFp.apiV1QueuePartnerSupportRequestApprovePost(partnerSupportRequestApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveProcessEmployeeAsExistingUserRequest} [approveProcessEmployeeAsExistingUserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessEmployeeAsExistingUserApprovePost: function (approveProcessEmployeeAsExistingUserRequest, options) {
            return localVarFp.apiV1QueueProcessEmployeeAsExistingUserApprovePost(approveProcessEmployeeAsExistingUserRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveProcessFirstAdminAsExistingUser} [approveProcessFirstAdminAsExistingUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessFirstAdminAsExistingUserApprovePost: function (approveProcessFirstAdminAsExistingUser, options) {
            return localVarFp.apiV1QueueProcessFirstAdminAsExistingUserApprovePost(approveProcessFirstAdminAsExistingUser, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveProcessInviteEmployeeRequest} [approveProcessInviteEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessInviteEmployeeApprovePost: function (approveProcessInviteEmployeeRequest, options) {
            return localVarFp.apiV1QueueProcessInviteEmployeeApprovePost(approveProcessInviteEmployeeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveProcessMigratedEmployeeRequest} [approveProcessMigratedEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessMigratedEmployeeApprovePost: function (approveProcessMigratedEmployeeRequest, options) {
            return localVarFp.apiV1QueueProcessMigratedEmployeeApprovePost(approveProcessMigratedEmployeeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveProcessNewEmployeeRequest} [approveProcessNewEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessNewEmployeeApprovePost: function (approveProcessNewEmployeeRequest, options) {
            return localVarFp.apiV1QueueProcessNewEmployeeApprovePost(approveProcessNewEmployeeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {FailProcessNewEmployeeRequest} [failProcessNewEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueProcessNewEmployeeFailPost: function (failProcessNewEmployeeRequest, options) {
            return localVarFp.apiV1QueueProcessNewEmployeeFailPost(failProcessNewEmployeeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApprovePromoteAdminRequest} [approvePromoteAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueuePromoteAdminApprovePost: function (approvePromoteAdminRequest, options) {
            return localVarFp.apiV1QueuePromoteAdminApprovePost(approvePromoteAdminRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectPromoteAdminRequest} [rejectPromoteAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueuePromoteAdminRejectPost: function (rejectPromoteAdminRequest, options) {
            return localVarFp.apiV1QueuePromoteAdminRejectPost(rejectPromoteAdminRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveQueueRequest} [approveQueueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonApprovePost: function (approveQueueRequest, options) {
            return localVarFp.apiV1QueueQueueCommonApprovePost(approveQueueRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} queueMessageId
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonCheckIfAvailableGet: function (queueMessageId, deviceId, options) {
            return localVarFp.apiV1QueueQueueCommonCheckIfAvailableGet(queueMessageId, deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {FailQueueRequest} [failQueueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonFailPost: function (failQueueRequest, options) {
            return localVarFp.apiV1QueueQueueCommonFailPost(failQueueRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} quantity
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonGetQueueMessagesGet: function (quantity, deviceId, options) {
            return localVarFp.apiV1QueueQueueCommonGetQueueMessagesGet(quantity, deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectQueueRequest} [rejectQueueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueQueueCommonRejectPost: function (rejectQueueRequest, options) {
            return localVarFp.apiV1QueueQueueCommonRejectPost(rejectQueueRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveRevokeAdminRequest} [approveRevokeAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeAdminApprovePost: function (approveRevokeAdminRequest, options) {
            return localVarFp.apiV1QueueRevokeAdminApprovePost(approveRevokeAdminRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectRevokeAdminRequest} [rejectRevokeAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeAdminRejectPost: function (rejectRevokeAdminRequest, options) {
            return localVarFp.apiV1QueueRevokeAdminRejectPost(rejectRevokeAdminRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveRevokeSharedVaultRequest} [approveRevokeSharedVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeSharedVaultApprovePost: function (approveRevokeSharedVaultRequest, options) {
            return localVarFp.apiV1QueueRevokeSharedVaultApprovePost(approveRevokeSharedVaultRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectRevokeSharedVaultRequest} [rejectRevokeSharedVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeSharedVaultRejectPost: function (rejectRevokeSharedVaultRequest, options) {
            return localVarFp.apiV1QueueRevokeSharedVaultRejectPost(rejectRevokeSharedVaultRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveRevokeVaultSharingRequest} [approveRevokeVaultSharingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeVaultSharingApprovePost: function (approveRevokeVaultSharingRequest, options) {
            return localVarFp.apiV1QueueRevokeVaultSharingApprovePost(approveRevokeVaultSharingRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectRevokeVaultSharingRequest} [rejectRevokeVaultSharingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRevokeVaultSharingRejectPost: function (rejectRevokeVaultSharingRequest, options) {
            return localVarFp.apiV1QueueRevokeVaultSharingRejectPost(rejectRevokeVaultSharingRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveShareGroupSecretWithEmployeeAccountRequest} [approveShareGroupSecretWithEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueShareGroupSecretWithEmployeeAccountApprovePost: function (approveShareGroupSecretWithEmployeeAccountRequest, options) {
            return localVarFp.apiV1QueueShareGroupSecretWithEmployeeAccountApprovePost(approveShareGroupSecretWithEmployeeAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveTrustedPortalRequestedRequest} [approveTrustedPortalRequestedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueTrustedPortalRequestedApprovePost: function (approveTrustedPortalRequestedRequest, options) {
            return localVarFp.apiV1QueueTrustedPortalRequestedApprovePost(approveTrustedPortalRequestedRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectTrustedPortalRequestedRequest} [rejectTrustedPortalRequestedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueTrustedPortalRequestedRejectPost: function (rejectTrustedPortalRequestedRequest, options) {
            return localVarFp.apiV1QueueTrustedPortalRequestedRejectPost(rejectTrustedPortalRequestedRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardCreationRequestedApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultCreditCardCreationRequestedApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardCreationRequestedForEmployeeApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultCreditCardCreationRequestedForEmployeeApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardCreationRequestedForGroupApprovePost: function (vaultCreditCardCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultCreditCardCreationRequestedForGroupApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultCreditCardDetailsRequestedApprovalRequest} [vaultCreditCardDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardDetailsRequestedApprovePost: function (vaultCreditCardDetailsRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultCreditCardDetailsRequestedApprovePost(vaultCreditCardDetailsRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultCreditCardDetailsRequestedApprovalRequest} [vaultCreditCardDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardDetailsRequestedForGroupApprovePost: function (vaultCreditCardDetailsRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultCreditCardDetailsRequestedForGroupApprovePost(vaultCreditCardDetailsRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultCreditCardDetailsRequestedRejectionRequest} [vaultCreditCardDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardDetailsRequestedForGroupRejectPost: function (vaultCreditCardDetailsRequestedRejectionRequest, options) {
            return localVarFp.apiV1QueueVaultCreditCardDetailsRequestedForGroupRejectPost(vaultCreditCardDetailsRequestedRejectionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultCreditCardDetailsRequestedRejectionRequest} [vaultCreditCardDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardDetailsRequestedRejectPost: function (vaultCreditCardDetailsRequestedRejectionRequest, options) {
            return localVarFp.apiV1QueueVaultCreditCardDetailsRequestedRejectPost(vaultCreditCardDetailsRequestedRejectionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultCreditCardEditRequestedApprovalRequest} [vaultCreditCardEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardEditRequestedForEmployeeApprovePost: function (vaultCreditCardEditRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultCreditCardEditRequestedForEmployeeApprovePost(vaultCreditCardEditRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultCreditCardEditRequestedApprovalRequest} [vaultCreditCardEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultCreditCardEditRequestedForGroupApprovePost: function (vaultCreditCardEditRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultCreditCardEditRequestedForGroupApprovePost(vaultCreditCardEditRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedUnmanagedApprovalRequest} [vaultPasswordCreationRequestedUnmanagedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordCreationRequestedApprovePost: function (vaultPasswordCreationRequestedUnmanagedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultPasswordCreationRequestedApprovePost(vaultPasswordCreationRequestedUnmanagedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordCreationRequestedForEmployeeApprovePost: function (vaultPasswordCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultPasswordCreationRequestedForEmployeeApprovePost(vaultPasswordCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordCreationRequestedForGroupApprovePost: function (vaultPasswordCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultPasswordCreationRequestedForGroupApprovePost(vaultPasswordCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultPasswordDetailsRequestedApprovalRequest} [vaultPasswordDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordDetailsRequestedApprovePost: function (vaultPasswordDetailsRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultPasswordDetailsRequestedApprovePost(vaultPasswordDetailsRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultPasswordDetailsRequestedApprovalRequest} [vaultPasswordDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordDetailsRequestedForGroupApprovePost: function (vaultPasswordDetailsRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultPasswordDetailsRequestedForGroupApprovePost(vaultPasswordDetailsRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultPasswordDetailsRequestedRejectionRequest} [vaultPasswordDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordDetailsRequestedForGroupRejectPost: function (vaultPasswordDetailsRequestedRejectionRequest, options) {
            return localVarFp.apiV1QueueVaultPasswordDetailsRequestedForGroupRejectPost(vaultPasswordDetailsRequestedRejectionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultPasswordDetailsRequestedRejectionRequest} [vaultPasswordDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordDetailsRequestedRejectPost: function (vaultPasswordDetailsRequestedRejectionRequest, options) {
            return localVarFp.apiV1QueueVaultPasswordDetailsRequestedRejectPost(vaultPasswordDetailsRequestedRejectionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultPasswordEditRequestedApprovalRequest} [vaultPasswordEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordEditRequestedForEmployeeApprovePost: function (vaultPasswordEditRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultPasswordEditRequestedForEmployeeApprovePost(vaultPasswordEditRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultPasswordEditRequestedApprovalRequest} [vaultPasswordEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultPasswordEditRequestedForGroupApprovePost: function (vaultPasswordEditRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultPasswordEditRequestedForGroupApprovePost(vaultPasswordEditRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteCreationRequestedApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultSecureNoteCreationRequestedApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteCreationRequestedForEmployeeApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultSecureNoteCreationRequestedForEmployeeApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteCreationRequestedForGroupApprovePost: function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultSecureNoteCreationRequestedForGroupApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultSecureNoteDetailsRequestedApprovalRequest} [vaultSecureNoteDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteDetailsRequestedApprovePost: function (vaultSecureNoteDetailsRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultSecureNoteDetailsRequestedApprovePost(vaultSecureNoteDetailsRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultSecureNoteDetailsRequestedApprovalRequest} [vaultSecureNoteDetailsRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteDetailsRequestedForGroupApprovePost: function (vaultSecureNoteDetailsRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultSecureNoteDetailsRequestedForGroupApprovePost(vaultSecureNoteDetailsRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultSecureNoteDetailsRequestedRejectionRequest} [vaultSecureNoteDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteDetailsRequestedForGroupRejectPost: function (vaultSecureNoteDetailsRequestedRejectionRequest, options) {
            return localVarFp.apiV1QueueVaultSecureNoteDetailsRequestedForGroupRejectPost(vaultSecureNoteDetailsRequestedRejectionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultSecureNoteDetailsRequestedRejectionRequest} [vaultSecureNoteDetailsRequestedRejectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteDetailsRequestedRejectPost: function (vaultSecureNoteDetailsRequestedRejectionRequest, options) {
            return localVarFp.apiV1QueueVaultSecureNoteDetailsRequestedRejectPost(vaultSecureNoteDetailsRequestedRejectionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultSecureNoteEditRequestedApprovalRequest} [vaultSecureNoteEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteEditRequestedForEmployeeApprovePost: function (vaultSecureNoteEditRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultSecureNoteEditRequestedForEmployeeApprovePost(vaultSecureNoteEditRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {VaultSecureNoteEditRequestedApprovalRequest} [vaultSecureNoteEditRequestedApprovalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueVaultSecureNoteEditRequestedForGroupApprovePost: function (vaultSecureNoteEditRequestedApprovalRequest, options) {
            return localVarFp.apiV1QueueVaultSecureNoteEditRequestedForGroupApprovePost(vaultSecureNoteEditRequestedApprovalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveCreateTrustedBrowserV2Request} [approveCreateTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueCreateTrustedBrowserRequestedApprovePost: function (approveCreateTrustedBrowserV2Request, options) {
            return localVarFp.apiV2QueueCreateTrustedBrowserRequestedApprovePost(approveCreateTrustedBrowserV2Request, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectCreateTrustedBrowserV2Request} [rejectCreateTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueCreateTrustedBrowserRequestedRejectPost: function (rejectCreateTrustedBrowserV2Request, options) {
            return localVarFp.apiV2QueueCreateTrustedBrowserRequestedRejectPost(rejectCreateTrustedBrowserV2Request, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request} [approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost: function (approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options) {
            return localVarFp.apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost(approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request} [rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options) {
            return localVarFp.apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ApproveGetVaultPasswordDetailsViaTrustedBrowserV2Request} [approveGetVaultPasswordDetailsViaTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost: function (approveGetVaultPasswordDetailsViaTrustedBrowserV2Request, options) {
            return localVarFp.apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost(approveGetVaultPasswordDetailsViaTrustedBrowserV2Request, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsViaTrustedBrowserV2Request} [rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request, options) {
            return localVarFp.apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} quantity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueQueueCommonGetAdminQueueMessagesGet: function (quantity, options) {
            return localVarFp.apiV2QueueQueueCommonGetAdminQueueMessagesGet(quantity, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} quantity
         * @param {string} deviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2QueueQueueCommonGetUserQueueMessagesGet: function (quantity, deviceId, options) {
            return localVarFp.apiV2QueueQueueCommonGetUserQueueMessagesGet(quantity, deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request} [rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request, options) {
            return localVarFp.apiV3QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RejectGetVaultPasswordDetailsViaTrustedBrowserV3Request} [rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost: function (rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request, options) {
            return localVarFp.apiV3QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.QueueApiFactory = QueueApiFactory;
/**
 * QueueApi - object-oriented interface
 * @export
 * @class QueueApi
 * @extends {BaseAPI}
 */
var QueueApi = /** @class */ (function (_super) {
    __extends(QueueApi, _super);
    function QueueApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {AddToEmployeeRequestedApprovalRequest} [addToEmployeeRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueAddRequestedForEmployeeApprovePost = function (addToEmployeeRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueAddRequestedForEmployeeApprovePost(addToEmployeeRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AddToEmployeeRequestedRejectRequest} [addToEmployeeRequestedRejectRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueAddRequestedForEmployeeRejectPost = function (addToEmployeeRequestedRejectRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueAddRequestedForEmployeeRejectPost(addToEmployeeRequestedRejectRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AddToGroupRequestedApprovalRequest} [addToGroupRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueAddRequestedForGroupApprovePost = function (addToGroupRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueAddRequestedForGroupApprovePost(addToGroupRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AddToGroupRequestedRejectRequest} [addToGroupRequestedRejectRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueAddRequestedForGroupRejectPost = function (addToGroupRequestedRejectRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueAddRequestedForGroupRejectPost(addToGroupRequestedRejectRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AddToEmployeeRequestedApprovalRequest} [addToEmployeeRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueAdminAddRequestedForEmployeeApprovePost = function (addToEmployeeRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueAdminAddRequestedForEmployeeApprovePost(addToEmployeeRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AddToGroupRequestedApprovalRequest} [addToGroupRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueAdminAddRequestedForGroupApprovePost = function (addToGroupRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueAdminAddRequestedForGroupApprovePost(addToGroupRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueAdminVaultCreditCardCreationRequestedForEmployeeApprovePost = function (vaultCreditCardCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueAdminVaultCreditCardCreationRequestedForEmployeeApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueAdminVaultCreditCardCreationRequestedForGroupApprovePost = function (vaultCreditCardCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueAdminVaultCreditCardCreationRequestedForGroupApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueAdminVaultPasswordCreationRequestedForEmployeeApprovePost = function (vaultPasswordCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueAdminVaultPasswordCreationRequestedForEmployeeApprovePost(vaultPasswordCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueAdminVaultPasswordCreationRequestedForGroupApprovePost = function (vaultPasswordCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueAdminVaultPasswordCreationRequestedForGroupApprovePost(vaultPasswordCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueAdminVaultSecureNoteCreationRequestedForEmployeeApprovePost = function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueAdminVaultSecureNoteCreationRequestedForEmployeeApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueAdminVaultSecureNoteCreationRequestedForGroupApprovePost = function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueAdminVaultSecureNoteCreationRequestedForGroupApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveCreateTrustedBrowserRequest} [approveCreateTrustedBrowserRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueCreateTrustedBrowserRequestedApprovePost = function (approveCreateTrustedBrowserRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueCreateTrustedBrowserRequestedApprovePost(approveCreateTrustedBrowserRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectCreateTrustedBrowserRequest} [rejectCreateTrustedBrowserRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueCreateTrustedBrowserRequestedRejectPost = function (rejectCreateTrustedBrowserRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueCreateTrustedBrowserRequestedRejectPost(rejectCreateTrustedBrowserRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveDeleteVaultRequest} [approveDeleteVaultRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueDeleteVaultApprovePost = function (approveDeleteVaultRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueDeleteVaultApprovePost(approveDeleteVaultRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectDeleteVaultRequest} [rejectDeleteVaultRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueDeleteVaultRejectPost = function (rejectDeleteVaultRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueDeleteVaultRejectPost(rejectDeleteVaultRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DeleteBulkVaultsApprovalRequest} [deleteBulkVaultsApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueDeletionBulkVaultsRequestedApprovePost = function (deleteBulkVaultsApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueDeletionBulkVaultsRequestedApprovePost(deleteBulkVaultsApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DeleteBulkVaultsRejectRequest} [deleteBulkVaultsRejectRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueDeletionBulkVaultsRequestedRejectPost = function (deleteBulkVaultsRejectRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueDeletionBulkVaultsRequestedRejectPost(deleteBulkVaultsRejectRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DeletionRequestedApprovalRequest} [deletionRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueDeletionForEmployeeRequestedApprovePost = function (deletionRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueDeletionForEmployeeRequestedApprovePost(deletionRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DeletionRequestedRejectionRequest} [deletionRequestedRejectionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueDeletionForEmployeeRequestedRejectPost = function (deletionRequestedRejectionRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueDeletionForEmployeeRequestedRejectPost(deletionRequestedRejectionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DeletionRequestedApprovalRequest} [deletionRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueDeletionForGroupRequestedApprovePost = function (deletionRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueDeletionForGroupRequestedApprovePost(deletionRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DeletionRequestedRejectionRequest} [deletionRequestedRejectionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueDeletionForGroupRequestedRejectPost = function (deletionRequestedRejectionRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueDeletionForGroupRequestedRejectPost(deletionRequestedRejectionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveExportVaultPasswordsRequest} [approveExportVaultPasswordsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueExportVaultPasswordsApprovePost = function (approveExportVaultPasswordsRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueExportVaultPasswordsApprovePost(approveExportVaultPasswordsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectExportVaultPasswordsRequest} [rejectExportVaultPasswordsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueExportVaultPasswordsRejectPost = function (rejectExportVaultPasswordsRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueExportVaultPasswordsRejectPost(rejectExportVaultPasswordsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveFixEmployeePrivateKeysRequest} [approveFixEmployeePrivateKeysRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueFixEmployeePrivateKeysApprovePost = function (approveFixEmployeePrivateKeysRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueFixEmployeePrivateKeysApprovePost(approveFixEmployeePrivateKeysRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateFixEmployeePrivateKeysRequest} [createFixEmployeePrivateKeysRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueFixEmployeePrivateKeysCreatePost = function (createFixEmployeePrivateKeysRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueFixEmployeePrivateKeysCreatePost(createFixEmployeePrivateKeysRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest} [approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost = function (approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost(approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest} [rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost = function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveGetVaultPasswordDetailsViaTrustedBrowserRequest} [approveGetVaultPasswordDetailsViaTrustedBrowserRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost = function (approveGetVaultPasswordDetailsViaTrustedBrowserRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost(approveGetVaultPasswordDetailsViaTrustedBrowserRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectGetVaultPasswordDetailsViaTrustedBrowserRequest} [rejectGetVaultPasswordDetailsViaTrustedBrowserRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost = function (rejectGetVaultPasswordDetailsViaTrustedBrowserRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsViaTrustedBrowserRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveMasterPasswordResetRequestRequest} [approveMasterPasswordResetRequestRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueMasterPasswordResetRequestApprovePost = function (approveMasterPasswordResetRequestRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueMasterPasswordResetRequestApprovePost(approveMasterPasswordResetRequestRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveMoveVaultBetweenEmployeeRequest} [approveMoveVaultBetweenEmployeeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueMoveVaultBetweenEmployeesApprovePost = function (approveMoveVaultBetweenEmployeeRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueMoveVaultBetweenEmployeesApprovePost(approveMoveVaultBetweenEmployeeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveMoveVaultBetweenGroupsRequest} [approveMoveVaultBetweenGroupsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueMoveVaultBetweenGroupsApprovePost = function (approveMoveVaultBetweenGroupsRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueMoveVaultBetweenGroupsApprovePost(approveMoveVaultBetweenGroupsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveMoveVaultFromEmployeeToGroupRequest} [approveMoveVaultFromEmployeeToGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueMoveVaultFromEmployeeToGroupApprovePost = function (approveMoveVaultFromEmployeeToGroupRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueMoveVaultFromEmployeeToGroupApprovePost(approveMoveVaultFromEmployeeToGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveMoveVaultToEmployeeOrganizationKeychainRequest} [approveMoveVaultToEmployeeOrganizationKeychainRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueMoveVaultToEmployeeOrganizationKeychainApprovePost = function (approveMoveVaultToEmployeeOrganizationKeychainRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueMoveVaultToEmployeeOrganizationKeychainApprovePost(approveMoveVaultToEmployeeOrganizationKeychainRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveMoveVaultToGroupRequest} [approveMoveVaultToGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueMoveVaultToGroupApprovePost = function (approveMoveVaultToGroupRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueMoveVaultToGroupApprovePost(approveMoveVaultToGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveMoveVaultToGroupOrganizationKeychainRequest} [approveMoveVaultToGroupOrganizationKeychainRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueMoveVaultToGroupOrganizationKeychainApprovePost = function (approveMoveVaultToGroupOrganizationKeychainRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueMoveVaultToGroupOrganizationKeychainApprovePost(approveMoveVaultToGroupOrganizationKeychainRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveMoveVaultToPrivateKeychainRequest} [approveMoveVaultToPrivateKeychainRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueMoveVaultToPrivateKeychainApprovePost = function (approveMoveVaultToPrivateKeychainRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueMoveVaultToPrivateKeychainApprovePost(approveMoveVaultToPrivateKeychainRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PartnerSupportRequestApprovalRequest} [partnerSupportRequestApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueuePartnerSupportRequestApprovePost = function (partnerSupportRequestApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueuePartnerSupportRequestApprovePost(partnerSupportRequestApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveProcessEmployeeAsExistingUserRequest} [approveProcessEmployeeAsExistingUserRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueProcessEmployeeAsExistingUserApprovePost = function (approveProcessEmployeeAsExistingUserRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueProcessEmployeeAsExistingUserApprovePost(approveProcessEmployeeAsExistingUserRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveProcessFirstAdminAsExistingUser} [approveProcessFirstAdminAsExistingUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueProcessFirstAdminAsExistingUserApprovePost = function (approveProcessFirstAdminAsExistingUser, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueProcessFirstAdminAsExistingUserApprovePost(approveProcessFirstAdminAsExistingUser, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveProcessInviteEmployeeRequest} [approveProcessInviteEmployeeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueProcessInviteEmployeeApprovePost = function (approveProcessInviteEmployeeRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueProcessInviteEmployeeApprovePost(approveProcessInviteEmployeeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveProcessMigratedEmployeeRequest} [approveProcessMigratedEmployeeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueProcessMigratedEmployeeApprovePost = function (approveProcessMigratedEmployeeRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueProcessMigratedEmployeeApprovePost(approveProcessMigratedEmployeeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveProcessNewEmployeeRequest} [approveProcessNewEmployeeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueProcessNewEmployeeApprovePost = function (approveProcessNewEmployeeRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueProcessNewEmployeeApprovePost(approveProcessNewEmployeeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {FailProcessNewEmployeeRequest} [failProcessNewEmployeeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueProcessNewEmployeeFailPost = function (failProcessNewEmployeeRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueProcessNewEmployeeFailPost(failProcessNewEmployeeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApprovePromoteAdminRequest} [approvePromoteAdminRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueuePromoteAdminApprovePost = function (approvePromoteAdminRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueuePromoteAdminApprovePost(approvePromoteAdminRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectPromoteAdminRequest} [rejectPromoteAdminRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueuePromoteAdminRejectPost = function (rejectPromoteAdminRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueuePromoteAdminRejectPost(rejectPromoteAdminRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveQueueRequest} [approveQueueRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueQueueCommonApprovePost = function (approveQueueRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueQueueCommonApprovePost(approveQueueRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} queueMessageId
     * @param {string} deviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueQueueCommonCheckIfAvailableGet = function (queueMessageId, deviceId, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueQueueCommonCheckIfAvailableGet(queueMessageId, deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {FailQueueRequest} [failQueueRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueQueueCommonFailPost = function (failQueueRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueQueueCommonFailPost(failQueueRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} quantity
     * @param {string} deviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueQueueCommonGetQueueMessagesGet = function (quantity, deviceId, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueQueueCommonGetQueueMessagesGet(quantity, deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectQueueRequest} [rejectQueueRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueQueueCommonRejectPost = function (rejectQueueRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueQueueCommonRejectPost(rejectQueueRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveRevokeAdminRequest} [approveRevokeAdminRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueRevokeAdminApprovePost = function (approveRevokeAdminRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueRevokeAdminApprovePost(approveRevokeAdminRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectRevokeAdminRequest} [rejectRevokeAdminRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueRevokeAdminRejectPost = function (rejectRevokeAdminRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueRevokeAdminRejectPost(rejectRevokeAdminRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveRevokeSharedVaultRequest} [approveRevokeSharedVaultRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueRevokeSharedVaultApprovePost = function (approveRevokeSharedVaultRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueRevokeSharedVaultApprovePost(approveRevokeSharedVaultRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectRevokeSharedVaultRequest} [rejectRevokeSharedVaultRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueRevokeSharedVaultRejectPost = function (rejectRevokeSharedVaultRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueRevokeSharedVaultRejectPost(rejectRevokeSharedVaultRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveRevokeVaultSharingRequest} [approveRevokeVaultSharingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueRevokeVaultSharingApprovePost = function (approveRevokeVaultSharingRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueRevokeVaultSharingApprovePost(approveRevokeVaultSharingRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectRevokeVaultSharingRequest} [rejectRevokeVaultSharingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueRevokeVaultSharingRejectPost = function (rejectRevokeVaultSharingRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueRevokeVaultSharingRejectPost(rejectRevokeVaultSharingRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveShareGroupSecretWithEmployeeAccountRequest} [approveShareGroupSecretWithEmployeeAccountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueShareGroupSecretWithEmployeeAccountApprovePost = function (approveShareGroupSecretWithEmployeeAccountRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueShareGroupSecretWithEmployeeAccountApprovePost(approveShareGroupSecretWithEmployeeAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveTrustedPortalRequestedRequest} [approveTrustedPortalRequestedRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueTrustedPortalRequestedApprovePost = function (approveTrustedPortalRequestedRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueTrustedPortalRequestedApprovePost(approveTrustedPortalRequestedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectTrustedPortalRequestedRequest} [rejectTrustedPortalRequestedRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueTrustedPortalRequestedRejectPost = function (rejectTrustedPortalRequestedRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueTrustedPortalRequestedRejectPost(rejectTrustedPortalRequestedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultCreditCardCreationRequestedApprovePost = function (vaultCreditCardCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultCreditCardCreationRequestedApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultCreditCardCreationRequestedForEmployeeApprovePost = function (vaultCreditCardCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultCreditCardCreationRequestedForEmployeeApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultCreditCardCreationRequestedApprovalRequest} [vaultCreditCardCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultCreditCardCreationRequestedForGroupApprovePost = function (vaultCreditCardCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultCreditCardCreationRequestedForGroupApprovePost(vaultCreditCardCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultCreditCardDetailsRequestedApprovalRequest} [vaultCreditCardDetailsRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultCreditCardDetailsRequestedApprovePost = function (vaultCreditCardDetailsRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultCreditCardDetailsRequestedApprovePost(vaultCreditCardDetailsRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultCreditCardDetailsRequestedApprovalRequest} [vaultCreditCardDetailsRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultCreditCardDetailsRequestedForGroupApprovePost = function (vaultCreditCardDetailsRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultCreditCardDetailsRequestedForGroupApprovePost(vaultCreditCardDetailsRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultCreditCardDetailsRequestedRejectionRequest} [vaultCreditCardDetailsRequestedRejectionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultCreditCardDetailsRequestedForGroupRejectPost = function (vaultCreditCardDetailsRequestedRejectionRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultCreditCardDetailsRequestedForGroupRejectPost(vaultCreditCardDetailsRequestedRejectionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultCreditCardDetailsRequestedRejectionRequest} [vaultCreditCardDetailsRequestedRejectionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultCreditCardDetailsRequestedRejectPost = function (vaultCreditCardDetailsRequestedRejectionRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultCreditCardDetailsRequestedRejectPost(vaultCreditCardDetailsRequestedRejectionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultCreditCardEditRequestedApprovalRequest} [vaultCreditCardEditRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultCreditCardEditRequestedForEmployeeApprovePost = function (vaultCreditCardEditRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultCreditCardEditRequestedForEmployeeApprovePost(vaultCreditCardEditRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultCreditCardEditRequestedApprovalRequest} [vaultCreditCardEditRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultCreditCardEditRequestedForGroupApprovePost = function (vaultCreditCardEditRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultCreditCardEditRequestedForGroupApprovePost(vaultCreditCardEditRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultPasswordCreationRequestedUnmanagedApprovalRequest} [vaultPasswordCreationRequestedUnmanagedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultPasswordCreationRequestedApprovePost = function (vaultPasswordCreationRequestedUnmanagedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultPasswordCreationRequestedApprovePost(vaultPasswordCreationRequestedUnmanagedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultPasswordCreationRequestedForEmployeeApprovePost = function (vaultPasswordCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultPasswordCreationRequestedForEmployeeApprovePost(vaultPasswordCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultPasswordCreationRequestedApprovalRequest} [vaultPasswordCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultPasswordCreationRequestedForGroupApprovePost = function (vaultPasswordCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultPasswordCreationRequestedForGroupApprovePost(vaultPasswordCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultPasswordDetailsRequestedApprovalRequest} [vaultPasswordDetailsRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultPasswordDetailsRequestedApprovePost = function (vaultPasswordDetailsRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultPasswordDetailsRequestedApprovePost(vaultPasswordDetailsRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultPasswordDetailsRequestedApprovalRequest} [vaultPasswordDetailsRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultPasswordDetailsRequestedForGroupApprovePost = function (vaultPasswordDetailsRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultPasswordDetailsRequestedForGroupApprovePost(vaultPasswordDetailsRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultPasswordDetailsRequestedRejectionRequest} [vaultPasswordDetailsRequestedRejectionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultPasswordDetailsRequestedForGroupRejectPost = function (vaultPasswordDetailsRequestedRejectionRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultPasswordDetailsRequestedForGroupRejectPost(vaultPasswordDetailsRequestedRejectionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultPasswordDetailsRequestedRejectionRequest} [vaultPasswordDetailsRequestedRejectionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultPasswordDetailsRequestedRejectPost = function (vaultPasswordDetailsRequestedRejectionRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultPasswordDetailsRequestedRejectPost(vaultPasswordDetailsRequestedRejectionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultPasswordEditRequestedApprovalRequest} [vaultPasswordEditRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultPasswordEditRequestedForEmployeeApprovePost = function (vaultPasswordEditRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultPasswordEditRequestedForEmployeeApprovePost(vaultPasswordEditRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultPasswordEditRequestedApprovalRequest} [vaultPasswordEditRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultPasswordEditRequestedForGroupApprovePost = function (vaultPasswordEditRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultPasswordEditRequestedForGroupApprovePost(vaultPasswordEditRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultSecureNoteCreationRequestedApprovePost = function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultSecureNoteCreationRequestedApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultSecureNoteCreationRequestedForEmployeeApprovePost = function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultSecureNoteCreationRequestedForEmployeeApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultSecureNoteCreationRequestedApprovalRequest} [vaultSecureNoteCreationRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultSecureNoteCreationRequestedForGroupApprovePost = function (vaultSecureNoteCreationRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultSecureNoteCreationRequestedForGroupApprovePost(vaultSecureNoteCreationRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultSecureNoteDetailsRequestedApprovalRequest} [vaultSecureNoteDetailsRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultSecureNoteDetailsRequestedApprovePost = function (vaultSecureNoteDetailsRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultSecureNoteDetailsRequestedApprovePost(vaultSecureNoteDetailsRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultSecureNoteDetailsRequestedApprovalRequest} [vaultSecureNoteDetailsRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultSecureNoteDetailsRequestedForGroupApprovePost = function (vaultSecureNoteDetailsRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultSecureNoteDetailsRequestedForGroupApprovePost(vaultSecureNoteDetailsRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultSecureNoteDetailsRequestedRejectionRequest} [vaultSecureNoteDetailsRequestedRejectionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultSecureNoteDetailsRequestedForGroupRejectPost = function (vaultSecureNoteDetailsRequestedRejectionRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultSecureNoteDetailsRequestedForGroupRejectPost(vaultSecureNoteDetailsRequestedRejectionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultSecureNoteDetailsRequestedRejectionRequest} [vaultSecureNoteDetailsRequestedRejectionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultSecureNoteDetailsRequestedRejectPost = function (vaultSecureNoteDetailsRequestedRejectionRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultSecureNoteDetailsRequestedRejectPost(vaultSecureNoteDetailsRequestedRejectionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultSecureNoteEditRequestedApprovalRequest} [vaultSecureNoteEditRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultSecureNoteEditRequestedForEmployeeApprovePost = function (vaultSecureNoteEditRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultSecureNoteEditRequestedForEmployeeApprovePost(vaultSecureNoteEditRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {VaultSecureNoteEditRequestedApprovalRequest} [vaultSecureNoteEditRequestedApprovalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueVaultSecureNoteEditRequestedForGroupApprovePost = function (vaultSecureNoteEditRequestedApprovalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueVaultSecureNoteEditRequestedForGroupApprovePost(vaultSecureNoteEditRequestedApprovalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveCreateTrustedBrowserV2Request} [approveCreateTrustedBrowserV2Request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV2QueueCreateTrustedBrowserRequestedApprovePost = function (approveCreateTrustedBrowserV2Request, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV2QueueCreateTrustedBrowserRequestedApprovePost(approveCreateTrustedBrowserV2Request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectCreateTrustedBrowserV2Request} [rejectCreateTrustedBrowserV2Request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV2QueueCreateTrustedBrowserRequestedRejectPost = function (rejectCreateTrustedBrowserV2Request, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV2QueueCreateTrustedBrowserRequestedRejectPost(rejectCreateTrustedBrowserV2Request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request} [approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost = function (approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedApprovePost(approveGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request} [rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost = function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV2QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV2Request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ApproveGetVaultPasswordDetailsViaTrustedBrowserV2Request} [approveGetVaultPasswordDetailsViaTrustedBrowserV2Request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost = function (approveGetVaultPasswordDetailsViaTrustedBrowserV2Request, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedApprovePost(approveGetVaultPasswordDetailsViaTrustedBrowserV2Request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectGetVaultPasswordDetailsViaTrustedBrowserV2Request} [rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost = function (rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV2QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsViaTrustedBrowserV2Request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} quantity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV2QueueQueueCommonGetAdminQueueMessagesGet = function (quantity, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV2QueueQueueCommonGetAdminQueueMessagesGet(quantity, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} quantity
     * @param {string} deviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV2QueueQueueCommonGetUserQueueMessagesGet = function (quantity, deviceId, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV2QueueQueueCommonGetUserQueueMessagesGet(quantity, deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request} [rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV3QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost = function (rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV3QueueGetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsFroGroupViaTrustedBrowserV3Request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RejectGetVaultPasswordDetailsViaTrustedBrowserV3Request} [rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV3QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost = function (rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV3QueueGetVaultPasswordDetailsViaTrustedBrowserRequestedRejectPost(rejectGetVaultPasswordDetailsViaTrustedBrowserV3Request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return QueueApi;
}(base_1.BaseAPI));
exports.QueueApi = QueueApi;
/**
 * SupportedUILanguagesApi - axios parameter creator
 * @export
 */
var SupportedUILanguagesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupportedUILanguagesGetAllGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/SupportedUILanguages/GetAll";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SupportedUILanguagesApiAxiosParamCreator = SupportedUILanguagesApiAxiosParamCreator;
/**
 * SupportedUILanguagesApi - functional programming interface
 * @export
 */
var SupportedUILanguagesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SupportedUILanguagesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupportedUILanguagesGetAllGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1SupportedUILanguagesGetAllGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SupportedUILanguagesApiFp = SupportedUILanguagesApiFp;
/**
 * SupportedUILanguagesApi - factory interface
 * @export
 */
var SupportedUILanguagesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SupportedUILanguagesApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupportedUILanguagesGetAllGet: function (options) {
            return localVarFp.apiV1SupportedUILanguagesGetAllGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SupportedUILanguagesApiFactory = SupportedUILanguagesApiFactory;
/**
 * SupportedUILanguagesApi - object-oriented interface
 * @export
 * @class SupportedUILanguagesApi
 * @extends {BaseAPI}
 */
var SupportedUILanguagesApi = /** @class */ (function (_super) {
    __extends(SupportedUILanguagesApi, _super);
    function SupportedUILanguagesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportedUILanguagesApi
     */
    SupportedUILanguagesApi.prototype.apiV1SupportedUILanguagesGetAllGet = function (options) {
        var _this = this;
        return (0, exports.SupportedUILanguagesApiFp)(this.configuration).apiV1SupportedUILanguagesGetAllGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SupportedUILanguagesApi;
}(base_1.BaseAPI));
exports.SupportedUILanguagesApi = SupportedUILanguagesApi;
/**
 * TrustedActionApi - axios parameter creator
 * @export
 */
var TrustedActionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {TrustedActionType} trustedActionType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionCompanionApplicationIdTrustedActionTypeDelete: function (companionApplicationId_1, trustedActionType_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([companionApplicationId_1, trustedActionType_1], args_1, true), void 0, function (companionApplicationId, trustedActionType, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companionApplicationId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1TrustedActionCompanionApplicationIdTrustedActionTypeDelete', 'companionApplicationId', companionApplicationId);
                            // verify required parameter 'trustedActionType' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1TrustedActionCompanionApplicationIdTrustedActionTypeDelete', 'trustedActionType', trustedActionType);
                            localVarPath = "/api/v1/TrustedAction/{companionApplicationId}/{trustedActionType}"
                                .replace("{".concat("companionApplicationId", "}"), encodeURIComponent(String(companionApplicationId)))
                                .replace("{".concat("trustedActionType", "}"), encodeURIComponent(String(trustedActionType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionGetAllGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/TrustedAction/GetAll";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateTrustedActionRequest} [createTrustedActionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionPost: function (createTrustedActionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createTrustedActionRequest_1], args_1, true), void 0, function (createTrustedActionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/TrustedAction";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createTrustedActionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TrustedActionApiAxiosParamCreator = TrustedActionApiAxiosParamCreator;
/**
 * TrustedActionApi - functional programming interface
 * @export
 */
var TrustedActionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TrustedActionApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {TrustedActionType} trustedActionType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionCompanionApplicationIdTrustedActionTypeDelete: function (companionApplicationId, trustedActionType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TrustedActionCompanionApplicationIdTrustedActionTypeDelete(companionApplicationId, trustedActionType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionGetAllGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TrustedActionGetAllGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateTrustedActionRequest} [createTrustedActionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionPost: function (createTrustedActionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TrustedActionPost(createTrustedActionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TrustedActionApiFp = TrustedActionApiFp;
/**
 * TrustedActionApi - factory interface
 * @export
 */
var TrustedActionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TrustedActionApiFp)(configuration);
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {TrustedActionType} trustedActionType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionCompanionApplicationIdTrustedActionTypeDelete: function (companionApplicationId, trustedActionType, options) {
            return localVarFp.apiV1TrustedActionCompanionApplicationIdTrustedActionTypeDelete(companionApplicationId, trustedActionType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionGetAllGet: function (options) {
            return localVarFp.apiV1TrustedActionGetAllGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateTrustedActionRequest} [createTrustedActionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionPost: function (createTrustedActionRequest, options) {
            return localVarFp.apiV1TrustedActionPost(createTrustedActionRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TrustedActionApiFactory = TrustedActionApiFactory;
/**
 * TrustedActionApi - object-oriented interface
 * @export
 * @class TrustedActionApi
 * @extends {BaseAPI}
 */
var TrustedActionApi = /** @class */ (function (_super) {
    __extends(TrustedActionApi, _super);
    function TrustedActionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} companionApplicationId
     * @param {TrustedActionType} trustedActionType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustedActionApi
     */
    TrustedActionApi.prototype.apiV1TrustedActionCompanionApplicationIdTrustedActionTypeDelete = function (companionApplicationId, trustedActionType, options) {
        var _this = this;
        return (0, exports.TrustedActionApiFp)(this.configuration).apiV1TrustedActionCompanionApplicationIdTrustedActionTypeDelete(companionApplicationId, trustedActionType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustedActionApi
     */
    TrustedActionApi.prototype.apiV1TrustedActionGetAllGet = function (options) {
        var _this = this;
        return (0, exports.TrustedActionApiFp)(this.configuration).apiV1TrustedActionGetAllGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateTrustedActionRequest} [createTrustedActionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustedActionApi
     */
    TrustedActionApi.prototype.apiV1TrustedActionPost = function (createTrustedActionRequest, options) {
        var _this = this;
        return (0, exports.TrustedActionApiFp)(this.configuration).apiV1TrustedActionPost(createTrustedActionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TrustedActionApi;
}(base_1.BaseAPI));
exports.TrustedActionApi = TrustedActionApi;
/**
 * TrustedBrowserApi - axios parameter creator
 * @export
 */
var TrustedBrowserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedBrowserCompanionApplicationIdDelete: function (companionApplicationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([companionApplicationId_1], args_1, true), void 0, function (companionApplicationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companionApplicationId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1TrustedBrowserCompanionApplicationIdDelete', 'companionApplicationId', companionApplicationId);
                            localVarPath = "/api/v1/TrustedBrowser/{companionApplicationId}"
                                .replace("{".concat("companionApplicationId", "}"), encodeURIComponent(String(companionApplicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedBrowserGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/TrustedBrowser";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TrustedBrowserApiAxiosParamCreator = TrustedBrowserApiAxiosParamCreator;
/**
 * TrustedBrowserApi - functional programming interface
 * @export
 */
var TrustedBrowserApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TrustedBrowserApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedBrowserCompanionApplicationIdDelete: function (companionApplicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TrustedBrowserCompanionApplicationIdDelete(companionApplicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedBrowserGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TrustedBrowserGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TrustedBrowserApiFp = TrustedBrowserApiFp;
/**
 * TrustedBrowserApi - factory interface
 * @export
 */
var TrustedBrowserApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TrustedBrowserApiFp)(configuration);
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedBrowserCompanionApplicationIdDelete: function (companionApplicationId, options) {
            return localVarFp.apiV1TrustedBrowserCompanionApplicationIdDelete(companionApplicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedBrowserGet: function (options) {
            return localVarFp.apiV1TrustedBrowserGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TrustedBrowserApiFactory = TrustedBrowserApiFactory;
/**
 * TrustedBrowserApi - object-oriented interface
 * @export
 * @class TrustedBrowserApi
 * @extends {BaseAPI}
 */
var TrustedBrowserApi = /** @class */ (function (_super) {
    __extends(TrustedBrowserApi, _super);
    function TrustedBrowserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} companionApplicationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustedBrowserApi
     */
    TrustedBrowserApi.prototype.apiV1TrustedBrowserCompanionApplicationIdDelete = function (companionApplicationId, options) {
        var _this = this;
        return (0, exports.TrustedBrowserApiFp)(this.configuration).apiV1TrustedBrowserCompanionApplicationIdDelete(companionApplicationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustedBrowserApi
     */
    TrustedBrowserApi.prototype.apiV1TrustedBrowserGet = function (options) {
        var _this = this;
        return (0, exports.TrustedBrowserApiFp)(this.configuration).apiV1TrustedBrowserGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TrustedBrowserApi;
}(base_1.BaseAPI));
exports.TrustedBrowserApi = TrustedBrowserApi;
/**
 * TrustedPortalApi - axios parameter creator
 * @export
 */
var TrustedPortalApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedPortalGetTokensSessionIdGet: function (sessionId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([sessionId_1], args_1, true), void 0, function (sessionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'sessionId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1TrustedPortalGetTokensSessionIdGet', 'sessionId', sessionId);
                            localVarPath = "/api/v1/TrustedPortal/GetTokens/{sessionId}"
                                .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RefreshSessionTokenRequest} [refreshSessionTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedPortalRefreshTokenPost: function (refreshSessionTokenRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([refreshSessionTokenRequest_1], args_1, true), void 0, function (refreshSessionTokenRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/TrustedPortal/RefreshToken";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refreshSessionTokenRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TrustedPortalApiAxiosParamCreator = TrustedPortalApiAxiosParamCreator;
/**
 * TrustedPortalApi - functional programming interface
 * @export
 */
var TrustedPortalApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TrustedPortalApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedPortalGetTokensSessionIdGet: function (sessionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TrustedPortalGetTokensSessionIdGet(sessionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RefreshSessionTokenRequest} [refreshSessionTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedPortalRefreshTokenPost: function (refreshSessionTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TrustedPortalRefreshTokenPost(refreshSessionTokenRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TrustedPortalApiFp = TrustedPortalApiFp;
/**
 * TrustedPortalApi - factory interface
 * @export
 */
var TrustedPortalApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TrustedPortalApiFp)(configuration);
    return {
        /**
         *
         * @param {string} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedPortalGetTokensSessionIdGet: function (sessionId, options) {
            return localVarFp.apiV1TrustedPortalGetTokensSessionIdGet(sessionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RefreshSessionTokenRequest} [refreshSessionTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedPortalRefreshTokenPost: function (refreshSessionTokenRequest, options) {
            return localVarFp.apiV1TrustedPortalRefreshTokenPost(refreshSessionTokenRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TrustedPortalApiFactory = TrustedPortalApiFactory;
/**
 * TrustedPortalApi - object-oriented interface
 * @export
 * @class TrustedPortalApi
 * @extends {BaseAPI}
 */
var TrustedPortalApi = /** @class */ (function (_super) {
    __extends(TrustedPortalApi, _super);
    function TrustedPortalApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustedPortalApi
     */
    TrustedPortalApi.prototype.apiV1TrustedPortalGetTokensSessionIdGet = function (sessionId, options) {
        var _this = this;
        return (0, exports.TrustedPortalApiFp)(this.configuration).apiV1TrustedPortalGetTokensSessionIdGet(sessionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RefreshSessionTokenRequest} [refreshSessionTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustedPortalApi
     */
    TrustedPortalApi.prototype.apiV1TrustedPortalRefreshTokenPost = function (refreshSessionTokenRequest, options) {
        var _this = this;
        return (0, exports.TrustedPortalApiFp)(this.configuration).apiV1TrustedPortalRefreshTokenPost(refreshSessionTokenRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TrustedPortalApi;
}(base_1.BaseAPI));
exports.TrustedPortalApi = TrustedPortalApi;
/**
 * UserApi - axios parameter creator
 * @export
 */
var UserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {ChangeMasterPasswordRequest} [changeMasterPasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserChangeMasterPasswordPost: function (changeMasterPasswordRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([changeMasterPasswordRequest_1], args_1, true), void 0, function (changeMasterPasswordRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/ChangeMasterPassword";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeMasterPasswordRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateMasterPasswordBackupRequest} [createMasterPasswordBackupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserCreateMasterPasswordBackupPost: function (createMasterPasswordBackupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createMasterPasswordBackupRequest_1], args_1, true), void 0, function (createMasterPasswordBackupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/CreateMasterPasswordBackup";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createMasterPasswordBackupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGetContinuousMigrationsInfoGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/GetContinuousMigrationsInfo";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGetCurrentUserGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/GetCurrentUser";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGetCurrentUserInfoGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/GetCurrentUserInfo";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {boolean} [includeArchived]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserKeyPairsGet: function (includeArchived_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([includeArchived_1], args_1, true), void 0, function (includeArchived, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/KeyPairs";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (includeArchived !== undefined) {
                                localVarQueryParameter['includeArchived'] = includeArchived;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UserLoginStepOneRequest} [userLoginStepOneRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserLoginStepOnePost: function (userLoginStepOneRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userLoginStepOneRequest_1], args_1, true), void 0, function (userLoginStepOneRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/LoginStepOne";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userLoginStepOneRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UserLoginStepTwoRequest} [userLoginStepTwoRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserLoginStepTwoPost: function (userLoginStepTwoRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userLoginStepTwoRequest_1], args_1, true), void 0, function (userLoginStepTwoRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/LoginStepTwo";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userLoginStepTwoRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRefreshSecondaryDeviceTokenPost: function (refreshTokenRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([refreshTokenRequest_1], args_1, true), void 0, function (refreshTokenRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/RefreshSecondaryDeviceToken";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refreshTokenRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRefreshTokenPost: function (refreshTokenRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([refreshTokenRequest_1], args_1, true), void 0, function (refreshTokenRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/RefreshToken";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refreshTokenRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateMasterPasswordAnalyticsRequest} [updateMasterPasswordAnalyticsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserUpdateMasterPasswordAnalyticsPost: function (updateMasterPasswordAnalyticsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updateMasterPasswordAnalyticsRequest_1], args_1, true), void 0, function (updateMasterPasswordAnalyticsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/UpdateMasterPasswordAnalytics";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateMasterPasswordAnalyticsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateMasterPasswordBackupRequestV2} [createMasterPasswordBackupRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserCreateMasterPasswordBackupPut: function (createMasterPasswordBackupRequestV2_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createMasterPasswordBackupRequestV2_1], args_1, true), void 0, function (createMasterPasswordBackupRequestV2, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v2/User/CreateMasterPasswordBackup";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createMasterPasswordBackupRequestV2, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi - functional programming interface
 * @export
 */
var UserApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ChangeMasterPasswordRequest} [changeMasterPasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserChangeMasterPasswordPost: function (changeMasterPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserChangeMasterPasswordPost(changeMasterPasswordRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateMasterPasswordBackupRequest} [createMasterPasswordBackupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserCreateMasterPasswordBackupPost: function (createMasterPasswordBackupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserCreateMasterPasswordBackupPost(createMasterPasswordBackupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGetContinuousMigrationsInfoGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserGetContinuousMigrationsInfoGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGetCurrentUserGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserGetCurrentUserGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGetCurrentUserInfoGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserGetCurrentUserInfoGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {boolean} [includeArchived]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserKeyPairsGet: function (includeArchived, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserKeyPairsGet(includeArchived, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {UserLoginStepOneRequest} [userLoginStepOneRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserLoginStepOnePost: function (userLoginStepOneRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserLoginStepOnePost(userLoginStepOneRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {UserLoginStepTwoRequest} [userLoginStepTwoRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserLoginStepTwoPost: function (userLoginStepTwoRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserLoginStepTwoPost(userLoginStepTwoRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRefreshSecondaryDeviceTokenPost: function (refreshTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserRefreshSecondaryDeviceTokenPost(refreshTokenRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRefreshTokenPost: function (refreshTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserRefreshTokenPost(refreshTokenRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateMasterPasswordAnalyticsRequest} [updateMasterPasswordAnalyticsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserUpdateMasterPasswordAnalyticsPost: function (updateMasterPasswordAnalyticsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserUpdateMasterPasswordAnalyticsPost(updateMasterPasswordAnalyticsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateMasterPasswordBackupRequestV2} [createMasterPasswordBackupRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserCreateMasterPasswordBackupPut: function (createMasterPasswordBackupRequestV2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV2UserCreateMasterPasswordBackupPut(createMasterPasswordBackupRequestV2, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UserApiFp = UserApiFp;
/**
 * UserApi - factory interface
 * @export
 */
var UserApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UserApiFp)(configuration);
    return {
        /**
         *
         * @param {ChangeMasterPasswordRequest} [changeMasterPasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserChangeMasterPasswordPost: function (changeMasterPasswordRequest, options) {
            return localVarFp.apiV1UserChangeMasterPasswordPost(changeMasterPasswordRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateMasterPasswordBackupRequest} [createMasterPasswordBackupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserCreateMasterPasswordBackupPost: function (createMasterPasswordBackupRequest, options) {
            return localVarFp.apiV1UserCreateMasterPasswordBackupPost(createMasterPasswordBackupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGetContinuousMigrationsInfoGet: function (options) {
            return localVarFp.apiV1UserGetContinuousMigrationsInfoGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGetCurrentUserGet: function (options) {
            return localVarFp.apiV1UserGetCurrentUserGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGetCurrentUserInfoGet: function (options) {
            return localVarFp.apiV1UserGetCurrentUserInfoGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {boolean} [includeArchived]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserKeyPairsGet: function (includeArchived, options) {
            return localVarFp.apiV1UserKeyPairsGet(includeArchived, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UserLoginStepOneRequest} [userLoginStepOneRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserLoginStepOnePost: function (userLoginStepOneRequest, options) {
            return localVarFp.apiV1UserLoginStepOnePost(userLoginStepOneRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UserLoginStepTwoRequest} [userLoginStepTwoRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserLoginStepTwoPost: function (userLoginStepTwoRequest, options) {
            return localVarFp.apiV1UserLoginStepTwoPost(userLoginStepTwoRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRefreshSecondaryDeviceTokenPost: function (refreshTokenRequest, options) {
            return localVarFp.apiV1UserRefreshSecondaryDeviceTokenPost(refreshTokenRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRefreshTokenPost: function (refreshTokenRequest, options) {
            return localVarFp.apiV1UserRefreshTokenPost(refreshTokenRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UpdateMasterPasswordAnalyticsRequest} [updateMasterPasswordAnalyticsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserUpdateMasterPasswordAnalyticsPost: function (updateMasterPasswordAnalyticsRequest, options) {
            return localVarFp.apiV1UserUpdateMasterPasswordAnalyticsPost(updateMasterPasswordAnalyticsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateMasterPasswordBackupRequestV2} [createMasterPasswordBackupRequestV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserCreateMasterPasswordBackupPut: function (createMasterPasswordBackupRequestV2, options) {
            return localVarFp.apiV2UserCreateMasterPasswordBackupPut(createMasterPasswordBackupRequestV2, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UserApiFactory = UserApiFactory;
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {ChangeMasterPasswordRequest} [changeMasterPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserChangeMasterPasswordPost = function (changeMasterPasswordRequest, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserChangeMasterPasswordPost(changeMasterPasswordRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateMasterPasswordBackupRequest} [createMasterPasswordBackupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserCreateMasterPasswordBackupPost = function (createMasterPasswordBackupRequest, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserCreateMasterPasswordBackupPost(createMasterPasswordBackupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserGetContinuousMigrationsInfoGet = function (options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserGetContinuousMigrationsInfoGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserGetCurrentUserGet = function (options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserGetCurrentUserGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserGetCurrentUserInfoGet = function (options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserGetCurrentUserInfoGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {boolean} [includeArchived]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserKeyPairsGet = function (includeArchived, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserKeyPairsGet(includeArchived, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UserLoginStepOneRequest} [userLoginStepOneRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserLoginStepOnePost = function (userLoginStepOneRequest, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserLoginStepOnePost(userLoginStepOneRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UserLoginStepTwoRequest} [userLoginStepTwoRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserLoginStepTwoPost = function (userLoginStepTwoRequest, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserLoginStepTwoPost(userLoginStepTwoRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RefreshTokenRequest} [refreshTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserRefreshSecondaryDeviceTokenPost = function (refreshTokenRequest, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserRefreshSecondaryDeviceTokenPost(refreshTokenRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RefreshTokenRequest} [refreshTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserRefreshTokenPost = function (refreshTokenRequest, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserRefreshTokenPost(refreshTokenRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UpdateMasterPasswordAnalyticsRequest} [updateMasterPasswordAnalyticsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserUpdateMasterPasswordAnalyticsPost = function (updateMasterPasswordAnalyticsRequest, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserUpdateMasterPasswordAnalyticsPost(updateMasterPasswordAnalyticsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateMasterPasswordBackupRequestV2} [createMasterPasswordBackupRequestV2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV2UserCreateMasterPasswordBackupPut = function (createMasterPasswordBackupRequestV2, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV2UserCreateMasterPasswordBackupPut(createMasterPasswordBackupRequestV2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserApi;
}(base_1.BaseAPI));
exports.UserApi = UserApi;
/**
 * UserActivationCodesApi - axios parameter creator
 * @export
 */
var UserActivationCodesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {CreateUserActivationCodeRequest} [createUserActivationCodeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserActivationCodesPost: function (createUserActivationCodeRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createUserActivationCodeRequest_1], args_1, true), void 0, function (createUserActivationCodeRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/UserActivationCodes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createUserActivationCodeRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UserActivationCodesApiAxiosParamCreator = UserActivationCodesApiAxiosParamCreator;
/**
 * UserActivationCodesApi - functional programming interface
 * @export
 */
var UserActivationCodesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UserActivationCodesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {CreateUserActivationCodeRequest} [createUserActivationCodeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserActivationCodesPost: function (createUserActivationCodeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserActivationCodesPost(createUserActivationCodeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UserActivationCodesApiFp = UserActivationCodesApiFp;
/**
 * UserActivationCodesApi - factory interface
 * @export
 */
var UserActivationCodesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UserActivationCodesApiFp)(configuration);
    return {
        /**
         *
         * @param {CreateUserActivationCodeRequest} [createUserActivationCodeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserActivationCodesPost: function (createUserActivationCodeRequest, options) {
            return localVarFp.apiV1UserActivationCodesPost(createUserActivationCodeRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UserActivationCodesApiFactory = UserActivationCodesApiFactory;
/**
 * UserActivationCodesApi - object-oriented interface
 * @export
 * @class UserActivationCodesApi
 * @extends {BaseAPI}
 */
var UserActivationCodesApi = /** @class */ (function (_super) {
    __extends(UserActivationCodesApi, _super);
    function UserActivationCodesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {CreateUserActivationCodeRequest} [createUserActivationCodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserActivationCodesApi
     */
    UserActivationCodesApi.prototype.apiV1UserActivationCodesPost = function (createUserActivationCodeRequest, options) {
        var _this = this;
        return (0, exports.UserActivationCodesApiFp)(this.configuration).apiV1UserActivationCodesPost(createUserActivationCodeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserActivationCodesApi;
}(base_1.BaseAPI));
exports.UserActivationCodesApi = UserActivationCodesApi;
/**
 * VaultsApi - axios parameter creator
 * @export
 */
var VaultsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} vaultId
         * @param {PutVaultPasswordApplicationRequest} [putVaultPasswordApplicationRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1VaultsEditPasswordApplicationVaultIdPut: function (vaultId_1, putVaultPasswordApplicationRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1, putVaultPasswordApplicationRequest_1], args_1, true), void 0, function (vaultId, putVaultPasswordApplicationRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsEditPasswordApplicationVaultIdPut', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/EditPasswordApplication/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(putVaultPasswordApplicationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {PutVaultPasswordDesktopApplication} [putVaultPasswordDesktopApplication]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsEditPasswordDesktopApplicationVaultIdPut: function (vaultId_1, putVaultPasswordDesktopApplication_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1, putVaultPasswordDesktopApplication_1], args_1, true), void 0, function (vaultId, putVaultPasswordDesktopApplication, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsEditPasswordDesktopApplicationVaultIdPut', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/EditPasswordDesktopApplication/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(putVaultPasswordDesktopApplication, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {PutVaultPasswordWebSiteRequest} [putVaultPasswordWebSiteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsEditPasswordWebSiteVaultIdPut: function (vaultId_1, putVaultPasswordWebSiteRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1, putVaultPasswordWebSiteRequest_1], args_1, true), void 0, function (vaultId, putVaultPasswordWebSiteRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsEditPasswordWebSiteVaultIdPut', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/EditPasswordWebSite/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(putVaultPasswordWebSiteRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetGroupVaultSharingInfoVaultIdGet: function (vaultId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1], args_1, true), void 0, function (vaultId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetGroupVaultSharingInfoVaultIdGet', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/GetGroupVaultSharingInfo/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetImportHistoryGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetImportHistory";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} sessionId
         * @param {number} page
         * @param {number} pageLength
         * @param {boolean} [processed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetImportVaultsBySessionIdSessionIdGet: function (sessionId_1, page_1, pageLength_1, processed_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([sessionId_1, page_1, pageLength_1, processed_1], args_1, true), void 0, function (sessionId, page, pageLength, processed, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'sessionId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetImportVaultsBySessionIdSessionIdGet', 'sessionId', sessionId);
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetImportVaultsBySessionIdSessionIdGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetImportVaultsBySessionIdSessionIdGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/Vaults/GetImportVaultsBySessionId/{sessionId}"
                                .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (processed !== undefined) {
                                localVarQueryParameter['Processed'] = processed;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetPoliciesByVaultIdVaultIdGet: function (vaultId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1], args_1, true), void 0, function (vaultId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetPoliciesByVaultIdVaultIdGet', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/GetPoliciesByVaultId/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultBackupByIdVaultIdGet: function (vaultId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1], args_1, true), void 0, function (vaultId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultBackupByIdVaultIdGet', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/GetVaultBackupById/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardByIdVaultIdGet: function (vaultId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1], args_1, true), void 0, function (vaultId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultCreditCardByIdVaultIdGet', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/GetVaultCreditCardById/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardByVaultIdAndGroupIdVaultIdGroupIdGet: function (vaultId_1, groupId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1, groupId_1], args_1, true), void 0, function (vaultId, groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultCreditCardByVaultIdAndGroupIdVaultIdGroupIdGet', 'vaultId', vaultId);
                            // verify required parameter 'groupId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultCreditCardByVaultIdAndGroupIdVaultIdGroupIdGet', 'groupId', groupId);
                            localVarPath = "/api/v1/Vaults/GetVaultCreditCardByVaultIdAndGroupId/{vaultId}/{groupId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)))
                                .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsForCurrentUserGet: function (updatedAfter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updatedAfter_1], args_1, true), void 0, function (updatedAfter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultCreditCardsForCurrentUser";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (updatedAfter !== undefined) {
                                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                                    updatedAfter.toISOString() :
                                    updatedAfter;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsForGroupGet: function (updatedAfter_1, groupId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updatedAfter_1, groupId_1], args_1, true), void 0, function (updatedAfter, groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultCreditCardsForGroup";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (updatedAfter !== undefined) {
                                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                                    updatedAfter.toISOString() :
                                    updatedAfter;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['GroupId'] = groupId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsSecureDataForCurrentUserGet: function (updatedAfter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updatedAfter_1], args_1, true), void 0, function (updatedAfter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultCreditCardsSecureDataForCurrentUser";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (updatedAfter !== undefined) {
                                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                                    updatedAfter.toISOString() :
                                    updatedAfter;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsSecureDataForGroupGet: function (updatedAfter_1, groupId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updatedAfter_1, groupId_1], args_1, true), void 0, function (updatedAfter, groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultCreditCardsSecureDataForGroup";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (updatedAfter !== undefined) {
                                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                                    updatedAfter.toISOString() :
                                    updatedAfter;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['GroupId'] = groupId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordByIdVaultIdGet: function (vaultId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1], args_1, true), void 0, function (vaultId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultPasswordByIdVaultIdGet', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/GetVaultPasswordById/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordByVaultIdAndGroupIdVaultIdGroupIdGet: function (vaultId_1, groupId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1, groupId_1], args_1, true), void 0, function (vaultId, groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultPasswordByVaultIdAndGroupIdVaultIdGroupIdGet', 'vaultId', vaultId);
                            // verify required parameter 'groupId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultPasswordByVaultIdAndGroupIdVaultIdGroupIdGet', 'groupId', groupId);
                            localVarPath = "/api/v1/Vaults/GetVaultPasswordByVaultIdAndGroupId/{vaultId}/{groupId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)))
                                .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsForCurrentUserGet: function (updatedAfter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updatedAfter_1], args_1, true), void 0, function (updatedAfter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultPasswordsForCurrentUser";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (updatedAfter !== undefined) {
                                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                                    updatedAfter.toISOString() :
                                    updatedAfter;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsForGroupGet: function (updatedAfter_1, groupId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updatedAfter_1, groupId_1], args_1, true), void 0, function (updatedAfter, groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultPasswordsForGroup";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (updatedAfter !== undefined) {
                                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                                    updatedAfter.toISOString() :
                                    updatedAfter;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['GroupId'] = groupId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsSecureDataForCurrentUserGet: function (updatedAfter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updatedAfter_1], args_1, true), void 0, function (updatedAfter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultPasswordsSecureDataForCurrentUser";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (updatedAfter !== undefined) {
                                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                                    updatedAfter.toISOString() :
                                    updatedAfter;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsSecureDataForGroupGet: function (updatedAfter_1, groupId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updatedAfter_1, groupId_1], args_1, true), void 0, function (updatedAfter, groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultPasswordsSecureDataForGroup";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (updatedAfter !== undefined) {
                                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                                    updatedAfter.toISOString() :
                                    updatedAfter;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['GroupId'] = groupId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNoteByIdVaultIdGet: function (vaultId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1], args_1, true), void 0, function (vaultId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultSecureNoteByIdVaultIdGet', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/GetVaultSecureNoteById/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNoteByVaultIdAndGroupIdVaultIdGroupIdGet: function (vaultId_1, groupId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1, groupId_1], args_1, true), void 0, function (vaultId, groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultSecureNoteByVaultIdAndGroupIdVaultIdGroupIdGet', 'vaultId', vaultId);
                            // verify required parameter 'groupId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultSecureNoteByVaultIdAndGroupIdVaultIdGroupIdGet', 'groupId', groupId);
                            localVarPath = "/api/v1/Vaults/GetVaultSecureNoteByVaultIdAndGroupId/{vaultId}/{groupId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)))
                                .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesForCurrentUserGet: function (updatedAfter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updatedAfter_1], args_1, true), void 0, function (updatedAfter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultSecureNotesForCurrentUser";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (updatedAfter !== undefined) {
                                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                                    updatedAfter.toISOString() :
                                    updatedAfter;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesForGroupsGet: function (updatedAfter_1, groupId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updatedAfter_1, groupId_1], args_1, true), void 0, function (updatedAfter, groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultSecureNotesForGroups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (updatedAfter !== undefined) {
                                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                                    updatedAfter.toISOString() :
                                    updatedAfter;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['GroupId'] = groupId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesSecureDataForCurrentUserGet: function (updatedAfter_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updatedAfter_1], args_1, true), void 0, function (updatedAfter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultSecureNotesSecureDataForCurrentUser";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (updatedAfter !== undefined) {
                                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                                    updatedAfter.toISOString() :
                                    updatedAfter;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesSecureDataForGroupsGet: function (updatedAfter_1, groupId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updatedAfter_1, groupId_1], args_1, true), void 0, function (updatedAfter, groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultSecureNotesSecureDataForGroups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (updatedAfter !== undefined) {
                                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                                    updatedAfter.toISOString() :
                                    updatedAfter;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['GroupId'] = groupId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSharingInfoVaultIdGet: function (vaultId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1], args_1, true), void 0, function (vaultId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultSharingInfoVaultIdGet', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/GetVaultSharingInfo/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultsSharedFromOtherUsersGet: function (searchString_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([searchString_1], args_1, true), void 0, function (searchString, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultsSharedFromOtherUsers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (searchString !== undefined) {
                                localVarQueryParameter['searchString'] = searchString;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [searchString]
         * @param {Array<string>} [vaultsFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultsSharedToOtherUsersGet: function (searchString_1, vaultsFilter_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([searchString_1, vaultsFilter_1], args_1, true), void 0, function (searchString, vaultsFilter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/GetVaultsSharedToOtherUsers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (searchString !== undefined) {
                                localVarQueryParameter['SearchString'] = searchString;
                            }
                            if (vaultsFilter) {
                                localVarQueryParameter['VaultsFilter'] = vaultsFilter;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ImportVaultCreatePasswordRequest} [importVaultCreatePasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsImportVaultCreatePasswordPost: function (importVaultCreatePasswordRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([importVaultCreatePasswordRequest_1], args_1, true), void 0, function (importVaultCreatePasswordRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/ImportVaultCreatePassword";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(importVaultCreatePasswordRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {MarkImportVaultsFailedRequest} [markImportVaultsFailedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMarkImportVaultsFailedPut: function (markImportVaultsFailedRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([markImportVaultsFailedRequest_1], args_1, true), void 0, function (markImportVaultsFailedRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/MarkImportVaultsFailed";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(markImportVaultsFailedRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {MarkImportVaultsProcessedRequest} [markImportVaultsProcessedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMarkImportVaultsProcessedPut: function (markImportVaultsProcessedRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([markImportVaultsProcessedRequest_1], args_1, true), void 0, function (markImportVaultsProcessedRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/MarkImportVaultsProcessed";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(markImportVaultsProcessedRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {MoveVaultToGroupRequest} [moveVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMoveVaultToGroupPost: function (moveVaultToGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([moveVaultToGroupRequest_1], args_1, true), void 0, function (moveVaultToGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/MoveVaultToGroup";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(moveVaultToGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {MoveVaultToOrganizationGroupRequest} [moveVaultToOrganizationGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMoveVaultToOrganizationGroupPost: function (moveVaultToOrganizationGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([moveVaultToOrganizationGroupRequest_1], args_1, true), void 0, function (moveVaultToOrganizationGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/MoveVaultToOrganizationGroup";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(moveVaultToOrganizationGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {MoveVaultToOrganizationRequest} [moveVaultToOrganizationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMoveVaultToOrganizationPost: function (moveVaultToOrganizationRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([moveVaultToOrganizationRequest_1], args_1, true), void 0, function (moveVaultToOrganizationRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/MoveVaultToOrganization";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(moveVaultToOrganizationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsPatchVaultCreditCardVaultIdPatch: function (vaultId_1, operation_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1, operation_1], args_1, true), void 0, function (vaultId, operation, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsPatchVaultCreditCardVaultIdPatch', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/PatchVaultCreditCard/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(operation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsPatchVaultPasswordVaultIdPatch: function (vaultId_1, operation_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1, operation_1], args_1, true), void 0, function (vaultId, operation, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsPatchVaultPasswordVaultIdPatch', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/PatchVaultPassword/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(operation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsPatchVaultSecureNoteVaultIdPatch: function (vaultId_1, operation_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1, operation_1], args_1, true), void 0, function (vaultId, operation, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsPatchVaultSecureNoteVaultIdPatch', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/PatchVaultSecureNote/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(operation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.VaultsApiAxiosParamCreator = VaultsApiAxiosParamCreator;
/**
 * VaultsApi - functional programming interface
 * @export
 */
var VaultsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VaultsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} vaultId
         * @param {PutVaultPasswordApplicationRequest} [putVaultPasswordApplicationRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1VaultsEditPasswordApplicationVaultIdPut: function (vaultId, putVaultPasswordApplicationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsEditPasswordApplicationVaultIdPut(vaultId, putVaultPasswordApplicationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {PutVaultPasswordDesktopApplication} [putVaultPasswordDesktopApplication]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsEditPasswordDesktopApplicationVaultIdPut: function (vaultId, putVaultPasswordDesktopApplication, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsEditPasswordDesktopApplicationVaultIdPut(vaultId, putVaultPasswordDesktopApplication, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {PutVaultPasswordWebSiteRequest} [putVaultPasswordWebSiteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsEditPasswordWebSiteVaultIdPut: function (vaultId, putVaultPasswordWebSiteRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsEditPasswordWebSiteVaultIdPut(vaultId, putVaultPasswordWebSiteRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetGroupVaultSharingInfoVaultIdGet: function (vaultId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetGroupVaultSharingInfoVaultIdGet(vaultId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetImportHistoryGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetImportHistoryGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} sessionId
         * @param {number} page
         * @param {number} pageLength
         * @param {boolean} [processed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetImportVaultsBySessionIdSessionIdGet: function (sessionId, page, pageLength, processed, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetImportVaultsBySessionIdSessionIdGet(sessionId, page, pageLength, processed, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetPoliciesByVaultIdVaultIdGet: function (vaultId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetPoliciesByVaultIdVaultIdGet(vaultId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultBackupByIdVaultIdGet: function (vaultId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultBackupByIdVaultIdGet(vaultId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardByIdVaultIdGet: function (vaultId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultCreditCardByIdVaultIdGet(vaultId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardByVaultIdAndGroupIdVaultIdGroupIdGet: function (vaultId, groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultCreditCardByVaultIdAndGroupIdVaultIdGroupIdGet(vaultId, groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsForCurrentUserGet: function (updatedAfter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultCreditCardsForCurrentUserGet(updatedAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsForGroupGet: function (updatedAfter, groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultCreditCardsForGroupGet(updatedAfter, groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsSecureDataForCurrentUserGet: function (updatedAfter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultCreditCardsSecureDataForCurrentUserGet(updatedAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsSecureDataForGroupGet: function (updatedAfter, groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultCreditCardsSecureDataForGroupGet(updatedAfter, groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordByIdVaultIdGet: function (vaultId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultPasswordByIdVaultIdGet(vaultId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordByVaultIdAndGroupIdVaultIdGroupIdGet: function (vaultId, groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultPasswordByVaultIdAndGroupIdVaultIdGroupIdGet(vaultId, groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsForCurrentUserGet: function (updatedAfter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultPasswordsForCurrentUserGet(updatedAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsForGroupGet: function (updatedAfter, groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultPasswordsForGroupGet(updatedAfter, groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsSecureDataForCurrentUserGet: function (updatedAfter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultPasswordsSecureDataForCurrentUserGet(updatedAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsSecureDataForGroupGet: function (updatedAfter, groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultPasswordsSecureDataForGroupGet(updatedAfter, groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNoteByIdVaultIdGet: function (vaultId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultSecureNoteByIdVaultIdGet(vaultId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNoteByVaultIdAndGroupIdVaultIdGroupIdGet: function (vaultId, groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultSecureNoteByVaultIdAndGroupIdVaultIdGroupIdGet(vaultId, groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesForCurrentUserGet: function (updatedAfter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultSecureNotesForCurrentUserGet(updatedAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesForGroupsGet: function (updatedAfter, groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultSecureNotesForGroupsGet(updatedAfter, groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesSecureDataForCurrentUserGet: function (updatedAfter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultSecureNotesSecureDataForCurrentUserGet(updatedAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesSecureDataForGroupsGet: function (updatedAfter, groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultSecureNotesSecureDataForGroupsGet(updatedAfter, groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSharingInfoVaultIdGet: function (vaultId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultSharingInfoVaultIdGet(vaultId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultsSharedFromOtherUsersGet: function (searchString, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultsSharedFromOtherUsersGet(searchString, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [searchString]
         * @param {Array<string>} [vaultsFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultsSharedToOtherUsersGet: function (searchString, vaultsFilter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultsSharedToOtherUsersGet(searchString, vaultsFilter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ImportVaultCreatePasswordRequest} [importVaultCreatePasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsImportVaultCreatePasswordPost: function (importVaultCreatePasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsImportVaultCreatePasswordPost(importVaultCreatePasswordRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {MarkImportVaultsFailedRequest} [markImportVaultsFailedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMarkImportVaultsFailedPut: function (markImportVaultsFailedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsMarkImportVaultsFailedPut(markImportVaultsFailedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {MarkImportVaultsProcessedRequest} [markImportVaultsProcessedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMarkImportVaultsProcessedPut: function (markImportVaultsProcessedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsMarkImportVaultsProcessedPut(markImportVaultsProcessedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {MoveVaultToGroupRequest} [moveVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMoveVaultToGroupPost: function (moveVaultToGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsMoveVaultToGroupPost(moveVaultToGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {MoveVaultToOrganizationGroupRequest} [moveVaultToOrganizationGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMoveVaultToOrganizationGroupPost: function (moveVaultToOrganizationGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsMoveVaultToOrganizationGroupPost(moveVaultToOrganizationGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {MoveVaultToOrganizationRequest} [moveVaultToOrganizationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMoveVaultToOrganizationPost: function (moveVaultToOrganizationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsMoveVaultToOrganizationPost(moveVaultToOrganizationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsPatchVaultCreditCardVaultIdPatch: function (vaultId, operation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsPatchVaultCreditCardVaultIdPatch(vaultId, operation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsPatchVaultPasswordVaultIdPatch: function (vaultId, operation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsPatchVaultPasswordVaultIdPatch(vaultId, operation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsPatchVaultSecureNoteVaultIdPatch: function (vaultId, operation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsPatchVaultSecureNoteVaultIdPatch(vaultId, operation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VaultsApiFp = VaultsApiFp;
/**
 * VaultsApi - factory interface
 * @export
 */
var VaultsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VaultsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} vaultId
         * @param {PutVaultPasswordApplicationRequest} [putVaultPasswordApplicationRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1VaultsEditPasswordApplicationVaultIdPut: function (vaultId, putVaultPasswordApplicationRequest, options) {
            return localVarFp.apiV1VaultsEditPasswordApplicationVaultIdPut(vaultId, putVaultPasswordApplicationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {PutVaultPasswordDesktopApplication} [putVaultPasswordDesktopApplication]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsEditPasswordDesktopApplicationVaultIdPut: function (vaultId, putVaultPasswordDesktopApplication, options) {
            return localVarFp.apiV1VaultsEditPasswordDesktopApplicationVaultIdPut(vaultId, putVaultPasswordDesktopApplication, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {PutVaultPasswordWebSiteRequest} [putVaultPasswordWebSiteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsEditPasswordWebSiteVaultIdPut: function (vaultId, putVaultPasswordWebSiteRequest, options) {
            return localVarFp.apiV1VaultsEditPasswordWebSiteVaultIdPut(vaultId, putVaultPasswordWebSiteRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetGroupVaultSharingInfoVaultIdGet: function (vaultId, options) {
            return localVarFp.apiV1VaultsGetGroupVaultSharingInfoVaultIdGet(vaultId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetImportHistoryGet: function (options) {
            return localVarFp.apiV1VaultsGetImportHistoryGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} sessionId
         * @param {number} page
         * @param {number} pageLength
         * @param {boolean} [processed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetImportVaultsBySessionIdSessionIdGet: function (sessionId, page, pageLength, processed, options) {
            return localVarFp.apiV1VaultsGetImportVaultsBySessionIdSessionIdGet(sessionId, page, pageLength, processed, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetPoliciesByVaultIdVaultIdGet: function (vaultId, options) {
            return localVarFp.apiV1VaultsGetPoliciesByVaultIdVaultIdGet(vaultId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultBackupByIdVaultIdGet: function (vaultId, options) {
            return localVarFp.apiV1VaultsGetVaultBackupByIdVaultIdGet(vaultId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardByIdVaultIdGet: function (vaultId, options) {
            return localVarFp.apiV1VaultsGetVaultCreditCardByIdVaultIdGet(vaultId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardByVaultIdAndGroupIdVaultIdGroupIdGet: function (vaultId, groupId, options) {
            return localVarFp.apiV1VaultsGetVaultCreditCardByVaultIdAndGroupIdVaultIdGroupIdGet(vaultId, groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsForCurrentUserGet: function (updatedAfter, options) {
            return localVarFp.apiV1VaultsGetVaultCreditCardsForCurrentUserGet(updatedAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsForGroupGet: function (updatedAfter, groupId, options) {
            return localVarFp.apiV1VaultsGetVaultCreditCardsForGroupGet(updatedAfter, groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsSecureDataForCurrentUserGet: function (updatedAfter, options) {
            return localVarFp.apiV1VaultsGetVaultCreditCardsSecureDataForCurrentUserGet(updatedAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsSecureDataForGroupGet: function (updatedAfter, groupId, options) {
            return localVarFp.apiV1VaultsGetVaultCreditCardsSecureDataForGroupGet(updatedAfter, groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordByIdVaultIdGet: function (vaultId, options) {
            return localVarFp.apiV1VaultsGetVaultPasswordByIdVaultIdGet(vaultId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordByVaultIdAndGroupIdVaultIdGroupIdGet: function (vaultId, groupId, options) {
            return localVarFp.apiV1VaultsGetVaultPasswordByVaultIdAndGroupIdVaultIdGroupIdGet(vaultId, groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsForCurrentUserGet: function (updatedAfter, options) {
            return localVarFp.apiV1VaultsGetVaultPasswordsForCurrentUserGet(updatedAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsForGroupGet: function (updatedAfter, groupId, options) {
            return localVarFp.apiV1VaultsGetVaultPasswordsForGroupGet(updatedAfter, groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsSecureDataForCurrentUserGet: function (updatedAfter, options) {
            return localVarFp.apiV1VaultsGetVaultPasswordsSecureDataForCurrentUserGet(updatedAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsSecureDataForGroupGet: function (updatedAfter, groupId, options) {
            return localVarFp.apiV1VaultsGetVaultPasswordsSecureDataForGroupGet(updatedAfter, groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNoteByIdVaultIdGet: function (vaultId, options) {
            return localVarFp.apiV1VaultsGetVaultSecureNoteByIdVaultIdGet(vaultId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNoteByVaultIdAndGroupIdVaultIdGroupIdGet: function (vaultId, groupId, options) {
            return localVarFp.apiV1VaultsGetVaultSecureNoteByVaultIdAndGroupIdVaultIdGroupIdGet(vaultId, groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesForCurrentUserGet: function (updatedAfter, options) {
            return localVarFp.apiV1VaultsGetVaultSecureNotesForCurrentUserGet(updatedAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesForGroupsGet: function (updatedAfter, groupId, options) {
            return localVarFp.apiV1VaultsGetVaultSecureNotesForGroupsGet(updatedAfter, groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesSecureDataForCurrentUserGet: function (updatedAfter, options) {
            return localVarFp.apiV1VaultsGetVaultSecureNotesSecureDataForCurrentUserGet(updatedAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [updatedAfter]
         * @param {string} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesSecureDataForGroupsGet: function (updatedAfter, groupId, options) {
            return localVarFp.apiV1VaultsGetVaultSecureNotesSecureDataForGroupsGet(updatedAfter, groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSharingInfoVaultIdGet: function (vaultId, options) {
            return localVarFp.apiV1VaultsGetVaultSharingInfoVaultIdGet(vaultId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [searchString]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultsSharedFromOtherUsersGet: function (searchString, options) {
            return localVarFp.apiV1VaultsGetVaultsSharedFromOtherUsersGet(searchString, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [searchString]
         * @param {Array<string>} [vaultsFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultsSharedToOtherUsersGet: function (searchString, vaultsFilter, options) {
            return localVarFp.apiV1VaultsGetVaultsSharedToOtherUsersGet(searchString, vaultsFilter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ImportVaultCreatePasswordRequest} [importVaultCreatePasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsImportVaultCreatePasswordPost: function (importVaultCreatePasswordRequest, options) {
            return localVarFp.apiV1VaultsImportVaultCreatePasswordPost(importVaultCreatePasswordRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {MarkImportVaultsFailedRequest} [markImportVaultsFailedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMarkImportVaultsFailedPut: function (markImportVaultsFailedRequest, options) {
            return localVarFp.apiV1VaultsMarkImportVaultsFailedPut(markImportVaultsFailedRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {MarkImportVaultsProcessedRequest} [markImportVaultsProcessedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMarkImportVaultsProcessedPut: function (markImportVaultsProcessedRequest, options) {
            return localVarFp.apiV1VaultsMarkImportVaultsProcessedPut(markImportVaultsProcessedRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {MoveVaultToGroupRequest} [moveVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMoveVaultToGroupPost: function (moveVaultToGroupRequest, options) {
            return localVarFp.apiV1VaultsMoveVaultToGroupPost(moveVaultToGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {MoveVaultToOrganizationGroupRequest} [moveVaultToOrganizationGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMoveVaultToOrganizationGroupPost: function (moveVaultToOrganizationGroupRequest, options) {
            return localVarFp.apiV1VaultsMoveVaultToOrganizationGroupPost(moveVaultToOrganizationGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {MoveVaultToOrganizationRequest} [moveVaultToOrganizationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMoveVaultToOrganizationPost: function (moveVaultToOrganizationRequest, options) {
            return localVarFp.apiV1VaultsMoveVaultToOrganizationPost(moveVaultToOrganizationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsPatchVaultCreditCardVaultIdPatch: function (vaultId, operation, options) {
            return localVarFp.apiV1VaultsPatchVaultCreditCardVaultIdPatch(vaultId, operation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsPatchVaultPasswordVaultIdPatch: function (vaultId, operation, options) {
            return localVarFp.apiV1VaultsPatchVaultPasswordVaultIdPatch(vaultId, operation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsPatchVaultSecureNoteVaultIdPatch: function (vaultId, operation, options) {
            return localVarFp.apiV1VaultsPatchVaultSecureNoteVaultIdPatch(vaultId, operation, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VaultsApiFactory = VaultsApiFactory;
/**
 * VaultsApi - object-oriented interface
 * @export
 * @class VaultsApi
 * @extends {BaseAPI}
 */
var VaultsApi = /** @class */ (function (_super) {
    __extends(VaultsApi, _super);
    function VaultsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} vaultId
     * @param {PutVaultPasswordApplicationRequest} [putVaultPasswordApplicationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsEditPasswordApplicationVaultIdPut = function (vaultId, putVaultPasswordApplicationRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsEditPasswordApplicationVaultIdPut(vaultId, putVaultPasswordApplicationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {PutVaultPasswordDesktopApplication} [putVaultPasswordDesktopApplication]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsEditPasswordDesktopApplicationVaultIdPut = function (vaultId, putVaultPasswordDesktopApplication, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsEditPasswordDesktopApplicationVaultIdPut(vaultId, putVaultPasswordDesktopApplication, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {PutVaultPasswordWebSiteRequest} [putVaultPasswordWebSiteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsEditPasswordWebSiteVaultIdPut = function (vaultId, putVaultPasswordWebSiteRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsEditPasswordWebSiteVaultIdPut(vaultId, putVaultPasswordWebSiteRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetGroupVaultSharingInfoVaultIdGet = function (vaultId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetGroupVaultSharingInfoVaultIdGet(vaultId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetImportHistoryGet = function (options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetImportHistoryGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} sessionId
     * @param {number} page
     * @param {number} pageLength
     * @param {boolean} [processed]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetImportVaultsBySessionIdSessionIdGet = function (sessionId, page, pageLength, processed, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetImportVaultsBySessionIdSessionIdGet(sessionId, page, pageLength, processed, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetPoliciesByVaultIdVaultIdGet = function (vaultId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetPoliciesByVaultIdVaultIdGet(vaultId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultBackupByIdVaultIdGet = function (vaultId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultBackupByIdVaultIdGet(vaultId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultCreditCardByIdVaultIdGet = function (vaultId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultCreditCardByIdVaultIdGet(vaultId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultCreditCardByVaultIdAndGroupIdVaultIdGroupIdGet = function (vaultId, groupId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultCreditCardByVaultIdAndGroupIdVaultIdGroupIdGet(vaultId, groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [updatedAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultCreditCardsForCurrentUserGet = function (updatedAfter, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultCreditCardsForCurrentUserGet(updatedAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [updatedAfter]
     * @param {string} [groupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultCreditCardsForGroupGet = function (updatedAfter, groupId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultCreditCardsForGroupGet(updatedAfter, groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [updatedAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultCreditCardsSecureDataForCurrentUserGet = function (updatedAfter, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultCreditCardsSecureDataForCurrentUserGet(updatedAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [updatedAfter]
     * @param {string} [groupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultCreditCardsSecureDataForGroupGet = function (updatedAfter, groupId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultCreditCardsSecureDataForGroupGet(updatedAfter, groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultPasswordByIdVaultIdGet = function (vaultId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultPasswordByIdVaultIdGet(vaultId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultPasswordByVaultIdAndGroupIdVaultIdGroupIdGet = function (vaultId, groupId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultPasswordByVaultIdAndGroupIdVaultIdGroupIdGet(vaultId, groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [updatedAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultPasswordsForCurrentUserGet = function (updatedAfter, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultPasswordsForCurrentUserGet(updatedAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [updatedAfter]
     * @param {string} [groupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultPasswordsForGroupGet = function (updatedAfter, groupId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultPasswordsForGroupGet(updatedAfter, groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [updatedAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultPasswordsSecureDataForCurrentUserGet = function (updatedAfter, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultPasswordsSecureDataForCurrentUserGet(updatedAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [updatedAfter]
     * @param {string} [groupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultPasswordsSecureDataForGroupGet = function (updatedAfter, groupId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultPasswordsSecureDataForGroupGet(updatedAfter, groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultSecureNoteByIdVaultIdGet = function (vaultId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultSecureNoteByIdVaultIdGet(vaultId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultSecureNoteByVaultIdAndGroupIdVaultIdGroupIdGet = function (vaultId, groupId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultSecureNoteByVaultIdAndGroupIdVaultIdGroupIdGet(vaultId, groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [updatedAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultSecureNotesForCurrentUserGet = function (updatedAfter, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultSecureNotesForCurrentUserGet(updatedAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [updatedAfter]
     * @param {string} [groupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultSecureNotesForGroupsGet = function (updatedAfter, groupId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultSecureNotesForGroupsGet(updatedAfter, groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [updatedAfter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultSecureNotesSecureDataForCurrentUserGet = function (updatedAfter, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultSecureNotesSecureDataForCurrentUserGet(updatedAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [updatedAfter]
     * @param {string} [groupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultSecureNotesSecureDataForGroupsGet = function (updatedAfter, groupId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultSecureNotesSecureDataForGroupsGet(updatedAfter, groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultSharingInfoVaultIdGet = function (vaultId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultSharingInfoVaultIdGet(vaultId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [searchString]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultsSharedFromOtherUsersGet = function (searchString, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultsSharedFromOtherUsersGet(searchString, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [searchString]
     * @param {Array<string>} [vaultsFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultsSharedToOtherUsersGet = function (searchString, vaultsFilter, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultsSharedToOtherUsersGet(searchString, vaultsFilter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ImportVaultCreatePasswordRequest} [importVaultCreatePasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsImportVaultCreatePasswordPost = function (importVaultCreatePasswordRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsImportVaultCreatePasswordPost(importVaultCreatePasswordRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {MarkImportVaultsFailedRequest} [markImportVaultsFailedRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsMarkImportVaultsFailedPut = function (markImportVaultsFailedRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsMarkImportVaultsFailedPut(markImportVaultsFailedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {MarkImportVaultsProcessedRequest} [markImportVaultsProcessedRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsMarkImportVaultsProcessedPut = function (markImportVaultsProcessedRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsMarkImportVaultsProcessedPut(markImportVaultsProcessedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {MoveVaultToGroupRequest} [moveVaultToGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsMoveVaultToGroupPost = function (moveVaultToGroupRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsMoveVaultToGroupPost(moveVaultToGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {MoveVaultToOrganizationGroupRequest} [moveVaultToOrganizationGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsMoveVaultToOrganizationGroupPost = function (moveVaultToOrganizationGroupRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsMoveVaultToOrganizationGroupPost(moveVaultToOrganizationGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {MoveVaultToOrganizationRequest} [moveVaultToOrganizationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsMoveVaultToOrganizationPost = function (moveVaultToOrganizationRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsMoveVaultToOrganizationPost(moveVaultToOrganizationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {Array<Operation>} [operation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsPatchVaultCreditCardVaultIdPatch = function (vaultId, operation, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsPatchVaultCreditCardVaultIdPatch(vaultId, operation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {Array<Operation>} [operation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsPatchVaultPasswordVaultIdPatch = function (vaultId, operation, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsPatchVaultPasswordVaultIdPatch(vaultId, operation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {Array<Operation>} [operation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsPatchVaultSecureNoteVaultIdPatch = function (vaultId, operation, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsPatchVaultSecureNoteVaultIdPatch(vaultId, operation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return VaultsApi;
}(base_1.BaseAPI));
exports.VaultsApi = VaultsApi;
/**
 * VaultsToEmployeeAccountsApi - axios parameter creator
 * @export
 */
var VaultsToEmployeeAccountsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {AddVaultToEmployeeAccountRequest} [addVaultToEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsAddPost: function (addVaultToEmployeeAccountRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([addVaultToEmployeeAccountRequest_1], args_1, true), void 0, function (addVaultToEmployeeAccountRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToEmployeeAccounts/Add";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addVaultToEmployeeAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultCreditCardForEmployeeRequest} [createVaultCreditCardForEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost: function (createVaultCreditCardForEmployeeRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultCreditCardForEmployeeRequest_1], args_1, true), void 0, function (createVaultCreditCardForEmployeeRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToEmployeeAccounts/CreateVaultCreditCard";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultCreditCardForEmployeeRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultPasswordForEmployeeRequest} [createVaultPasswordForEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost: function (createVaultPasswordForEmployeeRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultPasswordForEmployeeRequest_1], args_1, true), void 0, function (createVaultPasswordForEmployeeRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToEmployeeAccounts/CreateVaultPassword";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultPasswordForEmployeeRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultSecureNoteForEmployeeRequest} [createVaultSecureNoteForEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost: function (createVaultSecureNoteForEmployeeRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultSecureNoteForEmployeeRequest_1], args_1, true), void 0, function (createVaultSecureNoteForEmployeeRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToEmployeeAccounts/CreateVaultSecureNote";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultSecureNoteForEmployeeRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteVaultToEmployeeAccountRequest} [deleteVaultToEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsDelete: function (deleteVaultToEmployeeAccountRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteVaultToEmployeeAccountRequest_1], args_1, true), void 0, function (deleteVaultToEmployeeAccountRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToEmployeeAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteVaultToEmployeeAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RevokeSharedVaultRequest} [revokeSharedVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsRevokeSharedVaultDelete: function (revokeSharedVaultRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([revokeSharedVaultRequest_1], args_1, true), void 0, function (revokeSharedVaultRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToEmployeeAccounts/RevokeSharedVault";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(revokeSharedVaultRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RevokeVaultSharingRequest} [revokeVaultSharingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsRevokeVaultSharingDelete: function (revokeVaultSharingRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([revokeVaultSharingRequest_1], args_1, true), void 0, function (revokeVaultSharingRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToEmployeeAccounts/RevokeVaultSharing";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(revokeVaultSharingRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.VaultsToEmployeeAccountsApiAxiosParamCreator = VaultsToEmployeeAccountsApiAxiosParamCreator;
/**
 * VaultsToEmployeeAccountsApi - functional programming interface
 * @export
 */
var VaultsToEmployeeAccountsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VaultsToEmployeeAccountsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {AddVaultToEmployeeAccountRequest} [addVaultToEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsAddPost: function (addVaultToEmployeeAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToEmployeeAccountsAddPost(addVaultToEmployeeAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultCreditCardForEmployeeRequest} [createVaultCreditCardForEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost: function (createVaultCreditCardForEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost(createVaultCreditCardForEmployeeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultPasswordForEmployeeRequest} [createVaultPasswordForEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost: function (createVaultPasswordForEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost(createVaultPasswordForEmployeeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultSecureNoteForEmployeeRequest} [createVaultSecureNoteForEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost: function (createVaultSecureNoteForEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost(createVaultSecureNoteForEmployeeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteVaultToEmployeeAccountRequest} [deleteVaultToEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsDelete: function (deleteVaultToEmployeeAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToEmployeeAccountsDelete(deleteVaultToEmployeeAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RevokeSharedVaultRequest} [revokeSharedVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsRevokeSharedVaultDelete: function (revokeSharedVaultRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToEmployeeAccountsRevokeSharedVaultDelete(revokeSharedVaultRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RevokeVaultSharingRequest} [revokeVaultSharingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsRevokeVaultSharingDelete: function (revokeVaultSharingRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToEmployeeAccountsRevokeVaultSharingDelete(revokeVaultSharingRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VaultsToEmployeeAccountsApiFp = VaultsToEmployeeAccountsApiFp;
/**
 * VaultsToEmployeeAccountsApi - factory interface
 * @export
 */
var VaultsToEmployeeAccountsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VaultsToEmployeeAccountsApiFp)(configuration);
    return {
        /**
         *
         * @param {AddVaultToEmployeeAccountRequest} [addVaultToEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsAddPost: function (addVaultToEmployeeAccountRequest, options) {
            return localVarFp.apiV1VaultsToEmployeeAccountsAddPost(addVaultToEmployeeAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultCreditCardForEmployeeRequest} [createVaultCreditCardForEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost: function (createVaultCreditCardForEmployeeRequest, options) {
            return localVarFp.apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost(createVaultCreditCardForEmployeeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultPasswordForEmployeeRequest} [createVaultPasswordForEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost: function (createVaultPasswordForEmployeeRequest, options) {
            return localVarFp.apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost(createVaultPasswordForEmployeeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultSecureNoteForEmployeeRequest} [createVaultSecureNoteForEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost: function (createVaultSecureNoteForEmployeeRequest, options) {
            return localVarFp.apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost(createVaultSecureNoteForEmployeeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DeleteVaultToEmployeeAccountRequest} [deleteVaultToEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsDelete: function (deleteVaultToEmployeeAccountRequest, options) {
            return localVarFp.apiV1VaultsToEmployeeAccountsDelete(deleteVaultToEmployeeAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RevokeSharedVaultRequest} [revokeSharedVaultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsRevokeSharedVaultDelete: function (revokeSharedVaultRequest, options) {
            return localVarFp.apiV1VaultsToEmployeeAccountsRevokeSharedVaultDelete(revokeSharedVaultRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RevokeVaultSharingRequest} [revokeVaultSharingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsRevokeVaultSharingDelete: function (revokeVaultSharingRequest, options) {
            return localVarFp.apiV1VaultsToEmployeeAccountsRevokeVaultSharingDelete(revokeVaultSharingRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VaultsToEmployeeAccountsApiFactory = VaultsToEmployeeAccountsApiFactory;
/**
 * VaultsToEmployeeAccountsApi - object-oriented interface
 * @export
 * @class VaultsToEmployeeAccountsApi
 * @extends {BaseAPI}
 */
var VaultsToEmployeeAccountsApi = /** @class */ (function (_super) {
    __extends(VaultsToEmployeeAccountsApi, _super);
    function VaultsToEmployeeAccountsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {AddVaultToEmployeeAccountRequest} [addVaultToEmployeeAccountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToEmployeeAccountsApi
     */
    VaultsToEmployeeAccountsApi.prototype.apiV1VaultsToEmployeeAccountsAddPost = function (addVaultToEmployeeAccountRequest, options) {
        var _this = this;
        return (0, exports.VaultsToEmployeeAccountsApiFp)(this.configuration).apiV1VaultsToEmployeeAccountsAddPost(addVaultToEmployeeAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultCreditCardForEmployeeRequest} [createVaultCreditCardForEmployeeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToEmployeeAccountsApi
     */
    VaultsToEmployeeAccountsApi.prototype.apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost = function (createVaultCreditCardForEmployeeRequest, options) {
        var _this = this;
        return (0, exports.VaultsToEmployeeAccountsApiFp)(this.configuration).apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost(createVaultCreditCardForEmployeeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultPasswordForEmployeeRequest} [createVaultPasswordForEmployeeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToEmployeeAccountsApi
     */
    VaultsToEmployeeAccountsApi.prototype.apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost = function (createVaultPasswordForEmployeeRequest, options) {
        var _this = this;
        return (0, exports.VaultsToEmployeeAccountsApiFp)(this.configuration).apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost(createVaultPasswordForEmployeeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultSecureNoteForEmployeeRequest} [createVaultSecureNoteForEmployeeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToEmployeeAccountsApi
     */
    VaultsToEmployeeAccountsApi.prototype.apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost = function (createVaultSecureNoteForEmployeeRequest, options) {
        var _this = this;
        return (0, exports.VaultsToEmployeeAccountsApiFp)(this.configuration).apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost(createVaultSecureNoteForEmployeeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DeleteVaultToEmployeeAccountRequest} [deleteVaultToEmployeeAccountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToEmployeeAccountsApi
     */
    VaultsToEmployeeAccountsApi.prototype.apiV1VaultsToEmployeeAccountsDelete = function (deleteVaultToEmployeeAccountRequest, options) {
        var _this = this;
        return (0, exports.VaultsToEmployeeAccountsApiFp)(this.configuration).apiV1VaultsToEmployeeAccountsDelete(deleteVaultToEmployeeAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RevokeSharedVaultRequest} [revokeSharedVaultRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToEmployeeAccountsApi
     */
    VaultsToEmployeeAccountsApi.prototype.apiV1VaultsToEmployeeAccountsRevokeSharedVaultDelete = function (revokeSharedVaultRequest, options) {
        var _this = this;
        return (0, exports.VaultsToEmployeeAccountsApiFp)(this.configuration).apiV1VaultsToEmployeeAccountsRevokeSharedVaultDelete(revokeSharedVaultRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RevokeVaultSharingRequest} [revokeVaultSharingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToEmployeeAccountsApi
     */
    VaultsToEmployeeAccountsApi.prototype.apiV1VaultsToEmployeeAccountsRevokeVaultSharingDelete = function (revokeVaultSharingRequest, options) {
        var _this = this;
        return (0, exports.VaultsToEmployeeAccountsApiFp)(this.configuration).apiV1VaultsToEmployeeAccountsRevokeVaultSharingDelete(revokeVaultSharingRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return VaultsToEmployeeAccountsApi;
}(base_1.BaseAPI));
exports.VaultsToEmployeeAccountsApi = VaultsToEmployeeAccountsApi;
/**
 * VaultsToGroupsApi - axios parameter creator
 * @export
 */
var VaultsToGroupsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {AddVaultToGroupRequest} [addVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsAddPost: function (addVaultToGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([addVaultToGroupRequest_1], args_1, true), void 0, function (addVaultToGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToGroups/Add";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addVaultToGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultCreditCardForGroupRequest} [createVaultCreditCardForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultCreditCardPost: function (createVaultCreditCardForGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultCreditCardForGroupRequest_1], args_1, true), void 0, function (createVaultCreditCardForGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToGroups/CreateVaultCreditCard";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultCreditCardForGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultPasswordForGroupRequest} [createVaultPasswordForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultPasswordPost: function (createVaultPasswordForGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultPasswordForGroupRequest_1], args_1, true), void 0, function (createVaultPasswordForGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToGroups/CreateVaultPassword";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultPasswordForGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultSecureNoteForGroupRequest} [createVaultSecureNoteForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultSecureNotePost: function (createVaultSecureNoteForGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultSecureNoteForGroupRequest_1], args_1, true), void 0, function (createVaultSecureNoteForGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToGroups/CreateVaultSecureNote";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultSecureNoteForGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteVaultToGroupRequest} [deleteVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsDelete: function (deleteVaultToGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteVaultToGroupRequest_1], args_1, true), void 0, function (deleteVaultToGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToGroups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteVaultToGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.VaultsToGroupsApiAxiosParamCreator = VaultsToGroupsApiAxiosParamCreator;
/**
 * VaultsToGroupsApi - functional programming interface
 * @export
 */
var VaultsToGroupsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VaultsToGroupsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {AddVaultToGroupRequest} [addVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsAddPost: function (addVaultToGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToGroupsAddPost(addVaultToGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultCreditCardForGroupRequest} [createVaultCreditCardForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultCreditCardPost: function (createVaultCreditCardForGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToGroupsCreateVaultCreditCardPost(createVaultCreditCardForGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultPasswordForGroupRequest} [createVaultPasswordForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultPasswordPost: function (createVaultPasswordForGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToGroupsCreateVaultPasswordPost(createVaultPasswordForGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultSecureNoteForGroupRequest} [createVaultSecureNoteForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultSecureNotePost: function (createVaultSecureNoteForGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToGroupsCreateVaultSecureNotePost(createVaultSecureNoteForGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteVaultToGroupRequest} [deleteVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsDelete: function (deleteVaultToGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToGroupsDelete(deleteVaultToGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VaultsToGroupsApiFp = VaultsToGroupsApiFp;
/**
 * VaultsToGroupsApi - factory interface
 * @export
 */
var VaultsToGroupsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VaultsToGroupsApiFp)(configuration);
    return {
        /**
         *
         * @param {AddVaultToGroupRequest} [addVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsAddPost: function (addVaultToGroupRequest, options) {
            return localVarFp.apiV1VaultsToGroupsAddPost(addVaultToGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultCreditCardForGroupRequest} [createVaultCreditCardForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultCreditCardPost: function (createVaultCreditCardForGroupRequest, options) {
            return localVarFp.apiV1VaultsToGroupsCreateVaultCreditCardPost(createVaultCreditCardForGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultPasswordForGroupRequest} [createVaultPasswordForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultPasswordPost: function (createVaultPasswordForGroupRequest, options) {
            return localVarFp.apiV1VaultsToGroupsCreateVaultPasswordPost(createVaultPasswordForGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultSecureNoteForGroupRequest} [createVaultSecureNoteForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultSecureNotePost: function (createVaultSecureNoteForGroupRequest, options) {
            return localVarFp.apiV1VaultsToGroupsCreateVaultSecureNotePost(createVaultSecureNoteForGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DeleteVaultToGroupRequest} [deleteVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsDelete: function (deleteVaultToGroupRequest, options) {
            return localVarFp.apiV1VaultsToGroupsDelete(deleteVaultToGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VaultsToGroupsApiFactory = VaultsToGroupsApiFactory;
/**
 * VaultsToGroupsApi - object-oriented interface
 * @export
 * @class VaultsToGroupsApi
 * @extends {BaseAPI}
 */
var VaultsToGroupsApi = /** @class */ (function (_super) {
    __extends(VaultsToGroupsApi, _super);
    function VaultsToGroupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {AddVaultToGroupRequest} [addVaultToGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToGroupsApi
     */
    VaultsToGroupsApi.prototype.apiV1VaultsToGroupsAddPost = function (addVaultToGroupRequest, options) {
        var _this = this;
        return (0, exports.VaultsToGroupsApiFp)(this.configuration).apiV1VaultsToGroupsAddPost(addVaultToGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultCreditCardForGroupRequest} [createVaultCreditCardForGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToGroupsApi
     */
    VaultsToGroupsApi.prototype.apiV1VaultsToGroupsCreateVaultCreditCardPost = function (createVaultCreditCardForGroupRequest, options) {
        var _this = this;
        return (0, exports.VaultsToGroupsApiFp)(this.configuration).apiV1VaultsToGroupsCreateVaultCreditCardPost(createVaultCreditCardForGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultPasswordForGroupRequest} [createVaultPasswordForGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToGroupsApi
     */
    VaultsToGroupsApi.prototype.apiV1VaultsToGroupsCreateVaultPasswordPost = function (createVaultPasswordForGroupRequest, options) {
        var _this = this;
        return (0, exports.VaultsToGroupsApiFp)(this.configuration).apiV1VaultsToGroupsCreateVaultPasswordPost(createVaultPasswordForGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultSecureNoteForGroupRequest} [createVaultSecureNoteForGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToGroupsApi
     */
    VaultsToGroupsApi.prototype.apiV1VaultsToGroupsCreateVaultSecureNotePost = function (createVaultSecureNoteForGroupRequest, options) {
        var _this = this;
        return (0, exports.VaultsToGroupsApiFp)(this.configuration).apiV1VaultsToGroupsCreateVaultSecureNotePost(createVaultSecureNoteForGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DeleteVaultToGroupRequest} [deleteVaultToGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToGroupsApi
     */
    VaultsToGroupsApi.prototype.apiV1VaultsToGroupsDelete = function (deleteVaultToGroupRequest, options) {
        var _this = this;
        return (0, exports.VaultsToGroupsApiFp)(this.configuration).apiV1VaultsToGroupsDelete(deleteVaultToGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return VaultsToGroupsApi;
}(base_1.BaseAPI));
exports.VaultsToGroupsApi = VaultsToGroupsApi;
